/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * Template API
 * Backend API for the template startup. Consumed by Orval to generate the SPA client.
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AbuseBlockPageResponse,
  AbuseBlockResponse,
  AcceptInviteRequest,
  ActivateInviteRequest,
  ActivateInviteResponse,
  ActivationRequestResponse,
  AddNoteRequest,
  AdjustGrantBody,
  AlternativeResponse,
  Alternatives1Params,
  AlternativesParams,
  AnalyticsComparisonResponse,
  AnalyticsTrendResponse,
  ApproveRequestBody,
  AssignmentResponse,
  AuditParams,
  AutoAssignPolicyRequest,
  AutocompleteParams,
  AutocompleteResponse,
  BillingProfileRequest,
  BillingProfileResponse,
  BlacklistEntryResponse,
  BookingCtaRequest,
  BookingDetailResponse,
  BookingPolicyRequest,
  BookingPolicyResponse,
  BookingSubmitResponse,
  BreakGlassRequest,
  BreakGlassResponse,
  BrevoBody,
  BusinessLinkResponse,
  CalendarDensityResponse,
  CalendarExceptionRequest,
  CalendarExceptionResponse,
  CalendarParams,
  Cancel3200,
  Cancel4200,
  CancelManageRequest,
  CapacityOnlyModeRequest,
  CapacityRequest,
  CapacityResponse,
  CaptureResultResponse,
  CaptureSessionResponse,
  CasReasonBody,
  ChangePlanRequest,
  Charge200,
  CheckoutRequest,
  CheckoutResponse,
  CloseQueueRequest,
  CloseQueueResponse,
  ComparisonParams,
  Complete200,
  CompleteSignupRequest,
  CompleteSignupResponse,
  Confirm1200,
  Confirm200,
  Confirm2200,
  ConfirmCaptureRequest,
  ConfirmLocationRequest,
  ConfirmMatchRequest,
  ConfirmResponse,
  ConnectCustomDomainRequest,
  ConnectResponse,
  ConnectionStatusResponse,
  ConversionPreviewRequest,
  ConversionPreviewResponse,
  CookieConsentRequest,
  CookieConsentResponse,
  CreateBlacklistRequest,
  CreateBookingRequest,
  CreateMediaUpload200,
  CreateMediaUploadRequest,
  CreateThreadRequest,
  CreateUploadRequest,
  CreateVenueRequest,
  CustomDomainResponse,
  Deactivate1Params,
  DeactivateResponse,
  DecideAppealRequest,
  DeclineRequestBody,
  DefaultModeRequest,
  DefaultModeResponse,
  DemoContextResponse,
  DemoResetResponse,
  DetailParams,
  DeviceSessionResponse,
  DpaAcceptanceResponse,
  DpaStatusResponse,
  DsrCompletionResponse,
  DsrInboxResponse,
  DsrIntakeRequest,
  DsrIntakeResponse,
  DsrVerifyRequest,
  DsrVerifyResponse,
  End200,
  EntitlementViewDto,
  EntitlementViewResponse,
  EstimateParams,
  EventsParams,
  ExtendBody,
  FirstBookingFunnelDto,
  FloorPlanResponse,
  GoLive200,
  GoogleBusinessOauthCallbackParams,
  GrantTrialRequest,
  GroupAvailabilityParams,
  GroupAvailabilityResponse,
  GuaranteeResponse,
  GuestPageResponse,
  GuestProfileResponse,
  HealthStatus,
  HoldResponse,
  ImpersonationSessionDto,
  ImpersonationStartRequest,
  Inbox1Params,
  Inbox2Params,
  InboxParams,
  InviteRequest,
  InviteResponse,
  List4Params,
  List5Params,
  List6Params,
  List7Params,
  List8Params,
  ListParams,
  ListTenantsParams,
  ListUsersParams,
  ListingAuthorizationResponse,
  ListingDecisionRequest,
  LiveFloorResponse,
  LiveSeatRequest,
  LiveTimelineRowResponse,
  LiveVersionRequest,
  ManageBookingResponse,
  ManagerRefundRequest,
  MapLocationRequest,
  MappedLocationResponse,
  MediaAssetResponse,
  MergeConflictResponse,
  MergeRequest,
  MergeResponse,
  Messages1Params,
  MessagesParams,
  Modify200,
  ModifyManageRequest,
  None200,
  NoneMatchRequest,
  NotificationSettingsResponse,
  NotificationStatusResponse,
  NotifyRequest,
  OffboardRequest,
  OffboardResponse,
  OfflineRequest,
  OnboardingProgressResponse,
  OpenDeviceSessionRequest,
  OpenSlots1Params,
  OpenSlotsParams,
  OpenSlotsResponse,
  OverrideRequest,
  OverrideResponse,
  PageDtoOperatorAuditEntryDto,
  PageDtoSupportMessageDto,
  PageDtoSupportThreadDto,
  PageDtoTenantSearchHitDto,
  PageResponseActivityLogEntryResponse,
  PageResponseStaffBookingSummaryResponse,
  PageResponseUserResponse,
  PageResponseVenueResponse,
  PartySizeRequest,
  PhoneSyncResponse,
  PlaceHoldRequest,
  PlaceMatchSearchResponse,
  PlaceMatchStatusResponse,
  PlaceVerificationResponse,
  PlanCatalogResponse,
  PortalSessionRequest,
  PortalSessionResponse,
  PresenceRequest,
  PresenceViewersResponse,
  PreviewResponse,
  ProblemDetail,
  ProposeNextParams,
  ProposeNextResponse,
  ProvisionDemoRequest,
  ProvisionDemoResponse,
  PublicAlternativeDto,
  PublicJoinRequest,
  PublicOpenSlotsResponse,
  PublicWaitlistJoinResponse,
  PutPolicy200,
  QuickFlagRequest,
  QuotaResponse,
  RecommendationResponse,
  ReconcileParams,
  ReconciliationResponse,
  RecordAppealRequest,
  Refund1200,
  RefundGuaranteeRequest,
  RefundResponse,
  RenameSlugRequest,
  RenewRequest,
  ReorderRequest,
  RequestTrialBody,
  ResolveConflictRequest,
  ReviewReplyRequest,
  ReviewsResponse,
  RiskAdviceResponse,
  RiskPolicyRequest,
  RiskPolicyResponse,
  RiskRebuildResponse,
  SaveFloorPlanRequest,
  SaveScheduleRequest,
  ScheduleResponse,
  Search1Params,
  SeatRequest,
  SeoIndexableRequest,
  ServiceRequest,
  ServiceResponse,
  SetIdCheckRequest,
  SetOptInRequest,
  SetOverrideBody,
  SetOverrideRequest,
  SignupRequest,
  SignupResponse,
  SiteDraftRequest,
  SiteResponse,
  SlugAvailabilityParams,
  SlugAvailabilityResponse,
  SnapshotParams,
  SnapshotSlotResponse,
  SseEmitter,
  StaffBookingResponse,
  StaffCancelBookingRequest,
  StaffCreateBookingRequest,
  StaffEditBookingRequest,
  StaffJoinRequest,
  StartCaptureRequest,
  StepUpRequest,
  StepUpResponse,
  SubscriptionResponse,
  SupportMessageRequest,
  SupportThreadDto,
  SuspendRequest,
  SwitchRequest,
  SwitchResponse,
  SyncResponse,
  TableReadyResponse,
  TenantHealthDto,
  TenantSearchHitDto,
  Threads1Params,
  ThreadsParams,
  TimelineParams,
  TrendsParams,
  TrialBannerResponse,
  TrialDto,
  TrialStartedResponse,
  TrialViewDto,
  UpdateNotificationSettingsRequest,
  UpdateProfileRequest,
  UpdateTagsRequest,
  UploadUrlResponse,
  VenueConfigResponse,
  VenueDetailResponse,
  VenueEntitlementsResponse,
  VenueLocationResponse,
  VenueProfileResponse,
  VenueResponse,
  VenueStateDto,
  VersionRequest,
  ViewersParams,
  WaitEstimateResponse,
  WaitlistEntryResponse,
  WaitlistListResponse,
  WaitlistStatusCancelRequest,
  WaitlistStatusResponse,
  WalkInRequest,
  WithdrawRequestBody,
  WithdrawResponse
} from './model';

import { customInstance } from '../mutator';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getSetOfflineUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/site/offline`
}

/**
 * @summary Toggle the site offline/online; emits SiteTakenOffline/SiteBackOnline (R5)
 */
export const setOffline = async (venueId: string,
    offlineRequest: OfflineRequest, options?: RequestInit): Promise<SiteResponse> => {

  return customInstance<SiteResponse>(getSetOfflineUrl(venueId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(offlineRequest)
  }
);}




export const getSetOfflineMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOffline>>, TError,{venueId: string;data: OfflineRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setOffline>>, TError,{venueId: string;data: OfflineRequest}, TContext> => {

const mutationKey = ['setOffline'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setOffline>>, {venueId: string;data: OfflineRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  setOffline(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetOfflineMutationResult = NonNullable<Awaited<ReturnType<typeof setOffline>>>
    export type SetOfflineMutationBody = OfflineRequest
    export type SetOfflineMutationError = ProblemDetail

    /**
 * @summary Toggle the site offline/online; emits SiteTakenOffline/SiteBackOnline (R5)
 */
export const useSetOffline = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOffline>>, TError,{venueId: string;data: OfflineRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setOffline>>,
        TError,
        {venueId: string;data: OfflineRequest},
        TContext
      > => {
      return useMutation(getSetOfflineMutationOptions(options), queryClient);
    }

export const getSetBookingCtaUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/site/booking-cta`
}

/**
 * @summary Set the booking-CTA switch (Enabled | DisabledIndefinitely | PausedUntil); emits R2 event
 */
export const setBookingCta = async (venueId: string,
    bookingCtaRequest: BookingCtaRequest, options?: RequestInit): Promise<SiteResponse> => {

  return customInstance<SiteResponse>(getSetBookingCtaUrl(venueId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bookingCtaRequest)
  }
);}




export const getSetBookingCtaMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setBookingCta>>, TError,{venueId: string;data: BookingCtaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setBookingCta>>, TError,{venueId: string;data: BookingCtaRequest}, TContext> => {

const mutationKey = ['setBookingCta'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setBookingCta>>, {venueId: string;data: BookingCtaRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  setBookingCta(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetBookingCtaMutationResult = NonNullable<Awaited<ReturnType<typeof setBookingCta>>>
    export type SetBookingCtaMutationBody = BookingCtaRequest
    export type SetBookingCtaMutationError = ProblemDetail

    /**
 * @summary Set the booking-CTA switch (Enabled | DisabledIndefinitely | PausedUntil); emits R2 event
 */
export const useSetBookingCta = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setBookingCta>>, TError,{venueId: string;data: BookingCtaRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setBookingCta>>,
        TError,
        {venueId: string;data: BookingCtaRequest},
        TContext
      > => {
      return useMutation(getSetBookingCtaMutationOptions(options), queryClient);
    }

export const getGetScheduleUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/schedule`
}

/**
 * @summary The venue's whole weekly schedule (all windows + version)
 */
export const getSchedule = async (venueId: string, options?: RequestInit): Promise<ScheduleResponse> => {

  return customInstance<ScheduleResponse>(getGetScheduleUrl(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetScheduleQueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/schedule`
    ] as const;
    }


export const getGetScheduleQueryOptions = <TData = Awaited<ReturnType<typeof getSchedule>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScheduleQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchedule>>> = ({ signal }) => getSchedule(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof getSchedule>>>
export type GetScheduleQueryError = ProblemDetail


export function useGetSchedule<TData = Awaited<ReturnType<typeof getSchedule>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchedule>>,
          TError,
          Awaited<ReturnType<typeof getSchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchedule<TData = Awaited<ReturnType<typeof getSchedule>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchedule>>,
          TError,
          Awaited<ReturnType<typeof getSchedule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchedule<TData = Awaited<ReturnType<typeof getSchedule>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The venue's whole weekly schedule (all windows + version)
 */

export function useGetSchedule<TData = Awaited<ReturnType<typeof getSchedule>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetScheduleQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getPutScheduleUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/schedule`
}

/**
 * @summary Replace the whole week — typed rejections (overlap/R2) as 422; stale CAS as 409
 */
export const putSchedule = async (venueId: string,
    saveScheduleRequest: SaveScheduleRequest, options?: RequestInit): Promise<ScheduleResponse> => {

  return customInstance<ScheduleResponse>(getPutScheduleUrl(venueId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(saveScheduleRequest)
  }
);}




export const getPutScheduleMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSchedule>>, TError,{venueId: string;data: SaveScheduleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putSchedule>>, TError,{venueId: string;data: SaveScheduleRequest}, TContext> => {

const mutationKey = ['putSchedule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSchedule>>, {venueId: string;data: SaveScheduleRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  putSchedule(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof putSchedule>>>
    export type PutScheduleMutationBody = SaveScheduleRequest
    export type PutScheduleMutationError = ProblemDetail

    /**
 * @summary Replace the whole week — typed rejections (overlap/R2) as 422; stale CAS as 409
 */
export const usePutSchedule = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSchedule>>, TError,{venueId: string;data: SaveScheduleRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putSchedule>>,
        TError,
        {venueId: string;data: SaveScheduleRequest},
        TContext
      > => {
      return useMutation(getPutScheduleMutationOptions(options), queryClient);
    }

export const getGetPolicyUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/risk-policy`
}

/**
 * @summary The venue's no-show risk policy (level → soft action)
 */
export const getPolicy = async (venueId: string, options?: RequestInit): Promise<RiskPolicyResponse> => {

  return customInstance<RiskPolicyResponse>(getGetPolicyUrl(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPolicyQueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/risk-policy`
    ] as const;
    }


export const getGetPolicyQueryOptions = <TData = Awaited<ReturnType<typeof getPolicy>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPolicy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPolicyQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPolicy>>> = ({ signal }) => getPolicy(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPolicy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPolicyQueryResult = NonNullable<Awaited<ReturnType<typeof getPolicy>>>
export type GetPolicyQueryError = ProblemDetail


export function useGetPolicy<TData = Awaited<ReturnType<typeof getPolicy>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPolicy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPolicy>>,
          TError,
          Awaited<ReturnType<typeof getPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPolicy<TData = Awaited<ReturnType<typeof getPolicy>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPolicy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPolicy>>,
          TError,
          Awaited<ReturnType<typeof getPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPolicy<TData = Awaited<ReturnType<typeof getPolicy>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPolicy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The venue's no-show risk policy (level → soft action)
 */

export function useGetPolicy<TData = Awaited<ReturnType<typeof getPolicy>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPolicy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPolicyQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getPutPolicyUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/risk-policy`
}

/**
 * @summary Save the risk policy — waiter 403 (R4); PROMPT_GUARANTEE off-capability 400; stale CAS 409
 */
export const putPolicy = async (venueId: string,
    riskPolicyRequest: RiskPolicyRequest, options?: RequestInit): Promise<PutPolicy200> => {

  return customInstance<PutPolicy200>(getPutPolicyUrl(venueId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(riskPolicyRequest)
  }
);}




export const getPutPolicyMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPolicy>>, TError,{venueId: string;data: RiskPolicyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putPolicy>>, TError,{venueId: string;data: RiskPolicyRequest}, TContext> => {

const mutationKey = ['putPolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPolicy>>, {venueId: string;data: RiskPolicyRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  putPolicy(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof putPolicy>>>
    export type PutPolicyMutationBody = RiskPolicyRequest
    export type PutPolicyMutationError = ProblemDetail

    /**
 * @summary Save the risk policy — waiter 403 (R4); PROMPT_GUARANTEE off-capability 400; stale CAS 409
 */
export const usePutPolicy = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPolicy>>, TError,{venueId: string;data: RiskPolicyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPolicy>>,
        TError,
        {venueId: string;data: RiskPolicyRequest},
        TContext
      > => {
      return useMutation(getPutPolicyMutationOptions(options), queryClient);
    }

export const getGetUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/notification-settings`
}

/**
 * @summary The venue's notification settings (or platform defaults)
 */
export const get = async (venueId: string, options?: RequestInit): Promise<NotificationSettingsResponse> => {

  return customInstance<NotificationSettingsResponse>(getGetUrl(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetQueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/notification-settings`
    ] as const;
    }


export const getGetQueryOptions = <TData = Awaited<ReturnType<typeof get>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get>>> = ({ signal }) => get(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQueryResult = NonNullable<Awaited<ReturnType<typeof get>>>
export type GetQueryError = ProblemDetail


export function useGet<TData = Awaited<ReturnType<typeof get>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get>>,
          TError,
          Awaited<ReturnType<typeof get>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet<TData = Awaited<ReturnType<typeof get>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get>>,
          TError,
          Awaited<ReturnType<typeof get>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet<TData = Awaited<ReturnType<typeof get>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The venue's notification settings (or platform defaults)
 */

export function useGet<TData = Awaited<ReturnType<typeof get>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/notification-settings`
}

/**
 * @summary Update notification settings; disabling a core type is a 422 (NO-3)
 */
export const update = async (venueId: string,
    updateNotificationSettingsRequest: UpdateNotificationSettingsRequest, options?: RequestInit): Promise<NotificationSettingsResponse> => {

  return customInstance<NotificationSettingsResponse>(getUpdateUrl(venueId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateNotificationSettingsRequest)
  }
);}




export const getUpdateMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof update>>, TError,{venueId: string;data: UpdateNotificationSettingsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof update>>, TError,{venueId: string;data: UpdateNotificationSettingsRequest}, TContext> => {

const mutationKey = ['update'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof update>>, {venueId: string;data: UpdateNotificationSettingsRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  update(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMutationResult = NonNullable<Awaited<ReturnType<typeof update>>>
    export type UpdateMutationBody = UpdateNotificationSettingsRequest
    export type UpdateMutationError = ProblemDetail

    /**
 * @summary Update notification settings; disabling a core type is a 422 (NO-3)
 */
export const useUpdate = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof update>>, TError,{venueId: string;data: UpdateNotificationSettingsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof update>>,
        TError,
        {venueId: string;data: UpdateNotificationSettingsRequest},
        TContext
      > => {
      return useMutation(getUpdateMutationOptions(options), queryClient);
    }

export const getUpdateTagsUrl = (venueId: string,
    guestId: string,) => {




  return `/api/v1/venues/${venueId}/guests/${guestId}/tags`
}

/**
 * @summary Set free-text tags (CRM_NOTES_TAGS-gated); CAS 409 + current on stale
 */
export const updateTags = async (venueId: string,
    guestId: string,
    updateTagsRequest: UpdateTagsRequest, options?: RequestInit): Promise<GuestProfileResponse> => {

  return customInstance<GuestProfileResponse>(getUpdateTagsUrl(venueId,guestId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateTagsRequest)
  }
);}




export const getUpdateTagsMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTags>>, TError,{venueId: string;guestId: string;data: UpdateTagsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTags>>, TError,{venueId: string;guestId: string;data: UpdateTagsRequest}, TContext> => {

const mutationKey = ['updateTags'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTags>>, {venueId: string;guestId: string;data: UpdateTagsRequest}> = (props) => {
          const {venueId,guestId,data} = props ?? {};

          return  updateTags(venueId,guestId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTagsMutationResult = NonNullable<Awaited<ReturnType<typeof updateTags>>>
    export type UpdateTagsMutationBody = UpdateTagsRequest
    export type UpdateTagsMutationError = ProblemDetail

    /**
 * @summary Set free-text tags (CRM_NOTES_TAGS-gated); CAS 409 + current on stale
 */
export const useUpdateTags = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTags>>, TError,{venueId: string;guestId: string;data: UpdateTagsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTags>>,
        TError,
        {venueId: string;guestId: string;data: UpdateTagsRequest},
        TContext
      > => {
      return useMutation(getUpdateTagsMutationOptions(options), queryClient);
    }

export const getSetIdCheckUrl = (venueId: string,
    guestId: string,) => {




  return `/api/v1/venues/${venueId}/guests/${guestId}/id-check`
}

/**
 * @summary Toggle the ID/age-check flag (never gated — a safety flag); CAS 409 on stale
 */
export const setIdCheck = async (venueId: string,
    guestId: string,
    setIdCheckRequest: SetIdCheckRequest, options?: RequestInit): Promise<GuestProfileResponse> => {

  return customInstance<GuestProfileResponse>(getSetIdCheckUrl(venueId,guestId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setIdCheckRequest)
  }
);}




export const getSetIdCheckMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setIdCheck>>, TError,{venueId: string;guestId: string;data: SetIdCheckRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setIdCheck>>, TError,{venueId: string;guestId: string;data: SetIdCheckRequest}, TContext> => {

const mutationKey = ['setIdCheck'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setIdCheck>>, {venueId: string;guestId: string;data: SetIdCheckRequest}> = (props) => {
          const {venueId,guestId,data} = props ?? {};

          return  setIdCheck(venueId,guestId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetIdCheckMutationResult = NonNullable<Awaited<ReturnType<typeof setIdCheck>>>
    export type SetIdCheckMutationBody = SetIdCheckRequest
    export type SetIdCheckMutationError = ProblemDetail

    /**
 * @summary Toggle the ID/age-check flag (never gated — a safety flag); CAS 409 on stale
 */
export const useSetIdCheck = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setIdCheck>>, TError,{venueId: string;guestId: string;data: SetIdCheckRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setIdCheck>>,
        TError,
        {venueId: string;guestId: string;data: SetIdCheckRequest},
        TContext
      > => {
      return useMutation(getSetIdCheckMutationOptions(options), queryClient);
    }

export const getGetPlanUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/floor-plan`
}

/**
 * @summary The venue's floor plan (capacity-only pool or the table layout + version)
 */
export const getPlan = async (venueId: string, options?: RequestInit): Promise<FloorPlanResponse> => {

  return customInstance<FloorPlanResponse>(getGetPlanUrl(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPlanQueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/floor-plan`
    ] as const;
    }


export const getGetPlanQueryOptions = <TData = Awaited<ReturnType<typeof getPlan>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlanQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlan>>> = ({ signal }) => getPlan(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlanQueryResult = NonNullable<Awaited<ReturnType<typeof getPlan>>>
export type GetPlanQueryError = ProblemDetail


export function useGetPlan<TData = Awaited<ReturnType<typeof getPlan>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlan>>,
          TError,
          Awaited<ReturnType<typeof getPlan>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlan<TData = Awaited<ReturnType<typeof getPlan>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlan>>,
          TError,
          Awaited<ReturnType<typeof getPlan>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlan<TData = Awaited<ReturnType<typeof getPlan>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The venue's floor plan (capacity-only pool or the table layout + version)
 */

export function useGetPlan<TData = Awaited<ReturnType<typeof getPlan>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlan>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlanQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getPutPlanUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/floor-plan`
}

/**
 * @summary Replace the whole floor-plan layout (FLOOR_PLAN mode) — 409 stale, 422 typed rejection
 */
export const putPlan = async (venueId: string,
    saveFloorPlanRequest: SaveFloorPlanRequest, options?: RequestInit): Promise<FloorPlanResponse> => {

  return customInstance<FloorPlanResponse>(getPutPlanUrl(venueId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(saveFloorPlanRequest)
  }
);}




export const getPutPlanMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPlan>>, TError,{venueId: string;data: SaveFloorPlanRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putPlan>>, TError,{venueId: string;data: SaveFloorPlanRequest}, TContext> => {

const mutationKey = ['putPlan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPlan>>, {venueId: string;data: SaveFloorPlanRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  putPlan(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutPlanMutationResult = NonNullable<Awaited<ReturnType<typeof putPlan>>>
    export type PutPlanMutationBody = SaveFloorPlanRequest
    export type PutPlanMutationError = ProblemDetail

    /**
 * @summary Replace the whole floor-plan layout (FLOOR_PLAN mode) — 409 stale, 422 typed rejection
 */
export const usePutPlan = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPlan>>, TError,{venueId: string;data: SaveFloorPlanRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPlan>>,
        TError,
        {venueId: string;data: SaveFloorPlanRequest},
        TContext
      > => {
      return useMutation(getPutPlanMutationOptions(options), queryClient);
    }

export const getSwitchToCapacityOnlyUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/floor-plan/mode/capacity-only`
}

/**
 * @summary Switch the venue back to a CAPACITY_ONLY pool (the reverse FL-7 mode switch)
 */
export const switchToCapacityOnly = async (venueId: string,
    capacityOnlyModeRequest: CapacityOnlyModeRequest, options?: RequestInit): Promise<FloorPlanResponse> => {

  return customInstance<FloorPlanResponse>(getSwitchToCapacityOnlyUrl(venueId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(capacityOnlyModeRequest)
  }
);}




export const getSwitchToCapacityOnlyMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchToCapacityOnly>>, TError,{venueId: string;data: CapacityOnlyModeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof switchToCapacityOnly>>, TError,{venueId: string;data: CapacityOnlyModeRequest}, TContext> => {

const mutationKey = ['switchToCapacityOnly'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof switchToCapacityOnly>>, {venueId: string;data: CapacityOnlyModeRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  switchToCapacityOnly(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SwitchToCapacityOnlyMutationResult = NonNullable<Awaited<ReturnType<typeof switchToCapacityOnly>>>
    export type SwitchToCapacityOnlyMutationBody = CapacityOnlyModeRequest
    export type SwitchToCapacityOnlyMutationError = ProblemDetail

    /**
 * @summary Switch the venue back to a CAPACITY_ONLY pool (the reverse FL-7 mode switch)
 */
export const useSwitchToCapacityOnly = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchToCapacityOnly>>, TError,{venueId: string;data: CapacityOnlyModeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof switchToCapacityOnly>>,
        TError,
        {venueId: string;data: CapacityOnlyModeRequest},
        TContext
      > => {
      return useMutation(getSwitchToCapacityOnlyMutationOptions(options), queryClient);
    }

export const getPutPolicy1Url = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/floor-plan/auto-assign-policy`
}

/**
 * @summary Replace the auto-assign policy (oversize cap / zone spread)
 */
export const putPolicy1 = async (venueId: string,
    autoAssignPolicyRequest: AutoAssignPolicyRequest, options?: RequestInit): Promise<FloorPlanResponse> => {

  return customInstance<FloorPlanResponse>(getPutPolicy1Url(venueId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(autoAssignPolicyRequest)
  }
);}




export const getPutPolicy1MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPolicy1>>, TError,{venueId: string;data: AutoAssignPolicyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putPolicy1>>, TError,{venueId: string;data: AutoAssignPolicyRequest}, TContext> => {

const mutationKey = ['putPolicy1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPolicy1>>, {venueId: string;data: AutoAssignPolicyRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  putPolicy1(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutPolicy1MutationResult = NonNullable<Awaited<ReturnType<typeof putPolicy1>>>
    export type PutPolicy1MutationBody = AutoAssignPolicyRequest
    export type PutPolicy1MutationError = ProblemDetail

    /**
 * @summary Replace the auto-assign policy (oversize cap / zone spread)
 */
export const usePutPolicy1 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPolicy1>>, TError,{venueId: string;data: AutoAssignPolicyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPolicy1>>,
        TError,
        {venueId: string;data: AutoAssignPolicyRequest},
        TContext
      > => {
      return useMutation(getPutPolicy1MutationOptions(options), queryClient);
    }

export const getGet1Url = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/capacity`
}

/**
 * @summary Read the venue's capacity pool (null until the quick-start is set)
 */
export const get1 = async (venueId: string, options?: RequestInit): Promise<CapacityResponse> => {

  return customInstance<CapacityResponse>(getGet1Url(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGet1QueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/capacity`
    ] as const;
    }


export const getGet1QueryOptions = <TData = Awaited<ReturnType<typeof get1>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGet1QueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get1>>> = ({ signal }) => get1(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Get1QueryResult = NonNullable<Awaited<ReturnType<typeof get1>>>
export type Get1QueryError = ProblemDetail


export function useGet1<TData = Awaited<ReturnType<typeof get1>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get1>>,
          TError,
          Awaited<ReturnType<typeof get1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet1<TData = Awaited<ReturnType<typeof get1>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get1>>,
          TError,
          Awaited<ReturnType<typeof get1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet1<TData = Awaited<ReturnType<typeof get1>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read the venue's capacity pool (null until the quick-start is set)
 */

export function useGet1<TData = Awaited<ReturnType<typeof get1>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGet1QueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getPutUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/capacity`
}

/**
 * @summary Set/replace the CAPACITY_ONLY total-covers pool — marks CAPACITY done (FL-6 CAS)
 */
export const put = async (venueId: string,
    capacityRequest: CapacityRequest, options?: RequestInit): Promise<CapacityResponse> => {

  return customInstance<CapacityResponse>(getPutUrl(venueId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(capacityRequest)
  }
);}




export const getPutMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof put>>, TError,{venueId: string;data: CapacityRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof put>>, TError,{venueId: string;data: CapacityRequest}, TContext> => {

const mutationKey = ['put'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof put>>, {venueId: string;data: CapacityRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  put(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutMutationResult = NonNullable<Awaited<ReturnType<typeof put>>>
    export type PutMutationBody = CapacityRequest
    export type PutMutationError = ProblemDetail

    /**
 * @summary Set/replace the CAPACITY_ONLY total-covers pool — marks CAPACITY done (FL-6 CAS)
 */
export const usePut = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof put>>, TError,{venueId: string;data: CapacityRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof put>>,
        TError,
        {venueId: string;data: CapacityRequest},
        TContext
      > => {
      return useMutation(getPutMutationOptions(options), queryClient);
    }

export const getGetExceptionUrl = (venueId: string,
    date: string,) => {




  return `/api/v1/venues/${venueId}/calendar-exceptions/${date}`
}

/**
 * @summary The exception ruling a date, or 404
 */
export const getException = async (venueId: string,
    date: string, options?: RequestInit): Promise<CalendarExceptionResponse> => {

  return customInstance<CalendarExceptionResponse>(getGetExceptionUrl(venueId,date),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetExceptionQueryKey = (venueId: string,
    date: string,) => {
    return [
    `/api/v1/venues/${venueId}/calendar-exceptions/${date}`
    ] as const;
    }


export const getGetExceptionQueryOptions = <TData = Awaited<ReturnType<typeof getException>>, TError = ProblemDetail>(venueId: string,
    date: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getException>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExceptionQueryKey(venueId,date);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getException>>> = ({ signal }) => getException(venueId,date, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined && date !== null && date !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getException>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExceptionQueryResult = NonNullable<Awaited<ReturnType<typeof getException>>>
export type GetExceptionQueryError = ProblemDetail


export function useGetException<TData = Awaited<ReturnType<typeof getException>>, TError = ProblemDetail>(
 venueId: string,
    date: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getException>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getException>>,
          TError,
          Awaited<ReturnType<typeof getException>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetException<TData = Awaited<ReturnType<typeof getException>>, TError = ProblemDetail>(
 venueId: string,
    date: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getException>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getException>>,
          TError,
          Awaited<ReturnType<typeof getException>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetException<TData = Awaited<ReturnType<typeof getException>>, TError = ProblemDetail>(
 venueId: string,
    date: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getException>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The exception ruling a date, or 404
 */

export function useGetException<TData = Awaited<ReturnType<typeof getException>>, TError = ProblemDetail>(
 venueId: string,
    date: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getException>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExceptionQueryOptions(venueId,date,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getPutExceptionUrl = (venueId: string,
    date: string,) => {




  return `/api/v1/venues/${venueId}/calendar-exceptions/${date}`
}

/**
 * @summary Set a CLOSED/OVERRIDE ruling for a date (always wins over the weekly grid — R1)
 */
export const putException = async (venueId: string,
    date: string,
    calendarExceptionRequest: CalendarExceptionRequest, options?: RequestInit): Promise<CalendarExceptionResponse> => {

  return customInstance<CalendarExceptionResponse>(getPutExceptionUrl(venueId,date),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(calendarExceptionRequest)
  }
);}




export const getPutExceptionMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putException>>, TError,{venueId: string;date: string;data: CalendarExceptionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putException>>, TError,{venueId: string;date: string;data: CalendarExceptionRequest}, TContext> => {

const mutationKey = ['putException'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putException>>, {venueId: string;date: string;data: CalendarExceptionRequest}> = (props) => {
          const {venueId,date,data} = props ?? {};

          return  putException(venueId,date,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutExceptionMutationResult = NonNullable<Awaited<ReturnType<typeof putException>>>
    export type PutExceptionMutationBody = CalendarExceptionRequest
    export type PutExceptionMutationError = ProblemDetail

    /**
 * @summary Set a CLOSED/OVERRIDE ruling for a date (always wins over the weekly grid — R1)
 */
export const usePutException = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putException>>, TError,{venueId: string;date: string;data: CalendarExceptionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putException>>,
        TError,
        {venueId: string;date: string;data: CalendarExceptionRequest},
        TContext
      > => {
      return useMutation(getPutExceptionMutationOptions(options), queryClient);
    }

export const getDeleteExceptionUrl = (venueId: string,
    date: string,) => {




  return `/api/v1/venues/${venueId}/calendar-exceptions/${date}`
}

/**
 * @summary Clear a date's exception (reverts to the weekly grid)
 */
export const deleteException = async (venueId: string,
    date: string, options?: RequestInit): Promise<unknown> => {

  return customInstance<unknown>(getDeleteExceptionUrl(venueId,date),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteExceptionMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteException>>, TError,{venueId: string;date: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteException>>, TError,{venueId: string;date: string}, TContext> => {

const mutationKey = ['deleteException'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteException>>, {venueId: string;date: string}> = (props) => {
          const {venueId,date} = props ?? {};

          return  deleteException(venueId,date,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteExceptionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteException>>>

    export type DeleteExceptionMutationError = ProblemDetail

    /**
 * @summary Clear a date's exception (reverts to the weekly grid)
 */
export const useDeleteException = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteException>>, TError,{venueId: string;date: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteException>>,
        TError,
        {venueId: string;date: string},
        TContext
      > => {
      return useMutation(getDeleteExceptionMutationOptions(options), queryClient);
    }

export const getGetBusinessLinkUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/business-link`
}

/**
 * @summary The venue's Business Link read model: match + feed status, advertised URL, toggle, reason (R1)
 */
export const getBusinessLink = async (venueId: string, options?: RequestInit): Promise<BusinessLinkResponse> => {

  return customInstance<BusinessLinkResponse>(getGetBusinessLinkUrl(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBusinessLinkQueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/business-link`
    ] as const;
    }


export const getGetBusinessLinkQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessLink>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessLinkQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessLink>>> = ({ signal }) => getBusinessLink(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessLinkQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessLink>>>
export type GetBusinessLinkQueryError = ProblemDetail


export function useGetBusinessLink<TData = Awaited<ReturnType<typeof getBusinessLink>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessLink>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessLink>>,
          TError,
          Awaited<ReturnType<typeof getBusinessLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessLink<TData = Awaited<ReturnType<typeof getBusinessLink>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessLink>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessLink>>,
          TError,
          Awaited<ReturnType<typeof getBusinessLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessLink<TData = Awaited<ReturnType<typeof getBusinessLink>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The venue's Business Link read model: match + feed status, advertised URL, toggle, reason (R1)
 */

export function useGetBusinessLink<TData = Awaited<ReturnType<typeof getBusinessLink>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBusinessLinkQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSetOptInUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/business-link`
}

/**
 * @summary Flip the opt-in toggle (R3). CAS on version; a stale write returns 409 + the current record
 */
export const setOptIn = async (venueId: string,
    setOptInRequest: SetOptInRequest, options?: RequestInit): Promise<BusinessLinkResponse> => {

  return customInstance<BusinessLinkResponse>(getSetOptInUrl(venueId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setOptInRequest)
  }
);}




export const getSetOptInMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOptIn>>, TError,{venueId: string;data: SetOptInRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setOptIn>>, TError,{venueId: string;data: SetOptInRequest}, TContext> => {

const mutationKey = ['setOptIn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setOptIn>>, {venueId: string;data: SetOptInRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  setOptIn(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetOptInMutationResult = NonNullable<Awaited<ReturnType<typeof setOptIn>>>
    export type SetOptInMutationBody = SetOptInRequest
    export type SetOptInMutationError = ProblemDetail

    /**
 * @summary Flip the opt-in toggle (R3). CAS on version; a stale write returns 409 + the current record
 */
export const useSetOptIn = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOptIn>>, TError,{venueId: string;data: SetOptInRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setOptIn>>,
        TError,
        {venueId: string;data: SetOptInRequest},
        TContext
      > => {
      return useMutation(getSetOptInMutationOptions(options), queryClient);
    }

export const getGetPolicy1Url = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/booking-policy`
}

/**
 * @summary The venue booking policy (canonical cancellation cutoff, online-booking switch)
 */
export const getPolicy1 = async (venueId: string, options?: RequestInit): Promise<BookingPolicyResponse> => {

  return customInstance<BookingPolicyResponse>(getGetPolicy1Url(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPolicy1QueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/booking-policy`
    ] as const;
    }


export const getGetPolicy1QueryOptions = <TData = Awaited<ReturnType<typeof getPolicy1>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPolicy1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPolicy1QueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPolicy1>>> = ({ signal }) => getPolicy1(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPolicy1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPolicy1QueryResult = NonNullable<Awaited<ReturnType<typeof getPolicy1>>>
export type GetPolicy1QueryError = ProblemDetail


export function useGetPolicy1<TData = Awaited<ReturnType<typeof getPolicy1>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPolicy1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPolicy1>>,
          TError,
          Awaited<ReturnType<typeof getPolicy1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPolicy1<TData = Awaited<ReturnType<typeof getPolicy1>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPolicy1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPolicy1>>,
          TError,
          Awaited<ReturnType<typeof getPolicy1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPolicy1<TData = Awaited<ReturnType<typeof getPolicy1>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPolicy1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The venue booking policy (canonical cancellation cutoff, online-booking switch)
 */

export function useGetPolicy1<TData = Awaited<ReturnType<typeof getPolicy1>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPolicy1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPolicy1QueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getPutPolicy2Url = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/booking-policy`
}

/**
 * @summary Save the venue booking policy — 409 + current version on a stale CAS
 */
export const putPolicy2 = async (venueId: string,
    bookingPolicyRequest: BookingPolicyRequest, options?: RequestInit): Promise<BookingPolicyResponse> => {

  return customInstance<BookingPolicyResponse>(getPutPolicy2Url(venueId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bookingPolicyRequest)
  }
);}




export const getPutPolicy2MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPolicy2>>, TError,{venueId: string;data: BookingPolicyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putPolicy2>>, TError,{venueId: string;data: BookingPolicyRequest}, TContext> => {

const mutationKey = ['putPolicy2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPolicy2>>, {venueId: string;data: BookingPolicyRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  putPolicy2(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutPolicy2MutationResult = NonNullable<Awaited<ReturnType<typeof putPolicy2>>>
    export type PutPolicy2MutationBody = BookingPolicyRequest
    export type PutPolicy2MutationError = ProblemDetail

    /**
 * @summary Save the venue booking policy — 409 + current version on a stale CAS
 */
export const usePutPolicy2 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPolicy2>>, TError,{venueId: string;data: BookingPolicyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPolicy2>>,
        TError,
        {venueId: string;data: BookingPolicyRequest},
        TContext
      > => {
      return useMutation(getPutPolicy2MutationOptions(options), queryClient);
    }

export const getDefaultModeUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/blacklist/default-mode`
}

/**
 * @summary The venue default mode applied at entry creation (per-entry wins at check)
 */
export const defaultMode = async (venueId: string, options?: RequestInit): Promise<DefaultModeResponse> => {

  return customInstance<DefaultModeResponse>(getDefaultModeUrl(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDefaultModeQueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/blacklist/default-mode`
    ] as const;
    }


export const getDefaultModeQueryOptions = <TData = Awaited<ReturnType<typeof defaultMode>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof defaultMode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDefaultModeQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof defaultMode>>> = ({ signal }) => defaultMode(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof defaultMode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DefaultModeQueryResult = NonNullable<Awaited<ReturnType<typeof defaultMode>>>
export type DefaultModeQueryError = ProblemDetail


export function useDefaultMode<TData = Awaited<ReturnType<typeof defaultMode>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof defaultMode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof defaultMode>>,
          TError,
          Awaited<ReturnType<typeof defaultMode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDefaultMode<TData = Awaited<ReturnType<typeof defaultMode>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof defaultMode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof defaultMode>>,
          TError,
          Awaited<ReturnType<typeof defaultMode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDefaultMode<TData = Awaited<ReturnType<typeof defaultMode>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof defaultMode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The venue default mode applied at entry creation (per-entry wins at check)
 */

export function useDefaultMode<TData = Awaited<ReturnType<typeof defaultMode>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof defaultMode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDefaultModeQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSetDefaultModeUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/blacklist/default-mode`
}

/**
 * @summary Set the venue default mode (BLOCK | FLAG)
 */
export const setDefaultMode = async (venueId: string,
    defaultModeRequest: DefaultModeRequest, options?: RequestInit): Promise<DefaultModeResponse> => {

  return customInstance<DefaultModeResponse>(getSetDefaultModeUrl(venueId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(defaultModeRequest)
  }
);}




export const getSetDefaultModeMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultMode>>, TError,{venueId: string;data: DefaultModeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setDefaultMode>>, TError,{venueId: string;data: DefaultModeRequest}, TContext> => {

const mutationKey = ['setDefaultMode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDefaultMode>>, {venueId: string;data: DefaultModeRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  setDefaultMode(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetDefaultModeMutationResult = NonNullable<Awaited<ReturnType<typeof setDefaultMode>>>
    export type SetDefaultModeMutationBody = DefaultModeRequest
    export type SetDefaultModeMutationError = ProblemDetail

    /**
 * @summary Set the venue default mode (BLOCK | FLAG)
 */
export const useSetDefaultMode = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultMode>>, TError,{venueId: string;data: DefaultModeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setDefaultMode>>,
        TError,
        {venueId: string;data: DefaultModeRequest},
        TContext
      > => {
      return useMutation(getSetDefaultModeMutationOptions(options), queryClient);
    }

export const getViewersUrl = (params: ViewersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/realtime/presence?${stringifiedParams}` : `/api/v1/realtime/presence`
}

/**
 * @summary The live viewers of a record (ids only, no PII)
 */
export const viewers = async (params: ViewersParams, options?: RequestInit): Promise<PresenceViewersResponse> => {

  return customInstance<PresenceViewersResponse>(getViewersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getViewersQueryKey = (params?: ViewersParams,) => {
    return [
    `/api/v1/realtime/presence`, ...(params ? [params] : [])
    ] as const;
    }


export const getViewersQueryOptions = <TData = Awaited<ReturnType<typeof viewers>>, TError = ProblemDetail>(params: ViewersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getViewersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof viewers>>> = ({ signal }) => viewers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof viewers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ViewersQueryResult = NonNullable<Awaited<ReturnType<typeof viewers>>>
export type ViewersQueryError = ProblemDetail


export function useViewers<TData = Awaited<ReturnType<typeof viewers>>, TError = ProblemDetail>(
 params: ViewersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewers>>,
          TError,
          Awaited<ReturnType<typeof viewers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewers<TData = Awaited<ReturnType<typeof viewers>>, TError = ProblemDetail>(
 params: ViewersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof viewers>>,
          TError,
          Awaited<ReturnType<typeof viewers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useViewers<TData = Awaited<ReturnType<typeof viewers>>, TError = ProblemDetail>(
 params: ViewersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The live viewers of a record (ids only, no PII)
 */

export function useViewers<TData = Awaited<ReturnType<typeof viewers>>, TError = ProblemDetail>(
 params: ViewersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof viewers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getViewersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getHeartbeatUrl = () => {




  return `/api/v1/realtime/presence`
}

/**
 * @summary Record/refresh presence on a record (45s TTL heartbeat)
 */
export const heartbeat = async (presenceRequest: PresenceRequest, options?: RequestInit): Promise<void> => {

  return customInstance<void>(getHeartbeatUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(presenceRequest)
  }
);}




export const getHeartbeatMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof heartbeat>>, TError,{data: PresenceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof heartbeat>>, TError,{data: PresenceRequest}, TContext> => {

const mutationKey = ['heartbeat'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof heartbeat>>, {data: PresenceRequest}> = (props) => {
          const {data} = props ?? {};

          return  heartbeat(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HeartbeatMutationResult = NonNullable<Awaited<ReturnType<typeof heartbeat>>>
    export type HeartbeatMutationBody = PresenceRequest
    export type HeartbeatMutationError = ProblemDetail

    /**
 * @summary Record/refresh presence on a record (45s TTL heartbeat)
 */
export const useHeartbeat = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof heartbeat>>, TError,{data: PresenceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof heartbeat>>,
        TError,
        {data: PresenceRequest},
        TContext
      > => {
      return useMutation(getHeartbeatMutationOptions(options), queryClient);
    }

export const getLeaveUrl = () => {




  return `/api/v1/realtime/presence`
}

/**
 * @summary Drop presence on a record (clean tab close)
 */
export const leave = async (presenceRequest: PresenceRequest, options?: RequestInit): Promise<void> => {

  return customInstance<void>(getLeaveUrl(),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(presenceRequest)
  }
);}




export const getLeaveMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leave>>, TError,{data: PresenceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof leave>>, TError,{data: PresenceRequest}, TContext> => {

const mutationKey = ['leave'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof leave>>, {data: PresenceRequest}> = (props) => {
          const {data} = props ?? {};

          return  leave(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LeaveMutationResult = NonNullable<Awaited<ReturnType<typeof leave>>>
    export type LeaveMutationBody = PresenceRequest
    export type LeaveMutationError = ProblemDetail

    /**
 * @summary Drop presence on a record (clean tab close)
 */
export const useLeave = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leave>>, TError,{data: PresenceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof leave>>,
        TError,
        {data: PresenceRequest},
        TContext
      > => {
      return useMutation(getLeaveMutationOptions(options), queryClient);
    }

export const getProfileUrl = () => {




  return `/api/v1/billing/profile`
}

/**
 * @summary The account's billing identity (legal name, address, numéro de TVA) for invoices
 */
export const profile = async ( options?: RequestInit): Promise<BillingProfileResponse> => {

  return customInstance<BillingProfileResponse>(getProfileUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProfileQueryKey = () => {
    return [
    `/api/v1/billing/profile`
    ] as const;
    }


export const getProfileQueryOptions = <TData = Awaited<ReturnType<typeof profile>>, TError = ProblemDetail>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProfileQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof profile>>> = ({ signal }) => profile({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof profile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProfileQueryResult = NonNullable<Awaited<ReturnType<typeof profile>>>
export type ProfileQueryError = ProblemDetail


export function useProfile<TData = Awaited<ReturnType<typeof profile>>, TError = ProblemDetail>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof profile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof profile>>,
          TError,
          Awaited<ReturnType<typeof profile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProfile<TData = Awaited<ReturnType<typeof profile>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof profile>>,
          TError,
          Awaited<ReturnType<typeof profile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProfile<TData = Awaited<ReturnType<typeof profile>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The account's billing identity (legal name, address, numéro de TVA) for invoices
 */

export function useProfile<TData = Awaited<ReturnType<typeof profile>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProfileQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateProfileUrl = () => {




  return `/api/v1/billing/profile`
}

/**
 * @summary Upsert the account's billing identity (CAS on version). A stale write is a 409.
 */
export const updateProfile = async (billingProfileRequest: BillingProfileRequest, options?: RequestInit): Promise<BillingProfileResponse> => {

  return customInstance<BillingProfileResponse>(getUpdateProfileUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(billingProfileRequest)
  }
);}




export const getUpdateProfileMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{data: BillingProfileRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{data: BillingProfileRequest}, TContext> => {

const mutationKey = ['updateProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProfile>>, {data: BillingProfileRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateProfile>>>
    export type UpdateProfileMutationBody = BillingProfileRequest
    export type UpdateProfileMutationError = ProblemDetail

    /**
 * @summary Upsert the account's billing identity (CAS on version). A stale write is a 409.
 */
export const useUpdateProfile = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{data: BillingProfileRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProfile>>,
        TError,
        {data: BillingProfileRequest},
        TContext
      > => {
      return useMutation(getUpdateProfileMutationOptions(options), queryClient);
    }

export const getListUrl = (params?: ListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/venues?${stringifiedParams}` : `/api/v1/venues`
}

/**
 * @summary List the account's venues (cursor pagination, ADR-0022)
 */
export const list = async (params?: ListParams, options?: RequestInit): Promise<PageResponseVenueResponse> => {

  return customInstance<PageResponseVenueResponse>(getListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListQueryKey = (params?: ListParams,) => {
    return [
    `/api/v1/venues`, ...(params ? [params] : [])
    ] as const;
    }


export const getListQueryOptions = <TData = Awaited<ReturnType<typeof list>>, TError = ProblemDetail>(params?: ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof list>>> = ({ signal }) => list(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof list>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQueryResult = NonNullable<Awaited<ReturnType<typeof list>>>
export type ListQueryError = ProblemDetail


export function useList<TData = Awaited<ReturnType<typeof list>>, TError = ProblemDetail>(
 params: undefined |  ListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof list>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof list>>,
          TError,
          Awaited<ReturnType<typeof list>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useList<TData = Awaited<ReturnType<typeof list>>, TError = ProblemDetail>(
 params?: ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof list>>,
          TError,
          Awaited<ReturnType<typeof list>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useList<TData = Awaited<ReturnType<typeof list>>, TError = ProblemDetail>(
 params?: ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the account's venues (cursor pagination, ADR-0022)
 */

export function useList<TData = Awaited<ReturnType<typeof list>>, TError = ProblemDetail>(
 params?: ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateVenueUrl = () => {




  return `/api/v1/venues`
}

/**
 * @summary Create a venue — claims the slug first-writer-wins (R1/R2/EN-4)
 */
export const createVenue = async (createVenueRequest: CreateVenueRequest, options?: RequestInit): Promise<VenueResponse> => {

  return customInstance<VenueResponse>(getCreateVenueUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createVenueRequest)
  }
);}




export const getCreateVenueMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenue>>, TError,{data: CreateVenueRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createVenue>>, TError,{data: CreateVenueRequest}, TContext> => {

const mutationKey = ['createVenue'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVenue>>, {data: CreateVenueRequest}> = (props) => {
          const {data} = props ?? {};

          return  createVenue(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVenueMutationResult = NonNullable<Awaited<ReturnType<typeof createVenue>>>
    export type CreateVenueMutationBody = CreateVenueRequest
    export type CreateVenueMutationError = ProblemDetail

    /**
 * @summary Create a venue — claims the slug first-writer-wins (R1/R2/EN-4)
 */
export const useCreateVenue = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenue>>, TError,{data: CreateVenueRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createVenue>>,
        TError,
        {data: CreateVenueRequest},
        TContext
      > => {
      return useMutation(getCreateVenueMutationOptions(options), queryClient);
    }

export const getList1Url = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/waitlist/entries`
}

/**
 * @summary The single staff view: every OPEN entry across BOTH queues (R6). Readable even when the flag is off (WL-6).
 */
export const list1 = async (venueId: string, options?: RequestInit): Promise<WaitlistListResponse> => {

  return customInstance<WaitlistListResponse>(getList1Url(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getList1QueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/waitlist/entries`
    ] as const;
    }


export const getList1QueryOptions = <TData = Awaited<ReturnType<typeof list1>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getList1QueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof list1>>> = ({ signal }) => list1(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof list1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type List1QueryResult = NonNullable<Awaited<ReturnType<typeof list1>>>
export type List1QueryError = ProblemDetail


export function useList1<TData = Awaited<ReturnType<typeof list1>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof list1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof list1>>,
          TError,
          Awaited<ReturnType<typeof list1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useList1<TData = Awaited<ReturnType<typeof list1>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof list1>>,
          TError,
          Awaited<ReturnType<typeof list1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useList1<TData = Awaited<ReturnType<typeof list1>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The single staff view: every OPEN entry across BOTH queues (R6). Readable even when the flag is off (WL-6).
 */

export function useList1<TData = Awaited<ReturnType<typeof list1>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getList1QueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getAddUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/waitlist/entries`
}

/**
 * @summary Staff add to either queue (door quick form): raw phone → E.164, blacklist FLAG surfaced (GU-4).
 */
export const add = async (venueId: string,
    staffJoinRequest: StaffJoinRequest, options?: RequestInit): Promise<WaitlistEntryResponse> => {

  return customInstance<WaitlistEntryResponse>(getAddUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(staffJoinRequest)
  }
);}




export const getAddMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof add>>, TError,{venueId: string;data: StaffJoinRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof add>>, TError,{venueId: string;data: StaffJoinRequest}, TContext> => {

const mutationKey = ['add'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof add>>, {venueId: string;data: StaffJoinRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  add(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddMutationResult = NonNullable<Awaited<ReturnType<typeof add>>>
    export type AddMutationBody = StaffJoinRequest
    export type AddMutationError = ProblemDetail

    /**
 * @summary Staff add to either queue (door quick form): raw phone → E.164, blacklist FLAG surfaced (GU-4).
 */
export const useAdd = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof add>>, TError,{venueId: string;data: StaffJoinRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof add>>,
        TError,
        {venueId: string;data: StaffJoinRequest},
        TContext
      > => {
      return useMutation(getAddMutationOptions(options), queryClient);
    }

export const getSeatUrl = (venueId: string,
    id: string,) => {




  return `/api/v1/venues/${venueId}/waitlist/entries/${id}/seat`
}

/**
 * @summary Seat: claim via SlotClaimPort (channel WAITLIST) + WAITLIST booking SEATED + entry → SEATED, one tx.
 */
export const seat = async (venueId: string,
    id: string,
    seatRequest: SeatRequest, options?: RequestInit): Promise<WaitlistEntryResponse> => {

  return customInstance<WaitlistEntryResponse>(getSeatUrl(venueId,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(seatRequest)
  }
);}




export const getSeatMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof seat>>, TError,{venueId: string;id: string;data: SeatRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof seat>>, TError,{venueId: string;id: string;data: SeatRequest}, TContext> => {

const mutationKey = ['seat'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof seat>>, {venueId: string;id: string;data: SeatRequest}> = (props) => {
          const {venueId,id,data} = props ?? {};

          return  seat(venueId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SeatMutationResult = NonNullable<Awaited<ReturnType<typeof seat>>>
    export type SeatMutationBody = SeatRequest
    export type SeatMutationError = ProblemDetail

    /**
 * @summary Seat: claim via SlotClaimPort (channel WAITLIST) + WAITLIST booking SEATED + entry → SEATED, one tx.
 */
export const useSeat = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof seat>>, TError,{venueId: string;id: string;data: SeatRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof seat>>,
        TError,
        {venueId: string;id: string;data: SeatRequest},
        TContext
      > => {
      return useMutation(getSeatMutationOptions(options), queryClient);
    }

export const getReorderUrl = (venueId: string,
    id: string,) => {




  return `/api/v1/venues/${venueId}/waitlist/entries/${id}/reorder`
}

/**
 * @summary Reorder: rewrite ONLY this entry's rank (CAS). Fit does not reorder; positions stay stable otherwise.
 */
export const reorder = async (venueId: string,
    id: string,
    reorderRequest: ReorderRequest, options?: RequestInit): Promise<WaitlistEntryResponse> => {

  return customInstance<WaitlistEntryResponse>(getReorderUrl(venueId,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reorderRequest)
  }
);}




export const getReorderMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorder>>, TError,{venueId: string;id: string;data: ReorderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reorder>>, TError,{venueId: string;id: string;data: ReorderRequest}, TContext> => {

const mutationKey = ['reorder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorder>>, {venueId: string;id: string;data: ReorderRequest}> = (props) => {
          const {venueId,id,data} = props ?? {};

          return  reorder(venueId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReorderMutationResult = NonNullable<Awaited<ReturnType<typeof reorder>>>
    export type ReorderMutationBody = ReorderRequest
    export type ReorderMutationError = ProblemDetail

    /**
 * @summary Reorder: rewrite ONLY this entry's rank (CAS). Fit does not reorder; positions stay stable otherwise.
 */
export const useReorder = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorder>>, TError,{venueId: string;id: string;data: ReorderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reorder>>,
        TError,
        {venueId: string;id: string;data: ReorderRequest},
        TContext
      > => {
      return useMutation(getReorderMutationOptions(options), queryClient);
    }

export const getEditPartySizeUrl = (venueId: string,
    id: string,) => {




  return `/api/v1/venues/${venueId}/waitlist/entries/${id}/party-size`
}

/**
 * @summary Edit party size: re-quotes fit without moving position/state (edge case).
 */
export const editPartySize = async (venueId: string,
    id: string,
    partySizeRequest: PartySizeRequest, options?: RequestInit): Promise<WaitlistEntryResponse> => {

  return customInstance<WaitlistEntryResponse>(getEditPartySizeUrl(venueId,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(partySizeRequest)
  }
);}




export const getEditPartySizeMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editPartySize>>, TError,{venueId: string;id: string;data: PartySizeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof editPartySize>>, TError,{venueId: string;id: string;data: PartySizeRequest}, TContext> => {

const mutationKey = ['editPartySize'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editPartySize>>, {venueId: string;id: string;data: PartySizeRequest}> = (props) => {
          const {venueId,id,data} = props ?? {};

          return  editPartySize(venueId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditPartySizeMutationResult = NonNullable<Awaited<ReturnType<typeof editPartySize>>>
    export type EditPartySizeMutationBody = PartySizeRequest
    export type EditPartySizeMutationError = ProblemDetail

    /**
 * @summary Edit party size: re-quotes fit without moving position/state (edge case).
 */
export const useEditPartySize = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editPartySize>>, TError,{venueId: string;id: string;data: PartySizeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editPartySize>>,
        TError,
        {venueId: string;id: string;data: PartySizeRequest},
        TContext
      > => {
      return useMutation(getEditPartySizeMutationOptions(options), queryClient);
    }

export const getNotifyUrl = (venueId: string,
    id: string,) => {




  return `/api/v1/venues/${venueId}/waitlist/entries/${id}/notify`
}

/**
 * @summary Notify (page) an entry for a freed capacity (WL-2/WL-4). Override needs a reason → activity log.
 */
export const notify = async (venueId: string,
    id: string,
    notifyRequest: NotifyRequest, options?: RequestInit): Promise<WaitlistEntryResponse> => {

  return customInstance<WaitlistEntryResponse>(getNotifyUrl(venueId,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notifyRequest)
  }
);}




export const getNotifyMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notify>>, TError,{venueId: string;id: string;data: NotifyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof notify>>, TError,{venueId: string;id: string;data: NotifyRequest}, TContext> => {

const mutationKey = ['notify'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notify>>, {venueId: string;id: string;data: NotifyRequest}> = (props) => {
          const {venueId,id,data} = props ?? {};

          return  notify(venueId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotifyMutationResult = NonNullable<Awaited<ReturnType<typeof notify>>>
    export type NotifyMutationBody = NotifyRequest
    export type NotifyMutationError = ProblemDetail

    /**
 * @summary Notify (page) an entry for a freed capacity (WL-2/WL-4). Override needs a reason → activity log.
 */
export const useNotify = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notify>>, TError,{venueId: string;id: string;data: NotifyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notify>>,
        TError,
        {venueId: string;id: string;data: NotifyRequest},
        TContext
      > => {
      return useMutation(getNotifyMutationOptions(options), queryClient);
    }

export const getNoShowUrl = (venueId: string,
    id: string,) => {




  return `/api/v1/venues/${venueId}/waitlist/entries/${id}/no-show`
}

/**
 * @summary No-show: CHECKED_IN → NO_SHOW (own timestamp).
 */
export const noShow = async (venueId: string,
    id: string,
    versionRequest: VersionRequest, options?: RequestInit): Promise<WaitlistEntryResponse> => {

  return customInstance<WaitlistEntryResponse>(getNoShowUrl(venueId,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(versionRequest)
  }
);}




export const getNoShowMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof noShow>>, TError,{venueId: string;id: string;data: VersionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof noShow>>, TError,{venueId: string;id: string;data: VersionRequest}, TContext> => {

const mutationKey = ['noShow'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof noShow>>, {venueId: string;id: string;data: VersionRequest}> = (props) => {
          const {venueId,id,data} = props ?? {};

          return  noShow(venueId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NoShowMutationResult = NonNullable<Awaited<ReturnType<typeof noShow>>>
    export type NoShowMutationBody = VersionRequest
    export type NoShowMutationError = ProblemDetail

    /**
 * @summary No-show: CHECKED_IN → NO_SHOW (own timestamp).
 */
export const useNoShow = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof noShow>>, TError,{venueId: string;id: string;data: VersionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof noShow>>,
        TError,
        {venueId: string;id: string;data: VersionRequest},
        TContext
      > => {
      return useMutation(getNoShowMutationOptions(options), queryClient);
    }

export const getDeclineUrl = (venueId: string,
    id: string,) => {




  return `/api/v1/venues/${venueId}/waitlist/entries/${id}/decline`
}

/**
 * @summary Staff remove: → DECLINED (own timestamp).
 */
export const decline = async (venueId: string,
    id: string,
    versionRequest: VersionRequest, options?: RequestInit): Promise<WaitlistEntryResponse> => {

  return customInstance<WaitlistEntryResponse>(getDeclineUrl(venueId,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(versionRequest)
  }
);}




export const getDeclineMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof decline>>, TError,{venueId: string;id: string;data: VersionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof decline>>, TError,{venueId: string;id: string;data: VersionRequest}, TContext> => {

const mutationKey = ['decline'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof decline>>, {venueId: string;id: string;data: VersionRequest}> = (props) => {
          const {venueId,id,data} = props ?? {};

          return  decline(venueId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeclineMutationResult = NonNullable<Awaited<ReturnType<typeof decline>>>
    export type DeclineMutationBody = VersionRequest
    export type DeclineMutationError = ProblemDetail

    /**
 * @summary Staff remove: → DECLINED (own timestamp).
 */
export const useDecline = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof decline>>, TError,{venueId: string;id: string;data: VersionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof decline>>,
        TError,
        {venueId: string;id: string;data: VersionRequest},
        TContext
      > => {
      return useMutation(getDeclineMutationOptions(options), queryClient);
    }

export const getCheckInUrl = (venueId: string,
    id: string,) => {




  return `/api/v1/venues/${venueId}/waitlist/entries/${id}/check-in`
}

/**
 * @summary Check-in: NOTIFIED → CHECKED_IN (its own timestamp, WL-3).
 */
export const checkIn = async (venueId: string,
    id: string,
    versionRequest: VersionRequest, options?: RequestInit): Promise<WaitlistEntryResponse> => {

  return customInstance<WaitlistEntryResponse>(getCheckInUrl(venueId,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(versionRequest)
  }
);}




export const getCheckInMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkIn>>, TError,{venueId: string;id: string;data: VersionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof checkIn>>, TError,{venueId: string;id: string;data: VersionRequest}, TContext> => {

const mutationKey = ['checkIn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkIn>>, {venueId: string;id: string;data: VersionRequest}> = (props) => {
          const {venueId,id,data} = props ?? {};

          return  checkIn(venueId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckInMutationResult = NonNullable<Awaited<ReturnType<typeof checkIn>>>
    export type CheckInMutationBody = VersionRequest
    export type CheckInMutationError = ProblemDetail

    /**
 * @summary Check-in: NOTIFIED → CHECKED_IN (its own timestamp, WL-3).
 */
export const useCheckIn = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkIn>>, TError,{venueId: string;id: string;data: VersionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkIn>>,
        TError,
        {venueId: string;id: string;data: VersionRequest},
        TContext
      > => {
      return useMutation(getCheckInMutationOptions(options), queryClient);
    }

export const getCancelUrl = (venueId: string,
    id: string,) => {




  return `/api/v1/venues/${venueId}/waitlist/entries/${id}/cancel`
}

/**
 * @summary Guest cancel (staff-recorded): → CANCELLED (own timestamp); the next fitting entry can be re-proposed.
 */
export const cancel = async (venueId: string,
    id: string,
    versionRequest: VersionRequest, options?: RequestInit): Promise<WaitlistEntryResponse> => {

  return customInstance<WaitlistEntryResponse>(getCancelUrl(venueId,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(versionRequest)
  }
);}




export const getCancelMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancel>>, TError,{venueId: string;id: string;data: VersionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancel>>, TError,{venueId: string;id: string;data: VersionRequest}, TContext> => {

const mutationKey = ['cancel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancel>>, {venueId: string;id: string;data: VersionRequest}> = (props) => {
          const {venueId,id,data} = props ?? {};

          return  cancel(venueId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelMutationResult = NonNullable<Awaited<ReturnType<typeof cancel>>>
    export type CancelMutationBody = VersionRequest
    export type CancelMutationError = ProblemDetail

    /**
 * @summary Guest cancel (staff-recorded): → CANCELLED (own timestamp); the next fitting entry can be re-proposed.
 */
export const useCancel = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancel>>, TError,{venueId: string;id: string;data: VersionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancel>>,
        TError,
        {venueId: string;id: string;data: VersionRequest},
        TContext
      > => {
      return useMutation(getCancelMutationOptions(options), queryClient);
    }

export const getCloseUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/waitlist/close`
}

/**
 * @summary Close a queue for the day: bulk-decline every open entry + plan the 'no availability tonight' note.
 */
export const close = async (venueId: string,
    closeQueueRequest: CloseQueueRequest, options?: RequestInit): Promise<CloseQueueResponse> => {

  return customInstance<CloseQueueResponse>(getCloseUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(closeQueueRequest)
  }
);}




export const getCloseMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof close>>, TError,{venueId: string;data: CloseQueueRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof close>>, TError,{venueId: string;data: CloseQueueRequest}, TContext> => {

const mutationKey = ['close'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof close>>, {venueId: string;data: CloseQueueRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  close(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloseMutationResult = NonNullable<Awaited<ReturnType<typeof close>>>
    export type CloseMutationBody = CloseQueueRequest
    export type CloseMutationError = ProblemDetail

    /**
 * @summary Close a queue for the day: bulk-decline every open entry + plan the 'no availability tonight' note.
 */
export const useClose = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof close>>, TError,{venueId: string;data: CloseQueueRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof close>>,
        TError,
        {venueId: string;data: CloseQueueRequest},
        TContext
      > => {
      return useMutation(getCloseMutationOptions(options), queryClient);
    }

export const getAuthorizeUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/step-up/authorizations`
}

/**
 * @summary Authorize a sensitive action with a manager PIN (single-use, ~60s — ST-4)
 */
export const authorize = async (venueId: string,
    stepUpRequest: StepUpRequest, options?: RequestInit): Promise<StepUpResponse> => {

  return customInstance<StepUpResponse>(getAuthorizeUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(stepUpRequest)
  }
);}




export const getAuthorizeMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authorize>>, TError,{venueId: string;data: StepUpRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof authorize>>, TError,{venueId: string;data: StepUpRequest}, TContext> => {

const mutationKey = ['authorize'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authorize>>, {venueId: string;data: StepUpRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  authorize(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthorizeMutationResult = NonNullable<Awaited<ReturnType<typeof authorize>>>
    export type AuthorizeMutationBody = StepUpRequest
    export type AuthorizeMutationError = ProblemDetail

    /**
 * @summary Authorize a sensitive action with a manager PIN (single-use, ~60s — ST-4)
 */
export const useAuthorize = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authorize>>, TError,{venueId: string;data: StepUpRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authorize>>,
        TError,
        {venueId: string;data: StepUpRequest},
        TContext
      > => {
      return useMutation(getAuthorizeMutationOptions(options), queryClient);
    }

export const getSuspendUrl = (venueId: string,
    userId: string,) => {




  return `/api/v1/venues/${venueId}/staff/${userId}/suspend`
}

/**
 * @summary Suspend an assignment (reason mandatory; expiry never auto-restores — R9)
 */
export const suspend = async (venueId: string,
    userId: string,
    suspendRequest: SuspendRequest, options?: RequestInit): Promise<AssignmentResponse> => {

  return customInstance<AssignmentResponse>(getSuspendUrl(venueId,userId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(suspendRequest)
  }
);}




export const getSuspendMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suspend>>, TError,{venueId: string;userId: string;data: SuspendRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof suspend>>, TError,{venueId: string;userId: string;data: SuspendRequest}, TContext> => {

const mutationKey = ['suspend'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof suspend>>, {venueId: string;userId: string;data: SuspendRequest}> = (props) => {
          const {venueId,userId,data} = props ?? {};

          return  suspend(venueId,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SuspendMutationResult = NonNullable<Awaited<ReturnType<typeof suspend>>>
    export type SuspendMutationBody = SuspendRequest
    export type SuspendMutationError = ProblemDetail

    /**
 * @summary Suspend an assignment (reason mandatory; expiry never auto-restores — R9)
 */
export const useSuspend = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suspend>>, TError,{venueId: string;userId: string;data: SuspendRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof suspend>>,
        TError,
        {venueId: string;userId: string;data: SuspendRequest},
        TContext
      > => {
      return useMutation(getSuspendMutationOptions(options), queryClient);
    }

export const getRestoreUrl = (venueId: string,
    userId: string,) => {




  return `/api/v1/venues/${venueId}/staff/${userId}/restore`
}

/**
 * @summary Restore a suspended assignment (explicit only — R9)
 */
export const restore = async (venueId: string,
    userId: string, options?: RequestInit): Promise<AssignmentResponse> => {

  return customInstance<AssignmentResponse>(getRestoreUrl(venueId,userId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRestoreMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restore>>, TError,{venueId: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof restore>>, TError,{venueId: string;userId: string}, TContext> => {

const mutationKey = ['restore'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restore>>, {venueId: string;userId: string}> = (props) => {
          const {venueId,userId} = props ?? {};

          return  restore(venueId,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestoreMutationResult = NonNullable<Awaited<ReturnType<typeof restore>>>

    export type RestoreMutationError = ProblemDetail

    /**
 * @summary Restore a suspended assignment (explicit only — R9)
 */
export const useRestore = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restore>>, TError,{venueId: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof restore>>,
        TError,
        {venueId: string;userId: string},
        TContext
      > => {
      return useMutation(getRestoreMutationOptions(options), queryClient);
    }

export const getRemoveAssignmentUrl = (venueId: string,
    userId: string,) => {




  return `/api/v1/venues/${venueId}/staff/${userId}/remove`
}

/**
 * @summary Remove a user's assignment at a venue (soft delete; attributions kept)
 */
export const removeAssignment = async (venueId: string,
    userId: string, options?: RequestInit): Promise<AssignmentResponse> => {

  return customInstance<AssignmentResponse>(getRemoveAssignmentUrl(venueId,userId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRemoveAssignmentMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAssignment>>, TError,{venueId: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeAssignment>>, TError,{venueId: string;userId: string}, TContext> => {

const mutationKey = ['removeAssignment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeAssignment>>, {venueId: string;userId: string}> = (props) => {
          const {venueId,userId} = props ?? {};

          return  removeAssignment(venueId,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof removeAssignment>>>

    export type RemoveAssignmentMutationError = ProblemDetail

    /**
 * @summary Remove a user's assignment at a venue (soft delete; attributions kept)
 */
export const useRemoveAssignment = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAssignment>>, TError,{venueId: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeAssignment>>,
        TError,
        {venueId: string;userId: string},
        TContext
      > => {
      return useMutation(getRemoveAssignmentMutationOptions(options), queryClient);
    }

export const getInviteUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/staff/invites`
}

/**
 * @summary Invite a manager/waiter to a venue (ST-5: manager only at own venues)
 */
export const invite = async (venueId: string,
    inviteRequest: InviteRequest, options?: RequestInit): Promise<InviteResponse> => {

  return customInstance<InviteResponse>(getInviteUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(inviteRequest)
  }
);}




export const getInviteMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invite>>, TError,{venueId: string;data: InviteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof invite>>, TError,{venueId: string;data: InviteRequest}, TContext> => {

const mutationKey = ['invite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof invite>>, {venueId: string;data: InviteRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  invite(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InviteMutationResult = NonNullable<Awaited<ReturnType<typeof invite>>>
    export type InviteMutationBody = InviteRequest
    export type InviteMutationError = ProblemDetail

    /**
 * @summary Invite a manager/waiter to a venue (ST-5: manager only at own venues)
 */
export const useInvite = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invite>>, TError,{venueId: string;data: InviteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof invite>>,
        TError,
        {venueId: string;data: InviteRequest},
        TContext
      > => {
      return useMutation(getInviteMutationOptions(options), queryClient);
    }

export const getPublishUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/site/publish`
}

/**
 * @summary Publish: copy draft→published + bump content_version (CAS); emits SitePublished (R4)
 */
export const publish = async (venueId: string,
    versionRequest: VersionRequest, options?: RequestInit): Promise<SiteResponse> => {

  return customInstance<SiteResponse>(getPublishUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(versionRequest)
  }
);}




export const getPublishMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publish>>, TError,{venueId: string;data: VersionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof publish>>, TError,{venueId: string;data: VersionRequest}, TContext> => {

const mutationKey = ['publish'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publish>>, {venueId: string;data: VersionRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  publish(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishMutationResult = NonNullable<Awaited<ReturnType<typeof publish>>>
    export type PublishMutationBody = VersionRequest
    export type PublishMutationError = ProblemDetail

    /**
 * @summary Publish: copy draft→published + bump content_version (CAS); emits SitePublished (R4)
 */
export const usePublish = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publish>>, TError,{venueId: string;data: VersionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof publish>>,
        TError,
        {venueId: string;data: VersionRequest},
        TContext
      > => {
      return useMutation(getPublishMutationOptions(options), queryClient);
    }

export const getPreviewUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/site/preview`
}

/**
 * @summary Mint a staff-only preview URL for the current draft (401/403 for non-management)
 */
export const preview = async (venueId: string, options?: RequestInit): Promise<PreviewResponse> => {

  return customInstance<PreviewResponse>(getPreviewUrl(venueId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPreviewMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof preview>>, TError,{venueId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof preview>>, TError,{venueId: string}, TContext> => {

const mutationKey = ['preview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof preview>>, {venueId: string}> = (props) => {
          const {venueId} = props ?? {};

          return  preview(venueId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewMutationResult = NonNullable<Awaited<ReturnType<typeof preview>>>

    export type PreviewMutationError = ProblemDetail

    /**
 * @summary Mint a staff-only preview URL for the current draft (401/403 for non-management)
 */
export const usePreview = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof preview>>, TError,{venueId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof preview>>,
        TError,
        {venueId: string},
        TContext
      > => {
      return useMutation(getPreviewMutationOptions(options), queryClient);
    }

export const getList2Url = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/services`
}

/**
 * @summary List the venue's services (non-deleted)
 */
export const list2 = async (venueId: string, options?: RequestInit): Promise<ServiceResponse[]> => {

  return customInstance<ServiceResponse[]>(getList2Url(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getList2QueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/services`
    ] as const;
    }


export const getList2QueryOptions = <TData = Awaited<ReturnType<typeof list2>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getList2QueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof list2>>> = ({ signal }) => list2(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof list2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type List2QueryResult = NonNullable<Awaited<ReturnType<typeof list2>>>
export type List2QueryError = ProblemDetail


export function useList2<TData = Awaited<ReturnType<typeof list2>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof list2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof list2>>,
          TError,
          Awaited<ReturnType<typeof list2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useList2<TData = Awaited<ReturnType<typeof list2>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof list2>>,
          TError,
          Awaited<ReturnType<typeof list2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useList2<TData = Awaited<ReturnType<typeof list2>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the venue's services (non-deleted)
 */

export function useList2<TData = Awaited<ReturnType<typeof list2>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getList2QueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateServiceUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/services`
}

/**
 * @summary Create a service — stamps SC-3 defaults when online-bookable (R3)
 */
export const createService = async (venueId: string,
    serviceRequest: ServiceRequest, options?: RequestInit): Promise<ServiceResponse> => {

  return customInstance<ServiceResponse>(getCreateServiceUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(serviceRequest)
  }
);}




export const getCreateServiceMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createService>>, TError,{venueId: string;data: ServiceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createService>>, TError,{venueId: string;data: ServiceRequest}, TContext> => {

const mutationKey = ['createService'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createService>>, {venueId: string;data: ServiceRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  createService(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateServiceMutationResult = NonNullable<Awaited<ReturnType<typeof createService>>>
    export type CreateServiceMutationBody = ServiceRequest
    export type CreateServiceMutationError = ProblemDetail

    /**
 * @summary Create a service — stamps SC-3 defaults when online-bookable (R3)
 */
export const useCreateService = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createService>>, TError,{venueId: string;data: ServiceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createService>>,
        TError,
        {venueId: string;data: ServiceRequest},
        TContext
      > => {
      return useMutation(getCreateServiceMutationOptions(options), queryClient);
    }

export const getRebuildUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/risk-policy/rebuild`
}

/**
 * @summary Rebuild the venue's guest_risk projection from bookings (drift/correction repair)
 */
export const rebuild = async (venueId: string, options?: RequestInit): Promise<RiskRebuildResponse> => {

  return customInstance<RiskRebuildResponse>(getRebuildUrl(venueId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRebuildMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rebuild>>, TError,{venueId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof rebuild>>, TError,{venueId: string}, TContext> => {

const mutationKey = ['rebuild'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rebuild>>, {venueId: string}> = (props) => {
          const {venueId} = props ?? {};

          return  rebuild(venueId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RebuildMutationResult = NonNullable<Awaited<ReturnType<typeof rebuild>>>

    export type RebuildMutationError = ProblemDetail

    /**
 * @summary Rebuild the venue's guest_risk projection from bookings (drift/correction repair)
 */
export const useRebuild = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rebuild>>, TError,{venueId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rebuild>>,
        TError,
        {venueId: string},
        TContext
      > => {
      return useMutation(getRebuildMutationOptions(options), queryClient);
    }

export const getSearchUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/place-match/search`
}

/**
 * @summary Search Google Places candidates for the venue (review UI data)
 */
export const search = async (venueId: string, options?: RequestInit): Promise<PlaceMatchSearchResponse> => {

  return customInstance<PlaceMatchSearchResponse>(getSearchUrl(venueId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSearchMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof search>>, TError,{venueId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof search>>, TError,{venueId: string}, TContext> => {

const mutationKey = ['search'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof search>>, {venueId: string}> = (props) => {
          const {venueId} = props ?? {};

          return  search(venueId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SearchMutationResult = NonNullable<Awaited<ReturnType<typeof search>>>

    export type SearchMutationError = ProblemDetail

    /**
 * @summary Search Google Places candidates for the venue (review UI data)
 */
export const useSearch = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof search>>, TError,{venueId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof search>>,
        TError,
        {venueId: string},
        TContext
      > => {
      return useMutation(getSearchMutationOptions(options), queryClient);
    }

export const getNoneUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/place-match/none`
}

/**
 * @summary Mark none of the candidates a match → NOT_FOUND, venue stays off RwG (R2)
 */
export const none = async (venueId: string,
    noneMatchRequest: NoneMatchRequest, options?: RequestInit): Promise<None200> => {

  return customInstance<None200>(getNoneUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(noneMatchRequest)
  }
);}




export const getNoneMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof none>>, TError,{venueId: string;data: NoneMatchRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof none>>, TError,{venueId: string;data: NoneMatchRequest}, TContext> => {

const mutationKey = ['none'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof none>>, {venueId: string;data: NoneMatchRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  none(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NoneMutationResult = NonNullable<Awaited<ReturnType<typeof none>>>
    export type NoneMutationBody = NoneMatchRequest
    export type NoneMutationError = ProblemDetail

    /**
 * @summary Mark none of the candidates a match → NOT_FOUND, venue stays off RwG (R2)
 */
export const useNone = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof none>>, TError,{venueId: string;data: NoneMatchRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof none>>,
        TError,
        {venueId: string;data: NoneMatchRequest},
        TContext
      > => {
      return useMutation(getNoneMutationOptions(options), queryClient);
    }

export const getConfirmUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/place-match/confirm`
}

/**
 * @summary Confirm a Google candidate (or an override id) → VERIFIED (R1)
 */
export const confirm = async (venueId: string,
    confirmMatchRequest: ConfirmMatchRequest, options?: RequestInit): Promise<Confirm200> => {

  return customInstance<Confirm200>(getConfirmUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(confirmMatchRequest)
  }
);}




export const getConfirmMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirm>>, TError,{venueId: string;data: ConfirmMatchRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof confirm>>, TError,{venueId: string;data: ConfirmMatchRequest}, TContext> => {

const mutationKey = ['confirm'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirm>>, {venueId: string;data: ConfirmMatchRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  confirm(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmMutationResult = NonNullable<Awaited<ReturnType<typeof confirm>>>
    export type ConfirmMutationBody = ConfirmMatchRequest
    export type ConfirmMutationError = ProblemDetail

    /**
 * @summary Confirm a Google candidate (or an override id) → VERIFIED (R1)
 */
export const useConfirm = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirm>>, TError,{venueId: string;data: ConfirmMatchRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirm>>,
        TError,
        {venueId: string;data: ConfirmMatchRequest},
        TContext
      > => {
      return useMutation(getConfirmMutationOptions(options), queryClient);
    }

export const getCompleteUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/onboarding/complete`
}

/**
 * @summary Complete onboarding: mandatory steps done → READY (never LIVE) (R1/R2)
 */
export const complete = async (venueId: string, options?: RequestInit): Promise<Complete200> => {

  return customInstance<Complete200>(getCompleteUrl(venueId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCompleteMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof complete>>, TError,{venueId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof complete>>, TError,{venueId: string}, TContext> => {

const mutationKey = ['complete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof complete>>, {venueId: string}> = (props) => {
          const {venueId} = props ?? {};

          return  complete(venueId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteMutationResult = NonNullable<Awaited<ReturnType<typeof complete>>>

    export type CompleteMutationError = ProblemDetail

    /**
 * @summary Complete onboarding: mandatory steps done → READY (never LIVE) (R1/R2)
 */
export const useComplete = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof complete>>, TError,{venueId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof complete>>,
        TError,
        {venueId: string},
        TContext
      > => {
      return useMutation(getCompleteMutationOptions(options), queryClient);
    }

export const getRequestActivationUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/onboarding/activation-request`
}

/**
 * @summary Request activation (R7) — durable SLA-clock start + ops notification
 */
export const requestActivation = async (venueId: string, options?: RequestInit): Promise<ActivationRequestResponse> => {

  return customInstance<ActivationRequestResponse>(getRequestActivationUrl(venueId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRequestActivationMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestActivation>>, TError,{venueId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof requestActivation>>, TError,{venueId: string}, TContext> => {

const mutationKey = ['requestActivation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestActivation>>, {venueId: string}> = (props) => {
          const {venueId} = props ?? {};

          return  requestActivation(venueId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestActivationMutationResult = NonNullable<Awaited<ReturnType<typeof requestActivation>>>

    export type RequestActivationMutationError = ProblemDetail

    /**
 * @summary Request activation (R7) — durable SLA-clock start + ops notification
 */
export const useRequestActivation = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestActivation>>, TError,{venueId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestActivation>>,
        TError,
        {venueId: string},
        TContext
      > => {
      return useMutation(getRequestActivationMutationOptions(options), queryClient);
    }

export const getList3Url = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/media`
}

/**
 * @summary List the venue's media library (newest first) — status polling + grid
 */
export const list3 = async (venueId: string, options?: RequestInit): Promise<MediaAssetResponse[]> => {

  return customInstance<MediaAssetResponse[]>(getList3Url(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getList3QueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/media`
    ] as const;
    }


export const getList3QueryOptions = <TData = Awaited<ReturnType<typeof list3>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list3>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getList3QueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof list3>>> = ({ signal }) => list3(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof list3>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type List3QueryResult = NonNullable<Awaited<ReturnType<typeof list3>>>
export type List3QueryError = ProblemDetail


export function useList3<TData = Awaited<ReturnType<typeof list3>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof list3>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof list3>>,
          TError,
          Awaited<ReturnType<typeof list3>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useList3<TData = Awaited<ReturnType<typeof list3>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list3>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof list3>>,
          TError,
          Awaited<ReturnType<typeof list3>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useList3<TData = Awaited<ReturnType<typeof list3>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list3>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the venue's media library (newest first) — status polling + grid
 */

export function useList3<TData = Awaited<ReturnType<typeof list3>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list3>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getList3QueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateMediaUploadUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/media`
}

/**
 * @summary Create an upload: quota gate + validation, then a presigned PUT (R3)
 */
export const createMediaUpload = async (venueId: string,
    createMediaUploadRequest: CreateMediaUploadRequest, options?: RequestInit): Promise<CreateMediaUpload200> => {

  return customInstance<CreateMediaUpload200>(getCreateMediaUploadUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createMediaUploadRequest)
  }
);}




export const getCreateMediaUploadMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMediaUpload>>, TError,{venueId: string;data: CreateMediaUploadRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createMediaUpload>>, TError,{venueId: string;data: CreateMediaUploadRequest}, TContext> => {

const mutationKey = ['createMediaUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMediaUpload>>, {venueId: string;data: CreateMediaUploadRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  createMediaUpload(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMediaUploadMutationResult = NonNullable<Awaited<ReturnType<typeof createMediaUpload>>>
    export type CreateMediaUploadMutationBody = CreateMediaUploadRequest
    export type CreateMediaUploadMutationError = ProblemDetail

    /**
 * @summary Create an upload: quota gate + validation, then a presigned PUT (R3)
 */
export const useCreateMediaUpload = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMediaUpload>>, TError,{venueId: string;data: CreateMediaUploadRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMediaUpload>>,
        TError,
        {venueId: string;data: CreateMediaUploadRequest},
        TContext
      > => {
      return useMutation(getCreateMediaUploadMutationOptions(options), queryClient);
    }

export const getRetireUrl = (venueId: string,
    assetId: string,) => {




  return `/api/v1/venues/${venueId}/media/${assetId}/retire`
}

/**
 * @summary Retire the LIVE asset in a slot (remove/replace); frees the slot
 */
export const retire = async (venueId: string,
    assetId: string, options?: RequestInit): Promise<MediaAssetResponse> => {

  return customInstance<MediaAssetResponse>(getRetireUrl(venueId,assetId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRetireMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retire>>, TError,{venueId: string;assetId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof retire>>, TError,{venueId: string;assetId: string}, TContext> => {

const mutationKey = ['retire'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retire>>, {venueId: string;assetId: string}> = (props) => {
          const {venueId,assetId} = props ?? {};

          return  retire(venueId,assetId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetireMutationResult = NonNullable<Awaited<ReturnType<typeof retire>>>

    export type RetireMutationError = ProblemDetail

    /**
 * @summary Retire the LIVE asset in a slot (remove/replace); frees the slot
 */
export const useRetire = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retire>>, TError,{venueId: string;assetId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof retire>>,
        TError,
        {venueId: string;assetId: string},
        TContext
      > => {
      return useMutation(getRetireMutationOptions(options), queryClient);
    }

export const getConfirm1Url = (venueId: string,
    assetId: string,) => {




  return `/api/v1/venues/${venueId}/media/${assetId}/confirm`
}

/**
 * @summary Confirm the upload and run the pipeline; returns the terminal asset state
 */
export const confirm1 = async (venueId: string,
    assetId: string, options?: RequestInit): Promise<Confirm1200> => {

  return customInstance<Confirm1200>(getConfirm1Url(venueId,assetId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getConfirm1MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirm1>>, TError,{venueId: string;assetId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof confirm1>>, TError,{venueId: string;assetId: string}, TContext> => {

const mutationKey = ['confirm1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirm1>>, {venueId: string;assetId: string}> = (props) => {
          const {venueId,assetId} = props ?? {};

          return  confirm1(venueId,assetId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type Confirm1MutationResult = NonNullable<Awaited<ReturnType<typeof confirm1>>>

    export type Confirm1MutationError = ProblemDetail

    /**
 * @summary Confirm the upload and run the pipeline; returns the terminal asset state
 */
export const useConfirm1 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirm1>>, TError,{venueId: string;assetId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirm1>>,
        TError,
        {venueId: string;assetId: string},
        TContext
      > => {
      return useMutation(getConfirm1MutationOptions(options), queryClient);
    }

export const getGet2Url = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/location`
}

/**
 * @summary Read a venue's confirmed location (null when not yet confirmed)
 */
export const get2 = async (venueId: string, options?: RequestInit): Promise<VenueLocationResponse> => {

  return customInstance<VenueLocationResponse>(getGet2Url(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGet2QueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/location`
    ] as const;
    }


export const getGet2QueryOptions = <TData = Awaited<ReturnType<typeof get2>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGet2QueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get2>>> = ({ signal }) => get2(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Get2QueryResult = NonNullable<Awaited<ReturnType<typeof get2>>>
export type Get2QueryError = ProblemDetail


export function useGet2<TData = Awaited<ReturnType<typeof get2>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get2>>,
          TError,
          Awaited<ReturnType<typeof get2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet2<TData = Awaited<ReturnType<typeof get2>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get2>>,
          TError,
          Awaited<ReturnType<typeof get2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet2<TData = Awaited<ReturnType<typeof get2>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read a venue's confirmed location (null when not yet confirmed)
 */

export function useGet2<TData = Awaited<ReturnType<typeof get2>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGet2QueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getConfirm2Url = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/location`
}

/**
 * @summary Confirm/edit a venue's location — pin-authoritative geo (TN-7), best-effort place capture
 */
export const confirm2 = async (venueId: string,
    confirmLocationRequest: ConfirmLocationRequest, options?: RequestInit): Promise<Confirm2200> => {

  return customInstance<Confirm2200>(getConfirm2Url(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(confirmLocationRequest)
  }
);}




export const getConfirm2MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirm2>>, TError,{venueId: string;data: ConfirmLocationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof confirm2>>, TError,{venueId: string;data: ConfirmLocationRequest}, TContext> => {

const mutationKey = ['confirm2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirm2>>, {venueId: string;data: ConfirmLocationRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  confirm2(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type Confirm2MutationResult = NonNullable<Awaited<ReturnType<typeof confirm2>>>
    export type Confirm2MutationBody = ConfirmLocationRequest
    export type Confirm2MutationError = ProblemDetail

    /**
 * @summary Confirm/edit a venue's location — pin-authoritative geo (TN-7), best-effort place capture
 */
export const useConfirm2 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirm2>>, TError,{venueId: string;data: ConfirmLocationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirm2>>,
        TError,
        {venueId: string;data: ConfirmLocationRequest},
        TContext
      > => {
      return useMutation(getConfirm2MutationOptions(options), queryClient);
    }

export const getWalkInUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/live/walk-ins`
}

/**
 * @summary Door walk-in (channel WALK_IN) — consumes real inventory; may be created SEATED (§C.7).
 */
export const walkIn = async (venueId: string,
    walkInRequest: WalkInRequest, options?: RequestInit): Promise<StaffBookingResponse> => {

  return customInstance<StaffBookingResponse>(getWalkInUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(walkInRequest)
  }
);}




export const getWalkInMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof walkIn>>, TError,{venueId: string;data: WalkInRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof walkIn>>, TError,{venueId: string;data: WalkInRequest}, TContext> => {

const mutationKey = ['walkIn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof walkIn>>, {venueId: string;data: WalkInRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  walkIn(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WalkInMutationResult = NonNullable<Awaited<ReturnType<typeof walkIn>>>
    export type WalkInMutationBody = WalkInRequest
    export type WalkInMutationError = ProblemDetail

    /**
 * @summary Door walk-in (channel WALK_IN) — consumes real inventory; may be created SEATED (§C.7).
 */
export const useWalkIn = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof walkIn>>, TError,{venueId: string;data: WalkInRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof walkIn>>,
        TError,
        {venueId: string;data: WalkInRequest},
        TContext
      > => {
      return useMutation(getWalkInMutationOptions(options), queryClient);
    }

export const getTableReadyUrl = (venueId: string,
    tableId: string,) => {




  return `/api/v1/venues/${venueId}/live/tables/${tableId}/ready`
}

/**
 * @summary Table-ready — close the CLEANING fact so the table derives back to available. Idempotent.
 */
export const tableReady = async (venueId: string,
    tableId: string, options?: RequestInit): Promise<TableReadyResponse> => {

  return customInstance<TableReadyResponse>(getTableReadyUrl(venueId,tableId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getTableReadyMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tableReady>>, TError,{venueId: string;tableId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof tableReady>>, TError,{venueId: string;tableId: string}, TContext> => {

const mutationKey = ['tableReady'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tableReady>>, {venueId: string;tableId: string}> = (props) => {
          const {venueId,tableId} = props ?? {};

          return  tableReady(venueId,tableId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TableReadyMutationResult = NonNullable<Awaited<ReturnType<typeof tableReady>>>

    export type TableReadyMutationError = ProblemDetail

    /**
 * @summary Table-ready — close the CLEANING fact so the table derives back to available. Idempotent.
 */
export const useTableReady = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tableReady>>, TError,{venueId: string;tableId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tableReady>>,
        TError,
        {venueId: string;tableId: string},
        TContext
      > => {
      return useMutation(getTableReadyMutationOptions(options), queryClient);
    }

export const getSeat1Url = (venueId: string,
    bookingId: string,) => {




  return `/api/v1/venues/${venueId}/live/bookings/${bookingId}/seat`
}

/**
 * @summary Seat — CONFIRMED -> SEATED atomic with OCCUPIED table fact(s). Same-target no-op; 409 on conflict.
 */
export const seat1 = async (venueId: string,
    bookingId: string,
    liveSeatRequest: LiveSeatRequest, options?: RequestInit): Promise<StaffBookingResponse> => {

  return customInstance<StaffBookingResponse>(getSeat1Url(venueId,bookingId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(liveSeatRequest)
  }
);}




export const getSeat1MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof seat1>>, TError,{venueId: string;bookingId: string;data: LiveSeatRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof seat1>>, TError,{venueId: string;bookingId: string;data: LiveSeatRequest}, TContext> => {

const mutationKey = ['seat1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof seat1>>, {venueId: string;bookingId: string;data: LiveSeatRequest}> = (props) => {
          const {venueId,bookingId,data} = props ?? {};

          return  seat1(venueId,bookingId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type Seat1MutationResult = NonNullable<Awaited<ReturnType<typeof seat1>>>
    export type Seat1MutationBody = LiveSeatRequest
    export type Seat1MutationError = ProblemDetail

    /**
 * @summary Seat — CONFIRMED -> SEATED atomic with OCCUPIED table fact(s). Same-target no-op; 409 on conflict.
 */
export const useSeat1 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof seat1>>, TError,{venueId: string;bookingId: string;data: LiveSeatRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof seat1>>,
        TError,
        {venueId: string;bookingId: string;data: LiveSeatRequest},
        TContext
      > => {
      return useMutation(getSeat1MutationOptions(options), queryClient);
    }

export const getNoShow1Url = (venueId: string,
    bookingId: string,) => {




  return `/api/v1/venues/${venueId}/live/bookings/${bookingId}/no-show`
}

/**
 * @summary No-show — CONFIRMED -> NO_SHOW, releases the claim + logs to CRM (R3). Waiter-permitted.
 */
export const noShow1 = async (venueId: string,
    bookingId: string,
    liveVersionRequest: LiveVersionRequest, options?: RequestInit): Promise<StaffBookingResponse> => {

  return customInstance<StaffBookingResponse>(getNoShow1Url(venueId,bookingId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(liveVersionRequest)
  }
);}




export const getNoShow1MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof noShow1>>, TError,{venueId: string;bookingId: string;data: LiveVersionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof noShow1>>, TError,{venueId: string;bookingId: string;data: LiveVersionRequest}, TContext> => {

const mutationKey = ['noShow1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof noShow1>>, {venueId: string;bookingId: string;data: LiveVersionRequest}> = (props) => {
          const {venueId,bookingId,data} = props ?? {};

          return  noShow1(venueId,bookingId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NoShow1MutationResult = NonNullable<Awaited<ReturnType<typeof noShow1>>>
    export type NoShow1MutationBody = LiveVersionRequest
    export type NoShow1MutationError = ProblemDetail

    /**
 * @summary No-show — CONFIRMED -> NO_SHOW, releases the claim + logs to CRM (R3). Waiter-permitted.
 */
export const useNoShow1 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof noShow1>>, TError,{venueId: string;bookingId: string;data: LiveVersionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof noShow1>>,
        TError,
        {venueId: string;bookingId: string;data: LiveVersionRequest},
        TContext
      > => {
      return useMutation(getNoShow1MutationOptions(options), queryClient);
    }

export const getMoveUrl = (venueId: string,
    bookingId: string,) => {




  return `/api/v1/venues/${venueId}/live/bookings/${bookingId}/move`
}

/**
 * @summary Move — relocate a SEATED party to different table(s): open the new OCCUPIED fact(s), free the old. Same-target no-op; 409 on conflict / stale.
 */
export const move = async (venueId: string,
    bookingId: string,
    liveSeatRequest: LiveSeatRequest, options?: RequestInit): Promise<StaffBookingResponse> => {

  return customInstance<StaffBookingResponse>(getMoveUrl(venueId,bookingId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(liveSeatRequest)
  }
);}




export const getMoveMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof move>>, TError,{venueId: string;bookingId: string;data: LiveSeatRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof move>>, TError,{venueId: string;bookingId: string;data: LiveSeatRequest}, TContext> => {

const mutationKey = ['move'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof move>>, {venueId: string;bookingId: string;data: LiveSeatRequest}> = (props) => {
          const {venueId,bookingId,data} = props ?? {};

          return  move(venueId,bookingId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MoveMutationResult = NonNullable<Awaited<ReturnType<typeof move>>>
    export type MoveMutationBody = LiveSeatRequest
    export type MoveMutationError = ProblemDetail

    /**
 * @summary Move — relocate a SEATED party to different table(s): open the new OCCUPIED fact(s), free the old. Same-target no-op; 409 on conflict / stale.
 */
export const useMove = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof move>>, TError,{venueId: string;bookingId: string;data: LiveSeatRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof move>>,
        TError,
        {venueId: string;bookingId: string;data: LiveSeatRequest},
        TContext
      > => {
      return useMutation(getMoveMutationOptions(options), queryClient);
    }

export const getDepartUrl = (venueId: string,
    bookingId: string,) => {




  return `/api/v1/venues/${venueId}/live/bookings/${bookingId}/depart`
}

/**
 * @summary Depart — SEATED -> COMPLETED atomic with the table OCCUPIED -> CLEANING flip.
 */
export const depart = async (venueId: string,
    bookingId: string,
    liveVersionRequest: LiveVersionRequest, options?: RequestInit): Promise<StaffBookingResponse> => {

  return customInstance<StaffBookingResponse>(getDepartUrl(venueId,bookingId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(liveVersionRequest)
  }
);}




export const getDepartMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof depart>>, TError,{venueId: string;bookingId: string;data: LiveVersionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof depart>>, TError,{venueId: string;bookingId: string;data: LiveVersionRequest}, TContext> => {

const mutationKey = ['depart'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof depart>>, {venueId: string;bookingId: string;data: LiveVersionRequest}> = (props) => {
          const {venueId,bookingId,data} = props ?? {};

          return  depart(venueId,bookingId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DepartMutationResult = NonNullable<Awaited<ReturnType<typeof depart>>>
    export type DepartMutationBody = LiveVersionRequest
    export type DepartMutationError = ProblemDetail

    /**
 * @summary Depart — SEATED -> COMPLETED atomic with the table OCCUPIED -> CLEANING flip.
 */
export const useDepart = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof depart>>, TError,{venueId: string;bookingId: string;data: LiveVersionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof depart>>,
        TError,
        {venueId: string;bookingId: string;data: LiveVersionRequest},
        TContext
      > => {
      return useMutation(getDepartMutationOptions(options), queryClient);
    }

export const getArriveUrl = (venueId: string,
    bookingId: string,) => {




  return `/api/v1/venues/${venueId}/live/bookings/${bookingId}/arrive`
}

/**
 * @summary Arrive — stamp a check-in timestamp only (§C.7, not a status). Idempotent.
 */
export const arrive = async (venueId: string,
    bookingId: string,
    liveVersionRequest: LiveVersionRequest, options?: RequestInit): Promise<StaffBookingResponse> => {

  return customInstance<StaffBookingResponse>(getArriveUrl(venueId,bookingId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(liveVersionRequest)
  }
);}




export const getArriveMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof arrive>>, TError,{venueId: string;bookingId: string;data: LiveVersionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof arrive>>, TError,{venueId: string;bookingId: string;data: LiveVersionRequest}, TContext> => {

const mutationKey = ['arrive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof arrive>>, {venueId: string;bookingId: string;data: LiveVersionRequest}> = (props) => {
          const {venueId,bookingId,data} = props ?? {};

          return  arrive(venueId,bookingId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArriveMutationResult = NonNullable<Awaited<ReturnType<typeof arrive>>>
    export type ArriveMutationBody = LiveVersionRequest
    export type ArriveMutationError = ProblemDetail

    /**
 * @summary Arrive — stamp a check-in timestamp only (§C.7, not a status). Idempotent.
 */
export const useArrive = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof arrive>>, TError,{venueId: string;bookingId: string;data: LiveVersionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof arrive>>,
        TError,
        {venueId: string;bookingId: string;data: LiveVersionRequest},
        TContext
      > => {
      return useMutation(getArriveMutationOptions(options), queryClient);
    }

export const getGet3Url = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/listing-authorization`
}

/**
 * @summary Read the current listing decision + policy version + re-confirm flag (R3/R4)
 */
export const get3 = async (venueId: string, options?: RequestInit): Promise<ListingAuthorizationResponse> => {

  return customInstance<ListingAuthorizationResponse>(getGet3Url(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGet3QueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/listing-authorization`
    ] as const;
    }


export const getGet3QueryOptions = <TData = Awaited<ReturnType<typeof get3>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get3>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGet3QueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get3>>> = ({ signal }) => get3(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get3>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Get3QueryResult = NonNullable<Awaited<ReturnType<typeof get3>>>
export type Get3QueryError = ProblemDetail


export function useGet3<TData = Awaited<ReturnType<typeof get3>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get3>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get3>>,
          TError,
          Awaited<ReturnType<typeof get3>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet3<TData = Awaited<ReturnType<typeof get3>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get3>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get3>>,
          TError,
          Awaited<ReturnType<typeof get3>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet3<TData = Awaited<ReturnType<typeof get3>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get3>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read the current listing decision + policy version + re-confirm flag (R3/R4)
 */

export function useGet3<TData = Awaited<ReturnType<typeof get3>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get3>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGet3QueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getRecordUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/listing-authorization`
}

/**
 * @summary Record a listing decision (GRANTED|DECLINED|DEFERRED) — snapshots policy + decider (R4/R5)
 */
export const record = async (venueId: string,
    listingDecisionRequest: ListingDecisionRequest, options?: RequestInit): Promise<ListingAuthorizationResponse> => {

  return customInstance<ListingAuthorizationResponse>(getRecordUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(listingDecisionRequest)
  }
);}




export const getRecordMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof record>>, TError,{venueId: string;data: ListingDecisionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof record>>, TError,{venueId: string;data: ListingDecisionRequest}, TContext> => {

const mutationKey = ['record'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof record>>, {venueId: string;data: ListingDecisionRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  record(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordMutationResult = NonNullable<Awaited<ReturnType<typeof record>>>
    export type RecordMutationBody = ListingDecisionRequest
    export type RecordMutationError = ProblemDetail

    /**
 * @summary Record a listing decision (GRANTED|DECLINED|DEFERRED) — snapshots policy + decider (R4/R5)
 */
export const useRecord = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof record>>, TError,{venueId: string;data: ListingDecisionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof record>>,
        TError,
        {venueId: string;data: ListingDecisionRequest},
        TContext
      > => {
      return useMutation(getRecordMutationOptions(options), queryClient);
    }

export const getQuickFlagUrl = (venueId: string,
    guestId: string,) => {




  return `/api/v1/venues/${venueId}/guests/${guestId}/quick-flag`
}

/**
 * @summary Quick-flag from the live view (waiter-allowed, mandatory reason) → note + event
 */
export const quickFlag = async (venueId: string,
    guestId: string,
    quickFlagRequest: QuickFlagRequest, options?: RequestInit): Promise<GuestProfileResponse> => {

  return customInstance<GuestProfileResponse>(getQuickFlagUrl(venueId,guestId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(quickFlagRequest)
  }
);}




export const getQuickFlagMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof quickFlag>>, TError,{venueId: string;guestId: string;data: QuickFlagRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof quickFlag>>, TError,{venueId: string;guestId: string;data: QuickFlagRequest}, TContext> => {

const mutationKey = ['quickFlag'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof quickFlag>>, {venueId: string;guestId: string;data: QuickFlagRequest}> = (props) => {
          const {venueId,guestId,data} = props ?? {};

          return  quickFlag(venueId,guestId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QuickFlagMutationResult = NonNullable<Awaited<ReturnType<typeof quickFlag>>>
    export type QuickFlagMutationBody = QuickFlagRequest
    export type QuickFlagMutationError = ProblemDetail

    /**
 * @summary Quick-flag from the live view (waiter-allowed, mandatory reason) → note + event
 */
export const useQuickFlag = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof quickFlag>>, TError,{venueId: string;guestId: string;data: QuickFlagRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof quickFlag>>,
        TError,
        {venueId: string;guestId: string;data: QuickFlagRequest},
        TContext
      > => {
      return useMutation(getQuickFlagMutationOptions(options), queryClient);
    }

export const getAddNoteUrl = (venueId: string,
    guestId: string,) => {




  return `/api/v1/venues/${venueId}/guests/${guestId}/notes`
}

/**
 * @summary Append a staff note (CRM_NOTES_TAGS-gated, append-only)
 */
export const addNote = async (venueId: string,
    guestId: string,
    addNoteRequest: AddNoteRequest, options?: RequestInit): Promise<GuestProfileResponse> => {

  return customInstance<GuestProfileResponse>(getAddNoteUrl(venueId,guestId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addNoteRequest)
  }
);}




export const getAddNoteMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addNote>>, TError,{venueId: string;guestId: string;data: AddNoteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addNote>>, TError,{venueId: string;guestId: string;data: AddNoteRequest}, TContext> => {

const mutationKey = ['addNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addNote>>, {venueId: string;guestId: string;data: AddNoteRequest}> = (props) => {
          const {venueId,guestId,data} = props ?? {};

          return  addNote(venueId,guestId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddNoteMutationResult = NonNullable<Awaited<ReturnType<typeof addNote>>>
    export type AddNoteMutationBody = AddNoteRequest
    export type AddNoteMutationError = ProblemDetail

    /**
 * @summary Append a staff note (CRM_NOTES_TAGS-gated, append-only)
 */
export const useAddNote = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addNote>>, TError,{venueId: string;guestId: string;data: AddNoteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addNote>>,
        TError,
        {venueId: string;guestId: string;data: AddNoteRequest},
        TContext
      > => {
      return useMutation(getAddNoteMutationOptions(options), queryClient);
    }

export const getMergeUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/guests/merge`
}

/**
 * @summary Staff-initiated manual merge (winner/loser in one tx)
 */
export const merge = async (venueId: string,
    mergeRequest: MergeRequest, options?: RequestInit): Promise<MergeResponse> => {

  return customInstance<MergeResponse>(getMergeUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mergeRequest)
  }
);}




export const getMergeMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof merge>>, TError,{venueId: string;data: MergeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof merge>>, TError,{venueId: string;data: MergeRequest}, TContext> => {

const mutationKey = ['merge'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof merge>>, {venueId: string;data: MergeRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  merge(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MergeMutationResult = NonNullable<Awaited<ReturnType<typeof merge>>>
    export type MergeMutationBody = MergeRequest
    export type MergeMutationError = ProblemDetail

    /**
 * @summary Staff-initiated manual merge (winner/loser in one tx)
 */
export const useMerge = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof merge>>, TError,{venueId: string;data: MergeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof merge>>,
        TError,
        {venueId: string;data: MergeRequest},
        TContext
      > => {
      return useMutation(getMergeMutationOptions(options), queryClient);
    }

export const getResolveConflictUrl = (venueId: string,
    conflictId: string,) => {




  return `/api/v1/venues/${venueId}/guests/merge-conflicts/${conflictId}/resolve`
}

/**
 * @summary Resolve a conflict-queue row: MERGE (winner/loser) or DISMISS
 */
export const resolveConflict = async (venueId: string,
    conflictId: string,
    resolveConflictRequest: ResolveConflictRequest, options?: RequestInit): Promise<MergeResponse> => {

  return customInstance<MergeResponse>(getResolveConflictUrl(venueId,conflictId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resolveConflictRequest)
  }
);}




export const getResolveConflictMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveConflict>>, TError,{venueId: string;conflictId: string;data: ResolveConflictRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resolveConflict>>, TError,{venueId: string;conflictId: string;data: ResolveConflictRequest}, TContext> => {

const mutationKey = ['resolveConflict'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resolveConflict>>, {venueId: string;conflictId: string;data: ResolveConflictRequest}> = (props) => {
          const {venueId,conflictId,data} = props ?? {};

          return  resolveConflict(venueId,conflictId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResolveConflictMutationResult = NonNullable<Awaited<ReturnType<typeof resolveConflict>>>
    export type ResolveConflictMutationBody = ResolveConflictRequest
    export type ResolveConflictMutationError = ProblemDetail

    /**
 * @summary Resolve a conflict-queue row: MERGE (winner/loser) or DISMISS
 */
export const useResolveConflict = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveConflict>>, TError,{venueId: string;conflictId: string;data: ResolveConflictRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resolveConflict>>,
        TError,
        {venueId: string;conflictId: string;data: ResolveConflictRequest},
        TContext
      > => {
      return useMutation(getResolveConflictMutationOptions(options), queryClient);
    }

export const getGoLiveUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/go-live`
}

/**
 * @summary Attempt READY → LIVE: all four TN-3 gates (subdomain, onboarding, DPA, subscription)
 */
export const goLive = async (venueId: string, options?: RequestInit): Promise<GoLive200> => {

  return customInstance<GoLive200>(getGoLiveUrl(venueId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getGoLiveMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof goLive>>, TError,{venueId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof goLive>>, TError,{venueId: string}, TContext> => {

const mutationKey = ['goLive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof goLive>>, {venueId: string}> = (props) => {
          const {venueId} = props ?? {};

          return  goLive(venueId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GoLiveMutationResult = NonNullable<Awaited<ReturnType<typeof goLive>>>

    export type GoLiveMutationError = ProblemDetail

    /**
 * @summary Attempt READY → LIVE: all four TN-3 gates (subdomain, onboarding, DPA, subscription)
 */
export const useGoLive = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof goLive>>, TError,{venueId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof goLive>>,
        TError,
        {venueId: string},
        TContext
      > => {
      return useMutation(getGoLiveMutationOptions(options), queryClient);
    }

export const getComplete1Url = (venueId: string,
    requestId: string,) => {




  return `/api/v1/venues/${venueId}/dsr/${requestId}/complete`
}

/**
 * @summary Run access-export / erasure and close the request, disclosing exceptions (CP-3)
 */
export const complete1 = async (venueId: string,
    requestId: string, options?: RequestInit): Promise<DsrCompletionResponse> => {

  return customInstance<DsrCompletionResponse>(getComplete1Url(venueId,requestId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getComplete1MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof complete1>>, TError,{venueId: string;requestId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof complete1>>, TError,{venueId: string;requestId: string}, TContext> => {

const mutationKey = ['complete1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof complete1>>, {venueId: string;requestId: string}> = (props) => {
          const {venueId,requestId} = props ?? {};

          return  complete1(venueId,requestId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type Complete1MutationResult = NonNullable<Awaited<ReturnType<typeof complete1>>>

    export type Complete1MutationError = ProblemDetail

    /**
 * @summary Run access-export / erasure and close the request, disclosing exceptions (CP-3)
 */
export const useComplete1 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof complete1>>, TError,{venueId: string;requestId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof complete1>>,
        TError,
        {venueId: string;requestId: string},
        TContext
      > => {
      return useMutation(getComplete1MutationOptions(options), queryClient);
    }

export const getAcceptUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/dpa/acceptance`
}

/**
 * @summary Accept the current DPA (root/manager, R3) — records a versioned acceptance
 */
export const accept = async (venueId: string, options?: RequestInit): Promise<DpaAcceptanceResponse> => {

  return customInstance<DpaAcceptanceResponse>(getAcceptUrl(venueId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAcceptMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accept>>, TError,{venueId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof accept>>, TError,{venueId: string}, TContext> => {

const mutationKey = ['accept'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accept>>, {venueId: string}> = (props) => {
          const {venueId} = props ?? {};

          return  accept(venueId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptMutationResult = NonNullable<Awaited<ReturnType<typeof accept>>>

    export type AcceptMutationError = ProblemDetail

    /**
 * @summary Accept the current DPA (root/manager, R3) — records a versioned acceptance
 */
export const useAccept = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accept>>, TError,{venueId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accept>>,
        TError,
        {venueId: string},
        TContext
      > => {
      return useMutation(getAcceptMutationOptions(options), queryClient);
    }

export const getRefundUrl = (venueId: string,
    bookingRef: string,) => {




  return `/api/v1/venues/${venueId}/deposits/${bookingRef}/refund`
}

/**
 * @summary Manager full/partial refund with a mandatory reason (R6). Waiters are 403.
 */
export const refund = async (venueId: string,
    bookingRef: string,
    managerRefundRequest: ManagerRefundRequest, options?: RequestInit): Promise<RefundResponse> => {

  return customInstance<RefundResponse>(getRefundUrl(venueId,bookingRef),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(managerRefundRequest)
  }
);}




export const getRefundMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refund>>, TError,{venueId: string;bookingRef: string;data: ManagerRefundRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof refund>>, TError,{venueId: string;bookingRef: string;data: ManagerRefundRequest}, TContext> => {

const mutationKey = ['refund'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refund>>, {venueId: string;bookingRef: string;data: ManagerRefundRequest}> = (props) => {
          const {venueId,bookingRef,data} = props ?? {};

          return  refund(venueId,bookingRef,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefundMutationResult = NonNullable<Awaited<ReturnType<typeof refund>>>
    export type RefundMutationBody = ManagerRefundRequest
    export type RefundMutationError = ProblemDetail

    /**
 * @summary Manager full/partial refund with a mandatory reason (R6). Waiters are 403.
 */
export const useRefund = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refund>>, TError,{venueId: string;bookingRef: string;data: ManagerRefundRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refund>>,
        TError,
        {venueId: string;bookingRef: string;data: ManagerRefundRequest},
        TContext
      > => {
      return useMutation(getRefundMutationOptions(options), queryClient);
    }

export const getGetCustomDomainUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/custom-domain`
}

/**
 * @summary The venue's connected custom domain + verification status (null when none)
 */
export const getCustomDomain = async (venueId: string, options?: RequestInit): Promise<CustomDomainResponse> => {

  return customInstance<CustomDomainResponse>(getGetCustomDomainUrl(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomDomainQueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/custom-domain`
    ] as const;
    }


export const getGetCustomDomainQueryOptions = <TData = Awaited<ReturnType<typeof getCustomDomain>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomDomain>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomDomainQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomDomain>>> = ({ signal }) => getCustomDomain(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomDomain>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomDomainQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomDomain>>>
export type GetCustomDomainQueryError = ProblemDetail


export function useGetCustomDomain<TData = Awaited<ReturnType<typeof getCustomDomain>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomDomain>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomDomain>>,
          TError,
          Awaited<ReturnType<typeof getCustomDomain>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomDomain<TData = Awaited<ReturnType<typeof getCustomDomain>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomDomain>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomDomain>>,
          TError,
          Awaited<ReturnType<typeof getCustomDomain>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomDomain<TData = Awaited<ReturnType<typeof getCustomDomain>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomDomain>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The venue's connected custom domain + verification status (null when none)
 */

export function useGetCustomDomain<TData = Awaited<ReturnType<typeof getCustomDomain>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomDomain>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomDomainQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getConnectCustomDomainUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/custom-domain`
}

/**
 * @summary Connect a hostname — records status=pending, returns TXT + CNAME instructions (R1)
 */
export const connectCustomDomain = async (venueId: string,
    connectCustomDomainRequest: ConnectCustomDomainRequest, options?: RequestInit): Promise<CustomDomainResponse> => {

  return customInstance<CustomDomainResponse>(getConnectCustomDomainUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(connectCustomDomainRequest)
  }
);}




export const getConnectCustomDomainMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectCustomDomain>>, TError,{venueId: string;data: ConnectCustomDomainRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof connectCustomDomain>>, TError,{venueId: string;data: ConnectCustomDomainRequest}, TContext> => {

const mutationKey = ['connectCustomDomain'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectCustomDomain>>, {venueId: string;data: ConnectCustomDomainRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  connectCustomDomain(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConnectCustomDomainMutationResult = NonNullable<Awaited<ReturnType<typeof connectCustomDomain>>>
    export type ConnectCustomDomainMutationBody = ConnectCustomDomainRequest
    export type ConnectCustomDomainMutationError = ProblemDetail

    /**
 * @summary Connect a hostname — records status=pending, returns TXT + CNAME instructions (R1)
 */
export const useConnectCustomDomain = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectCustomDomain>>, TError,{venueId: string;data: ConnectCustomDomainRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof connectCustomDomain>>,
        TError,
        {venueId: string;data: ConnectCustomDomainRequest},
        TContext
      > => {
      return useMutation(getConnectCustomDomainMutationOptions(options), queryClient);
    }

export const getDisconnectCustomDomainUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/custom-domain`
}

/**
 * @summary Disconnect — deletes the CF hostname + KV key; subdomain endures (R2)
 */
export const disconnectCustomDomain = async (venueId: string, options?: RequestInit): Promise<void> => {

  return customInstance<void>(getDisconnectCustomDomainUrl(venueId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDisconnectCustomDomainMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectCustomDomain>>, TError,{venueId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectCustomDomain>>, TError,{venueId: string}, TContext> => {

const mutationKey = ['disconnectCustomDomain'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectCustomDomain>>, {venueId: string}> = (props) => {
          const {venueId} = props ?? {};

          return  disconnectCustomDomain(venueId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectCustomDomainMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectCustomDomain>>>

    export type DisconnectCustomDomainMutationError = ProblemDetail

    /**
 * @summary Disconnect — deletes the CF hostname + KV key; subdomain endures (R2)
 */
export const useDisconnectCustomDomain = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectCustomDomain>>, TError,{venueId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disconnectCustomDomain>>,
        TError,
        {venueId: string},
        TContext
      > => {
      return useMutation(getDisconnectCustomDomainMutationOptions(options), queryClient);
    }

export const getGrantBreakGlassUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/break-glass`
}

/**
 * @summary Account-root break-glass grant — time-boxed, reason mandatory (R10)
 */
export const grantBreakGlass = async (venueId: string,
    breakGlassRequest: BreakGlassRequest, options?: RequestInit): Promise<BreakGlassResponse> => {

  return customInstance<BreakGlassResponse>(getGrantBreakGlassUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(breakGlassRequest)
  }
);}




export const getGrantBreakGlassMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof grantBreakGlass>>, TError,{venueId: string;data: BreakGlassRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof grantBreakGlass>>, TError,{venueId: string;data: BreakGlassRequest}, TContext> => {

const mutationKey = ['grantBreakGlass'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof grantBreakGlass>>, {venueId: string;data: BreakGlassRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  grantBreakGlass(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GrantBreakGlassMutationResult = NonNullable<Awaited<ReturnType<typeof grantBreakGlass>>>
    export type GrantBreakGlassMutationBody = BreakGlassRequest
    export type GrantBreakGlassMutationError = ProblemDetail

    /**
 * @summary Account-root break-glass grant — time-boxed, reason mandatory (R10)
 */
export const useGrantBreakGlass = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof grantBreakGlass>>, TError,{venueId: string;data: BreakGlassRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof grantBreakGlass>>,
        TError,
        {venueId: string;data: BreakGlassRequest},
        TContext
      > => {
      return useMutation(getGrantBreakGlassMutationOptions(options), queryClient);
    }

export const getList4Url = (venueId: string,
    params?: List4Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/venues/${venueId}/bookings?${stringifiedParams}` : `/api/v1/venues/${venueId}/bookings`
}

/**
 * @summary List/search bookings (cursor pagination, ADR-0022; narrowing-filter guarded)
 */
export const list4 = async (venueId: string,
    params?: List4Params, options?: RequestInit): Promise<PageResponseStaffBookingSummaryResponse> => {

  return customInstance<PageResponseStaffBookingSummaryResponse>(getList4Url(venueId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getList4QueryKey = (venueId: string,
    params?: List4Params,) => {
    return [
    `/api/v1/venues/${venueId}/bookings`, ...(params ? [params] : [])
    ] as const;
    }


export const getList4QueryOptions = <TData = Awaited<ReturnType<typeof list4>>, TError = ProblemDetail>(venueId: string,
    params?: List4Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list4>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getList4QueryKey(venueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof list4>>> = ({ signal }) => list4(venueId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof list4>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type List4QueryResult = NonNullable<Awaited<ReturnType<typeof list4>>>
export type List4QueryError = ProblemDetail


export function useList4<TData = Awaited<ReturnType<typeof list4>>, TError = ProblemDetail>(
 venueId: string,
    params: undefined |  List4Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof list4>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof list4>>,
          TError,
          Awaited<ReturnType<typeof list4>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useList4<TData = Awaited<ReturnType<typeof list4>>, TError = ProblemDetail>(
 venueId: string,
    params?: List4Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list4>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof list4>>,
          TError,
          Awaited<ReturnType<typeof list4>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useList4<TData = Awaited<ReturnType<typeof list4>>, TError = ProblemDetail>(
 venueId: string,
    params?: List4Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list4>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List/search bookings (cursor pagination, ADR-0022; narrowing-filter guarded)
 */

export function useList4<TData = Awaited<ReturnType<typeof list4>>, TError = ProblemDetail>(
 venueId: string,
    params?: List4Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list4>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getList4QueryOptions(venueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateStaffBookingUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/bookings`
}

/**
 * @summary Staff manual/phone entry — PHONE|WALK_IN, created CONFIRMED (or SEATED walk-in)
 */
export const createStaffBooking = async (venueId: string,
    staffCreateBookingRequest: StaffCreateBookingRequest, options?: RequestInit): Promise<StaffBookingResponse> => {

  return customInstance<StaffBookingResponse>(getCreateStaffBookingUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(staffCreateBookingRequest)
  }
);}




export const getCreateStaffBookingMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStaffBooking>>, TError,{venueId: string;data: StaffCreateBookingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createStaffBooking>>, TError,{venueId: string;data: StaffCreateBookingRequest}, TContext> => {

const mutationKey = ['createStaffBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStaffBooking>>, {venueId: string;data: StaffCreateBookingRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  createStaffBooking(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateStaffBookingMutationResult = NonNullable<Awaited<ReturnType<typeof createStaffBooking>>>
    export type CreateStaffBookingMutationBody = StaffCreateBookingRequest
    export type CreateStaffBookingMutationError = ProblemDetail

    /**
 * @summary Staff manual/phone entry — PHONE|WALK_IN, created CONFIRMED (or SEATED walk-in)
 */
export const useCreateStaffBooking = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStaffBooking>>, TError,{venueId: string;data: StaffCreateBookingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createStaffBooking>>,
        TError,
        {venueId: string;data: StaffCreateBookingRequest},
        TContext
      > => {
      return useMutation(getCreateStaffBookingMutationOptions(options), queryClient);
    }

export const getDecline1Url = (venueId: string,
    bookingId: string,) => {




  return `/api/v1/venues/${venueId}/bookings/${bookingId}/request/decline`
}

/**
 * @summary Decline a PENDING request — releases the hold; optional reason + live-checked proposed alternative
 */
export const decline1 = async (venueId: string,
    bookingId: string,
    declineRequestBody: DeclineRequestBody, options?: RequestInit): Promise<StaffBookingResponse> => {

  return customInstance<StaffBookingResponse>(getDecline1Url(venueId,bookingId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(declineRequestBody)
  }
);}




export const getDecline1MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof decline1>>, TError,{venueId: string;bookingId: string;data: DeclineRequestBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof decline1>>, TError,{venueId: string;bookingId: string;data: DeclineRequestBody}, TContext> => {

const mutationKey = ['decline1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof decline1>>, {venueId: string;bookingId: string;data: DeclineRequestBody}> = (props) => {
          const {venueId,bookingId,data} = props ?? {};

          return  decline1(venueId,bookingId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type Decline1MutationResult = NonNullable<Awaited<ReturnType<typeof decline1>>>
    export type Decline1MutationBody = DeclineRequestBody
    export type Decline1MutationError = ProblemDetail

    /**
 * @summary Decline a PENDING request — releases the hold; optional reason + live-checked proposed alternative
 */
export const useDecline1 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof decline1>>, TError,{venueId: string;bookingId: string;data: DeclineRequestBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof decline1>>,
        TError,
        {venueId: string;bookingId: string;data: DeclineRequestBody},
        TContext
      > => {
      return useMutation(getDecline1MutationOptions(options), queryClient);
    }

export const getApproveUrl = (venueId: string,
    bookingId: string,) => {




  return `/api/v1/venues/${venueId}/bookings/${bookingId}/request/approve`
}

/**
 * @summary Approve a PENDING request — re-passes the atomic claim (R6); 409 + current on a conflicting decision
 */
export const approve = async (venueId: string,
    bookingId: string,
    approveRequestBody: ApproveRequestBody, options?: RequestInit): Promise<StaffBookingResponse> => {

  return customInstance<StaffBookingResponse>(getApproveUrl(venueId,bookingId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(approveRequestBody)
  }
);}




export const getApproveMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approve>>, TError,{venueId: string;bookingId: string;data: ApproveRequestBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof approve>>, TError,{venueId: string;bookingId: string;data: ApproveRequestBody}, TContext> => {

const mutationKey = ['approve'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approve>>, {venueId: string;bookingId: string;data: ApproveRequestBody}> = (props) => {
          const {venueId,bookingId,data} = props ?? {};

          return  approve(venueId,bookingId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveMutationResult = NonNullable<Awaited<ReturnType<typeof approve>>>
    export type ApproveMutationBody = ApproveRequestBody
    export type ApproveMutationError = ProblemDetail

    /**
 * @summary Approve a PENDING request — re-passes the atomic claim (R6); 409 + current on a conflicting decision
 */
export const useApprove = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approve>>, TError,{venueId: string;bookingId: string;data: ApproveRequestBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approve>>,
        TError,
        {venueId: string;bookingId: string;data: ApproveRequestBody},
        TContext
      > => {
      return useMutation(getApproveMutationOptions(options), queryClient);
    }

export const getRefund1Url = (venueId: string,
    bookingId: string,) => {




  return `/api/v1/venues/${venueId}/bookings/${bookingId}/guarantee/refund`
}

/**
 * @summary Refund a wrongly-triggered charge via billing's refund path; paymentStatus → REFUNDED
 */
export const refund1 = async (venueId: string,
    bookingId: string,
    refundGuaranteeRequest: RefundGuaranteeRequest, options?: RequestInit): Promise<Refund1200> => {

  return customInstance<Refund1200>(getRefund1Url(venueId,bookingId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(refundGuaranteeRequest)
  }
);}




export const getRefund1MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refund1>>, TError,{venueId: string;bookingId: string;data: RefundGuaranteeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof refund1>>, TError,{venueId: string;bookingId: string;data: RefundGuaranteeRequest}, TContext> => {

const mutationKey = ['refund1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refund1>>, {venueId: string;bookingId: string;data: RefundGuaranteeRequest}> = (props) => {
          const {venueId,bookingId,data} = props ?? {};

          return  refund1(venueId,bookingId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type Refund1MutationResult = NonNullable<Awaited<ReturnType<typeof refund1>>>
    export type Refund1MutationBody = RefundGuaranteeRequest
    export type Refund1MutationError = ProblemDetail

    /**
 * @summary Refund a wrongly-triggered charge via billing's refund path; paymentStatus → REFUNDED
 */
export const useRefund1 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refund1>>, TError,{venueId: string;bookingId: string;data: RefundGuaranteeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refund1>>,
        TError,
        {venueId: string;bookingId: string;data: RefundGuaranteeRequest},
        TContext
      > => {
      return useMutation(getRefund1MutationOptions(options), queryClient);
    }

export const getChargeUrl = (venueId: string,
    bookingId: string,) => {




  return `/api/v1/venues/${venueId}/bookings/${bookingId}/guarantee/charge`
}

/**
 * @summary Manager-confirmed no-show charge (R4/R6): snapshot amount only, single-charge guard
 */
export const charge = async (venueId: string,
    bookingId: string, options?: RequestInit): Promise<Charge200> => {

  return customInstance<Charge200>(getChargeUrl(venueId,bookingId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getChargeMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof charge>>, TError,{venueId: string;bookingId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof charge>>, TError,{venueId: string;bookingId: string}, TContext> => {

const mutationKey = ['charge'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof charge>>, {venueId: string;bookingId: string}> = (props) => {
          const {venueId,bookingId} = props ?? {};

          return  charge(venueId,bookingId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChargeMutationResult = NonNullable<Awaited<ReturnType<typeof charge>>>

    export type ChargeMutationError = ProblemDetail

    /**
 * @summary Manager-confirmed no-show charge (R4/R6): snapshot amount only, single-charge guard
 */
export const useCharge = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof charge>>, TError,{venueId: string;bookingId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof charge>>,
        TError,
        {venueId: string;bookingId: string},
        TContext
      > => {
      return useMutation(getChargeMutationOptions(options), queryClient);
    }

export const getCancel1Url = (venueId: string,
    bookingId: string,) => {




  return `/api/v1/venues/${venueId}/bookings/${bookingId}/cancel`
}

/**
 * @summary Cancel — waiter cancel of a CONFIRMED booking requires a manager step-up (ST-4/BK-8)
 */
export const cancel1 = async (venueId: string,
    bookingId: string,
    staffCancelBookingRequest: StaffCancelBookingRequest, options?: RequestInit): Promise<StaffBookingResponse> => {

  return customInstance<StaffBookingResponse>(getCancel1Url(venueId,bookingId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(staffCancelBookingRequest)
  }
);}




export const getCancel1MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancel1>>, TError,{venueId: string;bookingId: string;data: StaffCancelBookingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancel1>>, TError,{venueId: string;bookingId: string;data: StaffCancelBookingRequest}, TContext> => {

const mutationKey = ['cancel1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancel1>>, {venueId: string;bookingId: string;data: StaffCancelBookingRequest}> = (props) => {
          const {venueId,bookingId,data} = props ?? {};

          return  cancel1(venueId,bookingId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type Cancel1MutationResult = NonNullable<Awaited<ReturnType<typeof cancel1>>>
    export type Cancel1MutationBody = StaffCancelBookingRequest
    export type Cancel1MutationError = ProblemDetail

    /**
 * @summary Cancel — waiter cancel of a CONFIRMED booking requires a manager step-up (ST-4/BK-8)
 */
export const useCancel1 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancel1>>, TError,{venueId: string;bookingId: string;data: StaffCancelBookingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancel1>>,
        TError,
        {venueId: string;bookingId: string;data: StaffCancelBookingRequest},
        TContext
      > => {
      return useMutation(getCancel1MutationOptions(options), queryClient);
    }

export const getList5Url = (venueId: string,
    params?: List5Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/venues/${venueId}/blacklist?${stringifiedParams}` : `/api/v1/venues/${venueId}/blacklist`
}

/**
 * @summary List the venue's blacklist entries (manager-only, R5)
 */
export const list5 = async (venueId: string,
    params?: List5Params, options?: RequestInit): Promise<BlacklistEntryResponse[]> => {

  return customInstance<BlacklistEntryResponse[]>(getList5Url(venueId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getList5QueryKey = (venueId: string,
    params?: List5Params,) => {
    return [
    `/api/v1/venues/${venueId}/blacklist`, ...(params ? [params] : [])
    ] as const;
    }


export const getList5QueryOptions = <TData = Awaited<ReturnType<typeof list5>>, TError = ProblemDetail>(venueId: string,
    params?: List5Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list5>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getList5QueryKey(venueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof list5>>> = ({ signal }) => list5(venueId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof list5>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type List5QueryResult = NonNullable<Awaited<ReturnType<typeof list5>>>
export type List5QueryError = ProblemDetail


export function useList5<TData = Awaited<ReturnType<typeof list5>>, TError = ProblemDetail>(
 venueId: string,
    params: undefined |  List5Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof list5>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof list5>>,
          TError,
          Awaited<ReturnType<typeof list5>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useList5<TData = Awaited<ReturnType<typeof list5>>, TError = ProblemDetail>(
 venueId: string,
    params?: List5Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list5>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof list5>>,
          TError,
          Awaited<ReturnType<typeof list5>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useList5<TData = Awaited<ReturnType<typeof list5>>, TError = ProblemDetail>(
 venueId: string,
    params?: List5Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list5>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the venue's blacklist entries (manager-only, R5)
 */

export function useList5<TData = Awaited<ReturnType<typeof list5>>, TError = ProblemDetail>(
 venueId: string,
    params?: List5Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list5>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getList5QueryOptions(venueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateBlacklistEntryUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/blacklist`
}

/**
 * @summary Create an entry (reason mandatory, R2). NAME_ONLY → FLAG unless escalated
 */
export const createBlacklistEntry = async (venueId: string,
    createBlacklistRequest: CreateBlacklistRequest, options?: RequestInit): Promise<BlacklistEntryResponse> => {

  return customInstance<BlacklistEntryResponse>(getCreateBlacklistEntryUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createBlacklistRequest)
  }
);}




export const getCreateBlacklistEntryMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBlacklistEntry>>, TError,{venueId: string;data: CreateBlacklistRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createBlacklistEntry>>, TError,{venueId: string;data: CreateBlacklistRequest}, TContext> => {

const mutationKey = ['createBlacklistEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBlacklistEntry>>, {venueId: string;data: CreateBlacklistRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  createBlacklistEntry(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBlacklistEntryMutationResult = NonNullable<Awaited<ReturnType<typeof createBlacklistEntry>>>
    export type CreateBlacklistEntryMutationBody = CreateBlacklistRequest
    export type CreateBlacklistEntryMutationError = ProblemDetail

    /**
 * @summary Create an entry (reason mandatory, R2). NAME_ONLY → FLAG unless escalated
 */
export const useCreateBlacklistEntry = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBlacklistEntry>>, TError,{venueId: string;data: CreateBlacklistRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBlacklistEntry>>,
        TError,
        {venueId: string;data: CreateBlacklistRequest},
        TContext
      > => {
      return useMutation(getCreateBlacklistEntryMutationOptions(options), queryClient);
    }

export const getRenewUrl = (venueId: string,
    entryId: string,) => {




  return `/api/v1/venues/${venueId}/blacklist/${entryId}/renew`
}

/**
 * @summary Reasoned renewal (GU-3): a blank reason → 400
 */
export const renew = async (venueId: string,
    entryId: string,
    renewRequest: RenewRequest, options?: RequestInit): Promise<BlacklistEntryResponse> => {

  return customInstance<BlacklistEntryResponse>(getRenewUrl(venueId,entryId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(renewRequest)
  }
);}




export const getRenewMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renew>>, TError,{venueId: string;entryId: string;data: RenewRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof renew>>, TError,{venueId: string;entryId: string;data: RenewRequest}, TContext> => {

const mutationKey = ['renew'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renew>>, {venueId: string;entryId: string;data: RenewRequest}> = (props) => {
          const {venueId,entryId,data} = props ?? {};

          return  renew(venueId,entryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RenewMutationResult = NonNullable<Awaited<ReturnType<typeof renew>>>
    export type RenewMutationBody = RenewRequest
    export type RenewMutationError = ProblemDetail

    /**
 * @summary Reasoned renewal (GU-3): a blank reason → 400
 */
export const useRenew = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renew>>, TError,{venueId: string;entryId: string;data: RenewRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof renew>>,
        TError,
        {venueId: string;entryId: string;data: RenewRequest},
        TContext
      > => {
      return useMutation(getRenewMutationOptions(options), queryClient);
    }

export const getOverrideUrl = (venueId: string,
    entryId: string,) => {




  return `/api/v1/venues/${venueId}/blacklist/${entryId}/override`
}

/**
 * @summary One-shot override (R8/GU-5): behind @RequiresStepUp(BLACKLIST_OVERRIDE); entry unchanged
 */
export const override = async (venueId: string,
    entryId: string,
    overrideRequest: OverrideRequest, options?: RequestInit): Promise<OverrideResponse> => {

  return customInstance<OverrideResponse>(getOverrideUrl(venueId,entryId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(overrideRequest)
  }
);}




export const getOverrideMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof override>>, TError,{venueId: string;entryId: string;data: OverrideRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof override>>, TError,{venueId: string;entryId: string;data: OverrideRequest}, TContext> => {

const mutationKey = ['override'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof override>>, {venueId: string;entryId: string;data: OverrideRequest}> = (props) => {
          const {venueId,entryId,data} = props ?? {};

          return  override(venueId,entryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OverrideMutationResult = NonNullable<Awaited<ReturnType<typeof override>>>
    export type OverrideMutationBody = OverrideRequest
    export type OverrideMutationError = ProblemDetail

    /**
 * @summary One-shot override (R8/GU-5): behind @RequiresStepUp(BLACKLIST_OVERRIDE); entry unchanged
 */
export const useOverride = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof override>>, TError,{venueId: string;entryId: string;data: OverrideRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof override>>,
        TError,
        {venueId: string;entryId: string;data: OverrideRequest},
        TContext
      > => {
      return useMutation(getOverrideMutationOptions(options), queryClient);
    }

export const getRecordAppealUrl = (venueId: string,
    entryId: string,) => {




  return `/api/v1/venues/${venueId}/blacklist/${entryId}/appeals`
}

/**
 * @summary Record a guest appeal (OPEN)
 */
export const recordAppeal = async (venueId: string,
    entryId: string,
    recordAppealRequest: RecordAppealRequest, options?: RequestInit): Promise<BlacklistEntryResponse> => {

  return customInstance<BlacklistEntryResponse>(getRecordAppealUrl(venueId,entryId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(recordAppealRequest)
  }
);}




export const getRecordAppealMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordAppeal>>, TError,{venueId: string;entryId: string;data: RecordAppealRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof recordAppeal>>, TError,{venueId: string;entryId: string;data: RecordAppealRequest}, TContext> => {

const mutationKey = ['recordAppeal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordAppeal>>, {venueId: string;entryId: string;data: RecordAppealRequest}> = (props) => {
          const {venueId,entryId,data} = props ?? {};

          return  recordAppeal(venueId,entryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordAppealMutationResult = NonNullable<Awaited<ReturnType<typeof recordAppeal>>>
    export type RecordAppealMutationBody = RecordAppealRequest
    export type RecordAppealMutationError = ProblemDetail

    /**
 * @summary Record a guest appeal (OPEN)
 */
export const useRecordAppeal = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordAppeal>>, TError,{venueId: string;entryId: string;data: RecordAppealRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordAppeal>>,
        TError,
        {venueId: string;entryId: string;data: RecordAppealRequest},
        TContext
      > => {
      return useMutation(getRecordAppealMutationOptions(options), queryClient);
    }

export const getDecideAppealUrl = (venueId: string,
    entryId: string,
    appealId: string,) => {




  return `/api/v1/venues/${venueId}/blacklist/${entryId}/appeals/${appealId}/decision`
}

/**
 * @summary Decide an appeal UPHELD | REMOVED with decider + timestamp (R7)
 */
export const decideAppeal = async (venueId: string,
    entryId: string,
    appealId: string,
    decideAppealRequest: DecideAppealRequest, options?: RequestInit): Promise<BlacklistEntryResponse> => {

  return customInstance<BlacklistEntryResponse>(getDecideAppealUrl(venueId,entryId,appealId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(decideAppealRequest)
  }
);}




export const getDecideAppealMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof decideAppeal>>, TError,{venueId: string;entryId: string;appealId: string;data: DecideAppealRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof decideAppeal>>, TError,{venueId: string;entryId: string;appealId: string;data: DecideAppealRequest}, TContext> => {

const mutationKey = ['decideAppeal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof decideAppeal>>, {venueId: string;entryId: string;appealId: string;data: DecideAppealRequest}> = (props) => {
          const {venueId,entryId,appealId,data} = props ?? {};

          return  decideAppeal(venueId,entryId,appealId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DecideAppealMutationResult = NonNullable<Awaited<ReturnType<typeof decideAppeal>>>
    export type DecideAppealMutationBody = DecideAppealRequest
    export type DecideAppealMutationError = ProblemDetail

    /**
 * @summary Decide an appeal UPHELD | REMOVED with decider + timestamp (R7)
 */
export const useDecideAppeal = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof decideAppeal>>, TError,{venueId: string;entryId: string;appealId: string;data: DecideAppealRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof decideAppeal>>,
        TError,
        {venueId: string;entryId: string;appealId: string;data: DecideAppealRequest},
        TContext
      > => {
      return useMutation(getDecideAppealMutationOptions(options), queryClient);
    }

export const getClearUrl = (venueId: string,
    blockId: string,) => {




  return `/api/v1/venues/${venueId}/abuse-blocks/${blockId}/clear`
}

/**
 * @summary Clear a wrongly-flagged block — the next submission passes; audited to the activity log (CP-6)
 */
export const clear = async (venueId: string,
    blockId: string, options?: RequestInit): Promise<AbuseBlockResponse> => {

  return customInstance<AbuseBlockResponse>(getClearUrl(venueId,blockId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getClearMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clear>>, TError,{venueId: string;blockId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof clear>>, TError,{venueId: string;blockId: string}, TContext> => {

const mutationKey = ['clear'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clear>>, {venueId: string;blockId: string}> = (props) => {
          const {venueId,blockId} = props ?? {};

          return  clear(venueId,blockId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearMutationResult = NonNullable<Awaited<ReturnType<typeof clear>>>

    export type ClearMutationError = ProblemDetail

    /**
 * @summary Clear a wrongly-flagged block — the next submission passes; audited to the activity log (CP-6)
 */
export const useClear = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clear>>, TError,{venueId: string;blockId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clear>>,
        TError,
        {venueId: string;blockId: string},
        TContext
      > => {
      return useMutation(getClearMutationOptions(options), queryClient);
    }

export const getRenameSlugUrl = (id: string,) => {




  return `/api/v1/venues/${id}/slug`
}

/**
 * @summary Change a venue's slug — 90-day 301 redirect grace (R7); merchant id unchanged (TN-4)
 */
export const renameSlug = async (id: string,
    renameSlugRequest: RenameSlugRequest, options?: RequestInit): Promise<VenueResponse> => {

  return customInstance<VenueResponse>(getRenameSlugUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(renameSlugRequest)
  }
);}




export const getRenameSlugMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameSlug>>, TError,{id: string;data: RenameSlugRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof renameSlug>>, TError,{id: string;data: RenameSlugRequest}, TContext> => {

const mutationKey = ['renameSlug'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renameSlug>>, {id: string;data: RenameSlugRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  renameSlug(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RenameSlugMutationResult = NonNullable<Awaited<ReturnType<typeof renameSlug>>>
    export type RenameSlugMutationBody = RenameSlugRequest
    export type RenameSlugMutationError = ProblemDetail

    /**
 * @summary Change a venue's slug — 90-day 301 redirect grace (R7); merchant id unchanged (TN-4)
 */
export const useRenameSlug = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameSlug>>, TError,{id: string;data: RenameSlugRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof renameSlug>>,
        TError,
        {id: string;data: RenameSlugRequest},
        TContext
      > => {
      return useMutation(getRenameSlugMutationOptions(options), queryClient);
    }

export const getOffboardUrl = (id: string,) => {




  return `/api/v1/venues/${id}/offboard`
}

/**
 * @summary Offboard a venue — export gate then deprovision + cooldown (R6/TN-6/TN-8)
 */
export const offboard = async (id: string,
    offboardRequest: OffboardRequest, options?: RequestInit): Promise<OffboardResponse> => {

  return customInstance<OffboardResponse>(getOffboardUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(offboardRequest)
  }
);}




export const getOffboardMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offboard>>, TError,{id: string;data: OffboardRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof offboard>>, TError,{id: string;data: OffboardRequest}, TContext> => {

const mutationKey = ['offboard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offboard>>, {id: string;data: OffboardRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  offboard(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OffboardMutationResult = NonNullable<Awaited<ReturnType<typeof offboard>>>
    export type OffboardMutationBody = OffboardRequest
    export type OffboardMutationError = ProblemDetail

    /**
 * @summary Offboard a venue — export gate then deprovision + cooldown (R6/TN-6/TN-8)
 */
export const useOffboard = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offboard>>, TError,{id: string;data: OffboardRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof offboard>>,
        TError,
        {id: string;data: OffboardRequest},
        TContext
      > => {
      return useMutation(getOffboardMutationOptions(options), queryClient);
    }

export const getThreadsUrl = (params?: ThreadsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/support/threads?${stringifiedParams}` : `/api/v1/support/threads`
}

export const threads = async (params?: ThreadsParams, options?: RequestInit): Promise<PageDtoSupportThreadDto> => {

  return customInstance<PageDtoSupportThreadDto>(getThreadsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getThreadsQueryKey = (params?: ThreadsParams,) => {
    return [
    `/api/v1/support/threads`, ...(params ? [params] : [])
    ] as const;
    }


export const getThreadsQueryOptions = <TData = Awaited<ReturnType<typeof threads>>, TError = ProblemDetail>(params?: ThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof threads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getThreadsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof threads>>> = ({ signal }) => threads(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof threads>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ThreadsQueryResult = NonNullable<Awaited<ReturnType<typeof threads>>>
export type ThreadsQueryError = ProblemDetail


export function useThreads<TData = Awaited<ReturnType<typeof threads>>, TError = ProblemDetail>(
 params: undefined |  ThreadsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof threads>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof threads>>,
          TError,
          Awaited<ReturnType<typeof threads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useThreads<TData = Awaited<ReturnType<typeof threads>>, TError = ProblemDetail>(
 params?: ThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof threads>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof threads>>,
          TError,
          Awaited<ReturnType<typeof threads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useThreads<TData = Awaited<ReturnType<typeof threads>>, TError = ProblemDetail>(
 params?: ThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof threads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useThreads<TData = Awaited<ReturnType<typeof threads>>, TError = ProblemDetail>(
 params?: ThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof threads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getThreadsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateUrl = () => {




  return `/api/v1/support/threads`
}

export const create = async (createThreadRequest: CreateThreadRequest, options?: RequestInit): Promise<SupportThreadDto> => {

  return customInstance<SupportThreadDto>(getCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createThreadRequest)
  }
);}




export const getCreateMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof create>>, TError,{data: CreateThreadRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof create>>, TError,{data: CreateThreadRequest}, TContext> => {

const mutationKey = ['create'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof create>>, {data: CreateThreadRequest}> = (props) => {
          const {data} = props ?? {};

          return  create(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMutationResult = NonNullable<Awaited<ReturnType<typeof create>>>
    export type CreateMutationBody = CreateThreadRequest
    export type CreateMutationError = ProblemDetail

    export const useCreate = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof create>>, TError,{data: CreateThreadRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof create>>,
        TError,
        {data: CreateThreadRequest},
        TContext
      > => {
      return useMutation(getCreateMutationOptions(options), queryClient);
    }

export const getMessagesUrl = (threadId: string,
    params?: MessagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/support/threads/${threadId}/messages?${stringifiedParams}` : `/api/v1/support/threads/${threadId}/messages`
}

export const messages = async (threadId: string,
    params?: MessagesParams, options?: RequestInit): Promise<PageDtoSupportMessageDto> => {

  return customInstance<PageDtoSupportMessageDto>(getMessagesUrl(threadId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMessagesQueryKey = (threadId: string,
    params?: MessagesParams,) => {
    return [
    `/api/v1/support/threads/${threadId}/messages`, ...(params ? [params] : [])
    ] as const;
    }


export const getMessagesQueryOptions = <TData = Awaited<ReturnType<typeof messages>>, TError = ProblemDetail>(threadId: string,
    params?: MessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagesQueryKey(threadId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messages>>> = ({ signal }) => messages(threadId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: threadId !== null && threadId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MessagesQueryResult = NonNullable<Awaited<ReturnType<typeof messages>>>
export type MessagesQueryError = ProblemDetail


export function useMessages<TData = Awaited<ReturnType<typeof messages>>, TError = ProblemDetail>(
 threadId: string,
    params: undefined |  MessagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof messages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messages>>,
          TError,
          Awaited<ReturnType<typeof messages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessages<TData = Awaited<ReturnType<typeof messages>>, TError = ProblemDetail>(
 threadId: string,
    params?: MessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messages>>,
          TError,
          Awaited<ReturnType<typeof messages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessages<TData = Awaited<ReturnType<typeof messages>>, TError = ProblemDetail>(
 threadId: string,
    params?: MessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMessages<TData = Awaited<ReturnType<typeof messages>>, TError = ProblemDetail>(
 threadId: string,
    params?: MessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessagesQueryOptions(threadId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getPostUrl = (threadId: string,) => {




  return `/api/v1/support/threads/${threadId}/messages`
}

export const post = async (threadId: string,
    supportMessageRequest: SupportMessageRequest, options?: RequestInit): Promise<SupportThreadDto> => {

  return customInstance<SupportThreadDto>(getPostUrl(threadId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(supportMessageRequest)
  }
);}




export const getPostMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof post>>, TError,{threadId: string;data: SupportMessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof post>>, TError,{threadId: string;data: SupportMessageRequest}, TContext> => {

const mutationKey = ['post'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof post>>, {threadId: string;data: SupportMessageRequest}> = (props) => {
          const {threadId,data} = props ?? {};

          return  post(threadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostMutationResult = NonNullable<Awaited<ReturnType<typeof post>>>
    export type PostMutationBody = SupportMessageRequest
    export type PostMutationError = ProblemDetail

    export const usePost = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof post>>, TError,{threadId: string;data: SupportMessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof post>>,
        TError,
        {threadId: string;data: SupportMessageRequest},
        TContext
      > => {
      return useMutation(getPostMutationOptions(options), queryClient);
    }

export const getForcePasswordResetUrl = (userId: string,) => {




  return `/api/v1/staff/${userId}/force-password-reset`
}

/**
 * @summary Force a password reset (only the newest link works — ends live sessions, ST-3)
 */
export const forcePasswordReset = async (userId: string, options?: RequestInit): Promise<DeactivateResponse> => {

  return customInstance<DeactivateResponse>(getForcePasswordResetUrl(userId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getForcePasswordResetMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forcePasswordReset>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof forcePasswordReset>>, TError,{userId: string}, TContext> => {

const mutationKey = ['forcePasswordReset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof forcePasswordReset>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  forcePasswordReset(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ForcePasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof forcePasswordReset>>>

    export type ForcePasswordResetMutationError = ProblemDetail

    /**
 * @summary Force a password reset (only the newest link works — ends live sessions, ST-3)
 */
export const useForcePasswordReset = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forcePasswordReset>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof forcePasswordReset>>,
        TError,
        {userId: string},
        TContext
      > => {
      return useMutation(getForcePasswordResetMutationOptions(options), queryClient);
    }

export const getDeactivateUrl = (userId: string,) => {




  return `/api/v1/staff/${userId}/deactivate`
}

/**
 * @summary Account-wide removal — revokes sessions + PINs + device sessions (ST-2/ST-3)
 */
export const deactivate = async (userId: string, options?: RequestInit): Promise<DeactivateResponse> => {

  return customInstance<DeactivateResponse>(getDeactivateUrl(userId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getDeactivateMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivate>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deactivate>>, TError,{userId: string}, TContext> => {

const mutationKey = ['deactivate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivate>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  deactivate(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeactivateMutationResult = NonNullable<Awaited<ReturnType<typeof deactivate>>>

    export type DeactivateMutationError = ProblemDetail

    /**
 * @summary Account-wide removal — revokes sessions + PINs + device sessions (ST-2/ST-3)
 */
export const useDeactivate = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivate>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deactivate>>,
        TError,
        {userId: string},
        TContext
      > => {
      return useMutation(getDeactivateMutationOptions(options), queryClient);
    }

export const getActivateUrl = () => {




  return `/api/v1/staff/invites/activate`
}

export const activate = async (activateInviteRequest: ActivateInviteRequest, options?: RequestInit): Promise<ActivateInviteResponse> => {

  return customInstance<ActivateInviteResponse>(getActivateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(activateInviteRequest)
  }
);}




export const getActivateMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activate>>, TError,{data: ActivateInviteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activate>>, TError,{data: ActivateInviteRequest}, TContext> => {

const mutationKey = ['activate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activate>>, {data: ActivateInviteRequest}> = (props) => {
          const {data} = props ?? {};

          return  activate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivateMutationResult = NonNullable<Awaited<ReturnType<typeof activate>>>
    export type ActivateMutationBody = ActivateInviteRequest
    export type ActivateMutationError = ProblemDetail

    export const useActivate = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activate>>, TError,{data: ActivateInviteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activate>>,
        TError,
        {data: ActivateInviteRequest},
        TContext
      > => {
      return useMutation(getActivateMutationOptions(options), queryClient);
    }

export const getAccept1Url = () => {




  return `/api/v1/staff/invites/accept`
}

/**
 * @summary Accept an invite: provision identity + assignments (fails if all venues gone)
 */
export const accept1 = async (acceptInviteRequest: AcceptInviteRequest, options?: RequestInit): Promise<DeactivateResponse> => {

  return customInstance<DeactivateResponse>(getAccept1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(acceptInviteRequest)
  }
);}




export const getAccept1MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accept1>>, TError,{data: AcceptInviteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof accept1>>, TError,{data: AcceptInviteRequest}, TContext> => {

const mutationKey = ['accept1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accept1>>, {data: AcceptInviteRequest}> = (props) => {
          const {data} = props ?? {};

          return  accept1(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type Accept1MutationResult = NonNullable<Awaited<ReturnType<typeof accept1>>>
    export type Accept1MutationBody = AcceptInviteRequest
    export type Accept1MutationError = ProblemDetail

    /**
 * @summary Accept an invite: provision identity + assignments (fails if all venues gone)
 */
export const useAccept1 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accept1>>, TError,{data: AcceptInviteRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accept1>>,
        TError,
        {data: AcceptInviteRequest},
        TContext
      > => {
      return useMutation(getAccept1MutationOptions(options), queryClient);
    }

export const getSignupUrl = () => {




  return `/api/v1/signup`
}

/**
 * @summary Provision a new account + root identity (public — no token yet)
 */
export const signup = async (signupRequest: SignupRequest, options?: RequestInit): Promise<SignupResponse> => {

  return customInstance<SignupResponse>(getSignupUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(signupRequest)
  }
);}




export const getSignupMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,{data: SignupRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,{data: SignupRequest}, TContext> => {

const mutationKey = ['signup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signup>>, {data: SignupRequest}> = (props) => {
          const {data} = props ?? {};

          return  signup(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SignupMutationResult = NonNullable<Awaited<ReturnType<typeof signup>>>
    export type SignupMutationBody = SignupRequest
    export type SignupMutationError = ProblemDetail

    /**
 * @summary Provision a new account + root identity (public — no token yet)
 */
export const useSignup = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,{data: SignupRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof signup>>,
        TError,
        {data: SignupRequest},
        TContext
      > => {
      return useMutation(getSignupMutationOptions(options), queryClient);
    }

export const getCompleteSignupUrl = () => {




  return `/api/v1/signup/complete`
}

/**
 * @summary Provision an account for the already-authenticated (federated) caller
 */
export const completeSignup = async (completeSignupRequest: CompleteSignupRequest, options?: RequestInit): Promise<CompleteSignupResponse> => {

  return customInstance<CompleteSignupResponse>(getCompleteSignupUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(completeSignupRequest)
  }
);}




export const getCompleteSignupMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeSignup>>, TError,{data: CompleteSignupRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof completeSignup>>, TError,{data: CompleteSignupRequest}, TContext> => {

const mutationKey = ['completeSignup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeSignup>>, {data: CompleteSignupRequest}> = (props) => {
          const {data} = props ?? {};

          return  completeSignup(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteSignupMutationResult = NonNullable<Awaited<ReturnType<typeof completeSignup>>>
    export type CompleteSignupMutationBody = CompleteSignupRequest
    export type CompleteSignupMutationError = ProblemDetail

    /**
 * @summary Provision an account for the already-authenticated (federated) caller
 */
export const useCompleteSignup = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeSignup>>, TError,{data: CompleteSignupRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeSignup>>,
        TError,
        {data: CompleteSignupRequest},
        TContext
      > => {
      return useMutation(getCompleteSignupMutationOptions(options), queryClient);
    }

export const getSuspend1Url = (venueId: string,) => {




  return `/api/v1/ops/venues/${venueId}/suspend`
}

export const suspend1 = async (venueId: string,
    overrideRequest: OverrideRequest, options?: RequestInit): Promise<VenueStateDto> => {

  return customInstance<VenueStateDto>(getSuspend1Url(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(overrideRequest)
  }
);}




export const getSuspend1MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suspend1>>, TError,{venueId: string;data: OverrideRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof suspend1>>, TError,{venueId: string;data: OverrideRequest}, TContext> => {

const mutationKey = ['suspend1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof suspend1>>, {venueId: string;data: OverrideRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  suspend1(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type Suspend1MutationResult = NonNullable<Awaited<ReturnType<typeof suspend1>>>
    export type Suspend1MutationBody = OverrideRequest
    export type Suspend1MutationError = ProblemDetail

    export const useSuspend1 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suspend1>>, TError,{venueId: string;data: OverrideRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof suspend1>>,
        TError,
        {venueId: string;data: OverrideRequest},
        TContext
      > => {
      return useMutation(getSuspend1MutationOptions(options), queryClient);
    }

export const getReactivateUrl = (venueId: string,) => {




  return `/api/v1/ops/venues/${venueId}/reactivate`
}

export const reactivate = async (venueId: string,
    overrideRequest: OverrideRequest, options?: RequestInit): Promise<VenueStateDto> => {

  return customInstance<VenueStateDto>(getReactivateUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(overrideRequest)
  }
);}




export const getReactivateMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivate>>, TError,{venueId: string;data: OverrideRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reactivate>>, TError,{venueId: string;data: OverrideRequest}, TContext> => {

const mutationKey = ['reactivate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reactivate>>, {venueId: string;data: OverrideRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  reactivate(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReactivateMutationResult = NonNullable<Awaited<ReturnType<typeof reactivate>>>
    export type ReactivateMutationBody = OverrideRequest
    export type ReactivateMutationError = ProblemDetail

    export const useReactivate = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivate>>, TError,{venueId: string;data: OverrideRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reactivate>>,
        TError,
        {venueId: string;data: OverrideRequest},
        TContext
      > => {
      return useMutation(getReactivateMutationOptions(options), queryClient);
    }

export const getStartUrl = (venueId: string,) => {




  return `/api/v1/ops/venues/${venueId}/impersonate`
}

export const start = async (venueId: string,
    impersonationStartRequest: ImpersonationStartRequest, options?: RequestInit): Promise<ImpersonationSessionDto> => {

  return customInstance<ImpersonationSessionDto>(getStartUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(impersonationStartRequest)
  }
);}




export const getStartMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof start>>, TError,{venueId: string;data: ImpersonationStartRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof start>>, TError,{venueId: string;data: ImpersonationStartRequest}, TContext> => {

const mutationKey = ['start'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof start>>, {venueId: string;data: ImpersonationStartRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  start(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartMutationResult = NonNullable<Awaited<ReturnType<typeof start>>>
    export type StartMutationBody = ImpersonationStartRequest
    export type StartMutationError = ProblemDetail

    export const useStart = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof start>>, TError,{venueId: string;data: ImpersonationStartRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof start>>,
        TError,
        {venueId: string;data: ImpersonationStartRequest},
        TContext
      > => {
      return useMutation(getStartMutationOptions(options), queryClient);
    }

export const getSetOverrideUrl = (venueId: string,) => {




  return `/api/v1/ops/venues/${venueId}/entitlements/override`
}

export const setOverride = async (venueId: string,
    setOverrideBody: SetOverrideBody, options?: RequestInit): Promise<EntitlementViewDto> => {

  return customInstance<EntitlementViewDto>(getSetOverrideUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setOverrideBody)
  }
);}




export const getSetOverrideMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOverride>>, TError,{venueId: string;data: SetOverrideBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setOverride>>, TError,{venueId: string;data: SetOverrideBody}, TContext> => {

const mutationKey = ['setOverride'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setOverride>>, {venueId: string;data: SetOverrideBody}> = (props) => {
          const {venueId,data} = props ?? {};

          return  setOverride(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof setOverride>>>
    export type SetOverrideMutationBody = SetOverrideBody
    export type SetOverrideMutationError = ProblemDetail

    export const useSetOverride = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOverride>>, TError,{venueId: string;data: SetOverrideBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setOverride>>,
        TError,
        {venueId: string;data: SetOverrideBody},
        TContext
      > => {
      return useMutation(getSetOverrideMutationOptions(options), queryClient);
    }

export const getRequestUrl = (tenantId: string,) => {




  return `/api/v1/ops/tenants/${tenantId}/trials`
}

export const request = async (tenantId: string,
    requestTrialBody: RequestTrialBody, options?: RequestInit): Promise<TrialDto> => {

  return customInstance<TrialDto>(getRequestUrl(tenantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(requestTrialBody)
  }
);}




export const getRequestMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof request>>, TError,{tenantId: string;data: RequestTrialBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof request>>, TError,{tenantId: string;data: RequestTrialBody}, TContext> => {

const mutationKey = ['request'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof request>>, {tenantId: string;data: RequestTrialBody}> = (props) => {
          const {tenantId,data} = props ?? {};

          return  request(tenantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestMutationResult = NonNullable<Awaited<ReturnType<typeof request>>>
    export type RequestMutationBody = RequestTrialBody
    export type RequestMutationError = ProblemDetail

    export const useRequest = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof request>>, TError,{tenantId: string;data: RequestTrialBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof request>>,
        TError,
        {tenantId: string;data: RequestTrialBody},
        TContext
      > => {
      return useMutation(getRequestMutationOptions(options), queryClient);
    }

export const getExtendUrl = (tenantId: string,
    trialId: string,) => {




  return `/api/v1/ops/tenants/${tenantId}/trials/${trialId}/extend`
}

export const extend = async (tenantId: string,
    trialId: string,
    extendBody: ExtendBody, options?: RequestInit): Promise<TrialDto> => {

  return customInstance<TrialDto>(getExtendUrl(tenantId,trialId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(extendBody)
  }
);}




export const getExtendMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extend>>, TError,{tenantId: string;trialId: string;data: ExtendBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof extend>>, TError,{tenantId: string;trialId: string;data: ExtendBody}, TContext> => {

const mutationKey = ['extend'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof extend>>, {tenantId: string;trialId: string;data: ExtendBody}> = (props) => {
          const {tenantId,trialId,data} = props ?? {};

          return  extend(tenantId,trialId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExtendMutationResult = NonNullable<Awaited<ReturnType<typeof extend>>>
    export type ExtendMutationBody = ExtendBody
    export type ExtendMutationError = ProblemDetail

    export const useExtend = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extend>>, TError,{tenantId: string;trialId: string;data: ExtendBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof extend>>,
        TError,
        {tenantId: string;trialId: string;data: ExtendBody},
        TContext
      > => {
      return useMutation(getExtendMutationOptions(options), queryClient);
    }

export const getEndEarlyUrl = (tenantId: string,
    trialId: string,) => {




  return `/api/v1/ops/tenants/${tenantId}/trials/${trialId}/end-early`
}

export const endEarly = async (tenantId: string,
    trialId: string,
    casReasonBody: CasReasonBody, options?: RequestInit): Promise<TrialDto> => {

  return customInstance<TrialDto>(getEndEarlyUrl(tenantId,trialId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(casReasonBody)
  }
);}




export const getEndEarlyMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endEarly>>, TError,{tenantId: string;trialId: string;data: CasReasonBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof endEarly>>, TError,{tenantId: string;trialId: string;data: CasReasonBody}, TContext> => {

const mutationKey = ['endEarly'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof endEarly>>, {tenantId: string;trialId: string;data: CasReasonBody}> = (props) => {
          const {tenantId,trialId,data} = props ?? {};

          return  endEarly(tenantId,trialId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EndEarlyMutationResult = NonNullable<Awaited<ReturnType<typeof endEarly>>>
    export type EndEarlyMutationBody = CasReasonBody
    export type EndEarlyMutationError = ProblemDetail

    export const useEndEarly = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endEarly>>, TError,{tenantId: string;trialId: string;data: CasReasonBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof endEarly>>,
        TError,
        {tenantId: string;trialId: string;data: CasReasonBody},
        TContext
      > => {
      return useMutation(getEndEarlyMutationOptions(options), queryClient);
    }

export const getAdjustGrantUrl = (tenantId: string,
    trialId: string,) => {




  return `/api/v1/ops/tenants/${tenantId}/trials/${trialId}/adjust-grant`
}

export const adjustGrant = async (tenantId: string,
    trialId: string,
    adjustGrantBody: AdjustGrantBody, options?: RequestInit): Promise<TrialDto> => {

  return customInstance<TrialDto>(getAdjustGrantUrl(tenantId,trialId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(adjustGrantBody)
  }
);}




export const getAdjustGrantMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adjustGrant>>, TError,{tenantId: string;trialId: string;data: AdjustGrantBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adjustGrant>>, TError,{tenantId: string;trialId: string;data: AdjustGrantBody}, TContext> => {

const mutationKey = ['adjustGrant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adjustGrant>>, {tenantId: string;trialId: string;data: AdjustGrantBody}> = (props) => {
          const {tenantId,trialId,data} = props ?? {};

          return  adjustGrant(tenantId,trialId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdjustGrantMutationResult = NonNullable<Awaited<ReturnType<typeof adjustGrant>>>
    export type AdjustGrantMutationBody = AdjustGrantBody
    export type AdjustGrantMutationError = ProblemDetail

    export const useAdjustGrant = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adjustGrant>>, TError,{tenantId: string;trialId: string;data: AdjustGrantBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adjustGrant>>,
        TError,
        {tenantId: string;trialId: string;data: AdjustGrantBody},
        TContext
      > => {
      return useMutation(getAdjustGrantMutationOptions(options), queryClient);
    }

export const getActivate1Url = (tenantId: string,
    trialId: string,) => {




  return `/api/v1/ops/tenants/${tenantId}/trials/${trialId}/activate`
}

export const activate1 = async (tenantId: string,
    trialId: string,
    casReasonBody: CasReasonBody, options?: RequestInit): Promise<TrialDto> => {

  return customInstance<TrialDto>(getActivate1Url(tenantId,trialId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(casReasonBody)
  }
);}




export const getActivate1MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activate1>>, TError,{tenantId: string;trialId: string;data: CasReasonBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activate1>>, TError,{tenantId: string;trialId: string;data: CasReasonBody}, TContext> => {

const mutationKey = ['activate1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activate1>>, {tenantId: string;trialId: string;data: CasReasonBody}> = (props) => {
          const {tenantId,trialId,data} = props ?? {};

          return  activate1(tenantId,trialId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type Activate1MutationResult = NonNullable<Awaited<ReturnType<typeof activate1>>>
    export type Activate1MutationBody = CasReasonBody
    export type Activate1MutationError = ProblemDetail

    export const useActivate1 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activate1>>, TError,{tenantId: string;trialId: string;data: CasReasonBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activate1>>,
        TError,
        {tenantId: string;trialId: string;data: CasReasonBody},
        TContext
      > => {
      return useMutation(getActivate1MutationOptions(options), queryClient);
    }

export const getMessages1Url = (tenantId: string,
    threadId: string,
    params?: Messages1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/ops/support/tenants/${tenantId}/threads/${threadId}/messages?${stringifiedParams}` : `/api/v1/ops/support/tenants/${tenantId}/threads/${threadId}/messages`
}

export const messages1 = async (tenantId: string,
    threadId: string,
    params?: Messages1Params, options?: RequestInit): Promise<PageDtoSupportMessageDto> => {

  return customInstance<PageDtoSupportMessageDto>(getMessages1Url(tenantId,threadId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMessages1QueryKey = (tenantId: string,
    threadId: string,
    params?: Messages1Params,) => {
    return [
    `/api/v1/ops/support/tenants/${tenantId}/threads/${threadId}/messages`, ...(params ? [params] : [])
    ] as const;
    }


export const getMessages1QueryOptions = <TData = Awaited<ReturnType<typeof messages1>>, TError = ProblemDetail>(tenantId: string,
    threadId: string,
    params?: Messages1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messages1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessages1QueryKey(tenantId,threadId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messages1>>> = ({ signal }) => messages1(tenantId,threadId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined && threadId !== null && threadId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messages1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Messages1QueryResult = NonNullable<Awaited<ReturnType<typeof messages1>>>
export type Messages1QueryError = ProblemDetail


export function useMessages1<TData = Awaited<ReturnType<typeof messages1>>, TError = ProblemDetail>(
 tenantId: string,
    threadId: string,
    params: undefined |  Messages1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof messages1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messages1>>,
          TError,
          Awaited<ReturnType<typeof messages1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessages1<TData = Awaited<ReturnType<typeof messages1>>, TError = ProblemDetail>(
 tenantId: string,
    threadId: string,
    params?: Messages1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messages1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messages1>>,
          TError,
          Awaited<ReturnType<typeof messages1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessages1<TData = Awaited<ReturnType<typeof messages1>>, TError = ProblemDetail>(
 tenantId: string,
    threadId: string,
    params?: Messages1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messages1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMessages1<TData = Awaited<ReturnType<typeof messages1>>, TError = ProblemDetail>(
 tenantId: string,
    threadId: string,
    params?: Messages1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messages1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessages1QueryOptions(tenantId,threadId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getPost1Url = (tenantId: string,
    threadId: string,) => {




  return `/api/v1/ops/support/tenants/${tenantId}/threads/${threadId}/messages`
}

export const post1 = async (tenantId: string,
    threadId: string,
    supportMessageRequest: SupportMessageRequest, options?: RequestInit): Promise<SupportThreadDto> => {

  return customInstance<SupportThreadDto>(getPost1Url(tenantId,threadId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(supportMessageRequest)
  }
);}




export const getPost1MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof post1>>, TError,{tenantId: string;threadId: string;data: SupportMessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof post1>>, TError,{tenantId: string;threadId: string;data: SupportMessageRequest}, TContext> => {

const mutationKey = ['post1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof post1>>, {tenantId: string;threadId: string;data: SupportMessageRequest}> = (props) => {
          const {tenantId,threadId,data} = props ?? {};

          return  post1(tenantId,threadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type Post1MutationResult = NonNullable<Awaited<ReturnType<typeof post1>>>
    export type Post1MutationBody = SupportMessageRequest
    export type Post1MutationError = ProblemDetail

    export const usePost1 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof post1>>, TError,{tenantId: string;threadId: string;data: SupportMessageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof post1>>,
        TError,
        {tenantId: string;threadId: string;data: SupportMessageRequest},
        TContext
      > => {
      return useMutation(getPost1MutationOptions(options), queryClient);
    }

export const getEndUrl = (sessionId: string,) => {




  return `/api/v1/ops/impersonation/${sessionId}/end`
}

export const end = async (sessionId: string, options?: RequestInit): Promise<End200> => {

  return customInstance<End200>(getEndUrl(sessionId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getEndMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof end>>, TError,{sessionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof end>>, TError,{sessionId: string}, TContext> => {

const mutationKey = ['end'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof end>>, {sessionId: string}> = (props) => {
          const {sessionId} = props ?? {};

          return  end(sessionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EndMutationResult = NonNullable<Awaited<ReturnType<typeof end>>>

    export type EndMutationError = ProblemDetail

    export const useEnd = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof end>>, TError,{sessionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof end>>,
        TError,
        {sessionId: string},
        TContext
      > => {
      return useMutation(getEndMutationOptions(options), queryClient);
    }

export const getBrevoUrl = () => {




  return `/api/v1/notifications/webhooks/brevo`
}

/**
 * @summary Ingest a Brevo delivery-status / STOP event (shared-secret authenticated)
 */
export const brevo = async (brevoBody: BrevoBody, options?: RequestInit): Promise<void> => {

  return customInstance<void>(getBrevoUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(brevoBody)
  }
);}




export const getBrevoMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof brevo>>, TError,{data: BrevoBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof brevo>>, TError,{data: BrevoBody}, TContext> => {

const mutationKey = ['brevo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof brevo>>, {data: BrevoBody}> = (props) => {
          const {data} = props ?? {};

          return  brevo(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BrevoMutationResult = NonNullable<Awaited<ReturnType<typeof brevo>>>
    export type BrevoMutationBody = BrevoBody
    export type BrevoMutationError = ProblemDetail

    /**
 * @summary Ingest a Brevo delivery-status / STOP event (shared-secret authenticated)
 */
export const useBrevo = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof brevo>>, TError,{data: BrevoBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof brevo>>,
        TError,
        {data: BrevoBody},
        TContext
      > => {
      return useMutation(getBrevoMutationOptions(options), queryClient);
    }

export const getGrantTrialUrl = (venueId: string,) => {




  return `/api/v1/internal/entitlements/${venueId}/trial`
}

/**
 * @summary Grant a trial flag-set expiring at endsAt, then recompute (EN-3)
 */
export const grantTrial = async (venueId: string,
    grantTrialRequest: GrantTrialRequest, options?: RequestInit): Promise<EntitlementViewResponse> => {

  return customInstance<EntitlementViewResponse>(getGrantTrialUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(grantTrialRequest)
  }
);}




export const getGrantTrialMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof grantTrial>>, TError,{venueId: string;data: GrantTrialRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof grantTrial>>, TError,{venueId: string;data: GrantTrialRequest}, TContext> => {

const mutationKey = ['grantTrial'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof grantTrial>>, {venueId: string;data: GrantTrialRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  grantTrial(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GrantTrialMutationResult = NonNullable<Awaited<ReturnType<typeof grantTrial>>>
    export type GrantTrialMutationBody = GrantTrialRequest
    export type GrantTrialMutationError = ProblemDetail

    /**
 * @summary Grant a trial flag-set expiring at endsAt, then recompute (EN-3)
 */
export const useGrantTrial = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof grantTrial>>, TError,{venueId: string;data: GrantTrialRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof grantTrial>>,
        TError,
        {venueId: string;data: GrantTrialRequest},
        TContext
      > => {
      return useMutation(getGrantTrialMutationOptions(options), queryClient);
    }

export const getSetOverride1Url = (venueId: string,) => {




  return `/api/v1/internal/entitlements/${venueId}/override`
}

/**
 * @summary Set an operator override (wins over plan/trial; mandatory reason + future expiry, EN-1)
 */
export const setOverride1 = async (venueId: string,
    setOverrideRequest: SetOverrideRequest, options?: RequestInit): Promise<EntitlementViewResponse> => {

  return customInstance<EntitlementViewResponse>(getSetOverride1Url(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setOverrideRequest)
  }
);}




export const getSetOverride1MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOverride1>>, TError,{venueId: string;data: SetOverrideRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setOverride1>>, TError,{venueId: string;data: SetOverrideRequest}, TContext> => {

const mutationKey = ['setOverride1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setOverride1>>, {venueId: string;data: SetOverrideRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  setOverride1(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetOverride1MutationResult = NonNullable<Awaited<ReturnType<typeof setOverride1>>>
    export type SetOverride1MutationBody = SetOverrideRequest
    export type SetOverride1MutationError = ProblemDetail

    /**
 * @summary Set an operator override (wins over plan/trial; mandatory reason + future expiry, EN-1)
 */
export const useSetOverride1 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOverride1>>, TError,{venueId: string;data: SetOverrideRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setOverride1>>,
        TError,
        {venueId: string;data: SetOverrideRequest},
        TContext
      > => {
      return useMutation(getSetOverride1MutationOptions(options), queryClient);
    }

export const getResetUrl = (venueId: string,) => {




  return `/api/v1/internal/demo/${venueId}/reset`
}

export const reset = async (venueId: string, options?: RequestInit): Promise<DemoResetResponse> => {

  return customInstance<DemoResetResponse>(getResetUrl(venueId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getResetMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reset>>, TError,{venueId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reset>>, TError,{venueId: string}, TContext> => {

const mutationKey = ['reset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reset>>, {venueId: string}> = (props) => {
          const {venueId} = props ?? {};

          return  reset(venueId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetMutationResult = NonNullable<Awaited<ReturnType<typeof reset>>>

    export type ResetMutationError = ProblemDetail

    export const useReset = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reset>>, TError,{venueId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reset>>,
        TError,
        {venueId: string},
        TContext
      > => {
      return useMutation(getResetMutationOptions(options), queryClient);
    }

export const getProvisionUrl = () => {




  return `/api/v1/internal/demo/provision`
}

export const provision = async (provisionDemoRequest?: ProvisionDemoRequest, options?: RequestInit): Promise<ProvisionDemoResponse> => {

  return customInstance<ProvisionDemoResponse>(getProvisionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(provisionDemoRequest)
  }
);}




export const getProvisionMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof provision>>, TError,{data?: ProvisionDemoRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof provision>>, TError,{data?: ProvisionDemoRequest}, TContext> => {

const mutationKey = ['provision'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof provision>>, {data?: ProvisionDemoRequest}> = (props) => {
          const {data} = props ?? {};

          return  provision(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProvisionMutationResult = NonNullable<Awaited<ReturnType<typeof provision>>>
    export type ProvisionMutationBody = ProvisionDemoRequest | undefined
    export type ProvisionMutationError = ProblemDetail

    export const useProvision = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof provision>>, TError,{data?: ProvisionDemoRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof provision>>,
        TError,
        {data?: ProvisionDemoRequest},
        TContext
      > => {
      return useMutation(getProvisionMutationOptions(options), queryClient);
    }

export const getSyncUrl = () => {




  return `/api/v1/google-business/sync`
}

/**
 * @summary Re-list the account's GBP locations from Google and auto-map by place id (account root)
 */
export const sync = async ( options?: RequestInit): Promise<SyncResponse> => {

  return customInstance<SyncResponse>(getSyncUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSyncMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sync>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sync>>, TError,void, TContext> => {

const mutationKey = ['sync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sync>>, void> = () => {


          return  sync(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncMutationResult = NonNullable<Awaited<ReturnType<typeof sync>>>

    export type SyncMutationError = ProblemDetail

    /**
 * @summary Re-list the account's GBP locations from Google and auto-map by place id (account root)
 */
export const useSync = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sync>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sync>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSyncMutationOptions(options), queryClient);
    }

export const getReplyToReviewUrl = (locationId: string,
    reviewId: string,) => {




  return `/api/v1/google-business/locations/${locationId}/reviews/${reviewId}/reply`
}

/**
 * @summary Reply to (or update the reply on) a Google review — write-back to My Business v4 (manager)
 */
export const replyToReview = async (locationId: string,
    reviewId: string,
    reviewReplyRequest: ReviewReplyRequest, options?: RequestInit): Promise<void> => {

  return customInstance<void>(getReplyToReviewUrl(locationId,reviewId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reviewReplyRequest)
  }
);}




export const getReplyToReviewMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replyToReview>>, TError,{locationId: string;reviewId: string;data: ReviewReplyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof replyToReview>>, TError,{locationId: string;reviewId: string;data: ReviewReplyRequest}, TContext> => {

const mutationKey = ['replyToReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replyToReview>>, {locationId: string;reviewId: string;data: ReviewReplyRequest}> = (props) => {
          const {locationId,reviewId,data} = props ?? {};

          return  replyToReview(locationId,reviewId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplyToReviewMutationResult = NonNullable<Awaited<ReturnType<typeof replyToReview>>>
    export type ReplyToReviewMutationBody = ReviewReplyRequest
    export type ReplyToReviewMutationError = ProblemDetail

    /**
 * @summary Reply to (or update the reply on) a Google review — write-back to My Business v4 (manager)
 */
export const useReplyToReview = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replyToReview>>, TError,{locationId: string;reviewId: string;data: ReviewReplyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replyToReview>>,
        TError,
        {locationId: string;reviewId: string;data: ReviewReplyRequest},
        TContext
      > => {
      return useMutation(getReplyToReviewMutationOptions(options), queryClient);
    }

export const getDeleteReviewReplyUrl = (locationId: string,
    reviewId: string,) => {




  return `/api/v1/google-business/locations/${locationId}/reviews/${reviewId}/reply`
}

/**
 * @summary Delete the owner's reply to a Google review (manager)
 */
export const deleteReviewReply = async (locationId: string,
    reviewId: string, options?: RequestInit): Promise<void> => {

  return customInstance<void>(getDeleteReviewReplyUrl(locationId,reviewId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteReviewReplyMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteReviewReply>>, TError,{locationId: string;reviewId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteReviewReply>>, TError,{locationId: string;reviewId: string}, TContext> => {

const mutationKey = ['deleteReviewReply'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteReviewReply>>, {locationId: string;reviewId: string}> = (props) => {
          const {locationId,reviewId} = props ?? {};

          return  deleteReviewReply(locationId,reviewId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteReviewReplyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteReviewReply>>>

    export type DeleteReviewReplyMutationError = ProblemDetail

    /**
 * @summary Delete the owner's reply to a Google review (manager)
 */
export const useDeleteReviewReply = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteReviewReply>>, TError,{locationId: string;reviewId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteReviewReply>>,
        TError,
        {locationId: string;reviewId: string},
        TContext
      > => {
      return useMutation(getDeleteReviewReplyMutationOptions(options), queryClient);
    }

export const getPhoneSyncStatusUrl = (locationId: string,) => {




  return `/api/v1/google-business/locations/${locationId}/phone-sync`
}

/**
 * @summary Our venue's phone vs the Google listing's, for the mapped venue (manager)
 */
export const phoneSyncStatus = async (locationId: string, options?: RequestInit): Promise<PhoneSyncResponse> => {

  return customInstance<PhoneSyncResponse>(getPhoneSyncStatusUrl(locationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPhoneSyncStatusQueryKey = (locationId: string,) => {
    return [
    `/api/v1/google-business/locations/${locationId}/phone-sync`
    ] as const;
    }


export const getPhoneSyncStatusQueryOptions = <TData = Awaited<ReturnType<typeof phoneSyncStatus>>, TError = ProblemDetail>(locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof phoneSyncStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPhoneSyncStatusQueryKey(locationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof phoneSyncStatus>>> = ({ signal }) => phoneSyncStatus(locationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof phoneSyncStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PhoneSyncStatusQueryResult = NonNullable<Awaited<ReturnType<typeof phoneSyncStatus>>>
export type PhoneSyncStatusQueryError = ProblemDetail


export function usePhoneSyncStatus<TData = Awaited<ReturnType<typeof phoneSyncStatus>>, TError = ProblemDetail>(
 locationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof phoneSyncStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof phoneSyncStatus>>,
          TError,
          Awaited<ReturnType<typeof phoneSyncStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePhoneSyncStatus<TData = Awaited<ReturnType<typeof phoneSyncStatus>>, TError = ProblemDetail>(
 locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof phoneSyncStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof phoneSyncStatus>>,
          TError,
          Awaited<ReturnType<typeof phoneSyncStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePhoneSyncStatus<TData = Awaited<ReturnType<typeof phoneSyncStatus>>, TError = ProblemDetail>(
 locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof phoneSyncStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Our venue's phone vs the Google listing's, for the mapped venue (manager)
 */

export function usePhoneSyncStatus<TData = Awaited<ReturnType<typeof phoneSyncStatus>>, TError = ProblemDetail>(
 locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof phoneSyncStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPhoneSyncStatusQueryOptions(locationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getPushPhoneUrl = (locationId: string,) => {




  return `/api/v1/google-business/locations/${locationId}/phone-sync`
}

/**
 * @summary Push our venue's phone to the Google listing (Business Information patch, manager)
 */
export const pushPhone = async (locationId: string, options?: RequestInit): Promise<void> => {

  return customInstance<void>(getPushPhoneUrl(locationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPushPhoneMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushPhone>>, TError,{locationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof pushPhone>>, TError,{locationId: string}, TContext> => {

const mutationKey = ['pushPhone'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pushPhone>>, {locationId: string}> = (props) => {
          const {locationId} = props ?? {};

          return  pushPhone(locationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PushPhoneMutationResult = NonNullable<Awaited<ReturnType<typeof pushPhone>>>

    export type PushPhoneMutationError = ProblemDetail

    /**
 * @summary Push our venue's phone to the Google listing (Business Information patch, manager)
 */
export const usePushPhone = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pushPhone>>, TError,{locationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pushPhone>>,
        TError,
        {locationId: string},
        TContext
      > => {
      return useMutation(getPushPhoneMutationOptions(options), queryClient);
    }

export const getMapLocationUrl = (locationId: string,) => {




  return `/api/v1/google-business/locations/${locationId}/mapping`
}

/**
 * @summary Map (or clear) which venue a GBP location belongs to. CAS on version; stale ⇒ 409 (manager)
 */
export const mapLocation = async (locationId: string,
    mapLocationRequest: MapLocationRequest, options?: RequestInit): Promise<MappedLocationResponse> => {

  return customInstance<MappedLocationResponse>(getMapLocationUrl(locationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mapLocationRequest)
  }
);}




export const getMapLocationMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mapLocation>>, TError,{locationId: string;data: MapLocationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof mapLocation>>, TError,{locationId: string;data: MapLocationRequest}, TContext> => {

const mutationKey = ['mapLocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mapLocation>>, {locationId: string;data: MapLocationRequest}> = (props) => {
          const {locationId,data} = props ?? {};

          return  mapLocation(locationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MapLocationMutationResult = NonNullable<Awaited<ReturnType<typeof mapLocation>>>
    export type MapLocationMutationBody = MapLocationRequest
    export type MapLocationMutationError = ProblemDetail

    /**
 * @summary Map (or clear) which venue a GBP location belongs to. CAS on version; stale ⇒ 409 (manager)
 */
export const useMapLocation = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mapLocation>>, TError,{locationId: string;data: MapLocationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mapLocation>>,
        TError,
        {locationId: string;data: MapLocationRequest},
        TContext
      > => {
      return useMutation(getMapLocationMutationOptions(options), queryClient);
    }

export const getDisconnectUrl = () => {




  return `/api/v1/google-business/disconnect`
}

/**
 * @summary Revoke the grant at Google and remove the stored connection + locations (account root)
 */
export const disconnect = async ( options?: RequestInit): Promise<void> => {

  return customInstance<void>(getDisconnectUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getDisconnectMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnect>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnect>>, TError,void, TContext> => {

const mutationKey = ['disconnect'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnect>>, void> = () => {


          return  disconnect(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectMutationResult = NonNullable<Awaited<ReturnType<typeof disconnect>>>

    export type DisconnectMutationError = ProblemDetail

    /**
 * @summary Revoke the grant at Google and remove the stored connection + locations (account root)
 */
export const useDisconnect = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnect>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disconnect>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDisconnectMutationOptions(options), queryClient);
    }

export const getConnectUrl = () => {




  return `/api/v1/google-business/connect`
}

/**
 * @summary Begin connecting a Google Business Profile — returns the Google consent URL (account root)
 */
export const connect = async ( options?: RequestInit): Promise<ConnectResponse> => {

  return customInstance<ConnectResponse>(getConnectUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getConnectMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connect>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof connect>>, TError,void, TContext> => {

const mutationKey = ['connect'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connect>>, void> = () => {


          return  connect(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConnectMutationResult = NonNullable<Awaited<ReturnType<typeof connect>>>

    export type ConnectMutationError = ProblemDetail

    /**
 * @summary Begin connecting a Google Business Profile — returns the Google consent URL (account root)
 */
export const useConnect = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connect>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof connect>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getConnectMutationOptions(options), queryClient);
    }

export const getCreateFileUploadUrl = () => {




  return `/api/v1/files`
}

/**
 * @summary Create a presigned upload URL (client PUTs the bytes directly)
 */
export const createFileUpload = async (createUploadRequest: CreateUploadRequest, options?: RequestInit): Promise<UploadUrlResponse> => {

  return customInstance<UploadUrlResponse>(getCreateFileUploadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createUploadRequest)
  }
);}




export const getCreateFileUploadMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFileUpload>>, TError,{data: CreateUploadRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createFileUpload>>, TError,{data: CreateUploadRequest}, TContext> => {

const mutationKey = ['createFileUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFileUpload>>, {data: CreateUploadRequest}> = (props) => {
          const {data} = props ?? {};

          return  createFileUpload(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFileUploadMutationResult = NonNullable<Awaited<ReturnType<typeof createFileUpload>>>
    export type CreateFileUploadMutationBody = CreateUploadRequest
    export type CreateFileUploadMutationError = ProblemDetail

    /**
 * @summary Create a presigned upload URL (client PUTs the bytes directly)
 */
export const useCreateFileUpload = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFileUpload>>, TError,{data: CreateUploadRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createFileUpload>>,
        TError,
        {data: CreateUploadRequest},
        TContext
      > => {
      return useMutation(getCreateFileUploadMutationOptions(options), queryClient);
    }

export const getConfirm3Url = (key: string,) => {




  return `/api/v1/files/${key}/confirm`
}

/**
 * @summary Confirm an upload: size/type re-check + image processing when applicable
 */
export const confirm3 = async (key: string, options?: RequestInit): Promise<ConfirmResponse> => {

  return customInstance<ConfirmResponse>(getConfirm3Url(key),
  {
    ...options,
    method: 'POST'


  }
);}




export const getConfirm3MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirm3>>, TError,{key: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof confirm3>>, TError,{key: string}, TContext> => {

const mutationKey = ['confirm3'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirm3>>, {key: string}> = (props) => {
          const {key} = props ?? {};

          return  confirm3(key,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type Confirm3MutationResult = NonNullable<Awaited<ReturnType<typeof confirm3>>>

    export type Confirm3MutationError = ProblemDetail

    /**
 * @summary Confirm an upload: size/type re-check + image processing when applicable
 */
export const useConfirm3 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirm3>>, TError,{key: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirm3>>,
        TError,
        {key: string},
        TContext
      > => {
      return useMutation(getConfirm3MutationOptions(options), queryClient);
    }

export const getOpenUrl = () => {




  return `/api/v1/device-sessions`
}

/**
 * @summary Open a device session bound to a venue + the Keycloak device session
 */
export const open = async (openDeviceSessionRequest: OpenDeviceSessionRequest, options?: RequestInit): Promise<DeviceSessionResponse> => {

  return customInstance<DeviceSessionResponse>(getOpenUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(openDeviceSessionRequest)
  }
);}




export const getOpenMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof open>>, TError,{data: OpenDeviceSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof open>>, TError,{data: OpenDeviceSessionRequest}, TContext> => {

const mutationKey = ['open'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof open>>, {data: OpenDeviceSessionRequest}> = (props) => {
          const {data} = props ?? {};

          return  open(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OpenMutationResult = NonNullable<Awaited<ReturnType<typeof open>>>
    export type OpenMutationBody = OpenDeviceSessionRequest
    export type OpenMutationError = ProblemDetail

    /**
 * @summary Open a device session bound to a venue + the Keycloak device session
 */
export const useOpen = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof open>>, TError,{data: OpenDeviceSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof open>>,
        TError,
        {data: OpenDeviceSessionRequest},
        TContext
      > => {
      return useMutation(getOpenMutationOptions(options), queryClient);
    }

export const getSwitchUrl = (id: string,) => {




  return `/api/v1/device-sessions/${id}/switch`
}

/**
 * @summary Quick-switch acting staff by PIN (fail-closed lockout — ST-6)
 */
export const _switch = async (id: string,
    switchRequest: SwitchRequest, options?: RequestInit): Promise<SwitchResponse> => {

  return customInstance<SwitchResponse>(getSwitchUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(switchRequest)
  }
);}




export const getSwitchMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof _switch>>, TError,{id: string;data: SwitchRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof _switch>>, TError,{id: string;data: SwitchRequest}, TContext> => {

const mutationKey = ['_switch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof _switch>>, {id: string;data: SwitchRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  _switch(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type _SwitchMutationResult = NonNullable<Awaited<ReturnType<typeof _switch>>>
    export type _SwitchMutationBody = SwitchRequest
    export type _SwitchMutationError = ProblemDetail

    /**
 * @summary Quick-switch acting staff by PIN (fail-closed lockout — ST-6)
 */
export const useSwitch = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof _switch>>, TError,{id: string;data: SwitchRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof _switch>>,
        TError,
        {id: string;data: SwitchRequest},
        TContext
      > => {
      return useMutation(getSwitchMutationOptions(options), queryClient);
    }

export const getReactivate1Url = (venueId: string,) => {




  return `/api/v1/billing/venues/${venueId}/subscription/reactivate`
}

/**
 * @summary Undo a scheduled cancel-at-period-end (the subscription keeps renewing)
 */
export const reactivate1 = async (venueId: string, options?: RequestInit): Promise<SubscriptionResponse> => {

  return customInstance<SubscriptionResponse>(getReactivate1Url(venueId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getReactivate1MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivate1>>, TError,{venueId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reactivate1>>, TError,{venueId: string}, TContext> => {

const mutationKey = ['reactivate1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reactivate1>>, {venueId: string}> = (props) => {
          const {venueId} = props ?? {};

          return  reactivate1(venueId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type Reactivate1MutationResult = NonNullable<Awaited<ReturnType<typeof reactivate1>>>

    export type Reactivate1MutationError = ProblemDetail

    /**
 * @summary Undo a scheduled cancel-at-period-end (the subscription keeps renewing)
 */
export const useReactivate1 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivate1>>, TError,{venueId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reactivate1>>,
        TError,
        {venueId: string},
        TContext
      > => {
      return useMutation(getReactivate1MutationOptions(options), queryClient);
    }

export const getChangePlanUrl = (venueId: string,) => {




  return `/api/v1/billing/venues/${venueId}/subscription/plan`
}

/**
 * @summary Change plan / toggle add-ons. Downgrade guard: a breached limit is a typed 409 (BI-3).
 */
export const changePlan = async (venueId: string,
    changePlanRequest: ChangePlanRequest, options?: RequestInit): Promise<SubscriptionResponse> => {

  return customInstance<SubscriptionResponse>(getChangePlanUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(changePlanRequest)
  }
);}




export const getChangePlanMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePlan>>, TError,{venueId: string;data: ChangePlanRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof changePlan>>, TError,{venueId: string;data: ChangePlanRequest}, TContext> => {

const mutationKey = ['changePlan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changePlan>>, {venueId: string;data: ChangePlanRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  changePlan(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangePlanMutationResult = NonNullable<Awaited<ReturnType<typeof changePlan>>>
    export type ChangePlanMutationBody = ChangePlanRequest
    export type ChangePlanMutationError = ProblemDetail

    /**
 * @summary Change plan / toggle add-ons. Downgrade guard: a breached limit is a typed 409 (BI-3).
 */
export const useChangePlan = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePlan>>, TError,{venueId: string;data: ChangePlanRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changePlan>>,
        TError,
        {venueId: string;data: ChangePlanRequest},
        TContext
      > => {
      return useMutation(getChangePlanMutationOptions(options), queryClient);
    }

export const getCheckoutUrl = (venueId: string,) => {




  return `/api/v1/billing/venues/${venueId}/subscription/checkout`
}

/**
 * @summary A Stripe Checkout URL to subscribe the venue — Stripe collects the card + creates the sub.
 */
export const checkout = async (venueId: string,
    checkoutRequest: CheckoutRequest, options?: RequestInit): Promise<CheckoutResponse> => {

  return customInstance<CheckoutResponse>(getCheckoutUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(checkoutRequest)
  }
);}




export const getCheckoutMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkout>>, TError,{venueId: string;data: CheckoutRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof checkout>>, TError,{venueId: string;data: CheckoutRequest}, TContext> => {

const mutationKey = ['checkout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkout>>, {venueId: string;data: CheckoutRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  checkout(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof checkout>>>
    export type CheckoutMutationBody = CheckoutRequest
    export type CheckoutMutationError = ProblemDetail

    /**
 * @summary A Stripe Checkout URL to subscribe the venue — Stripe collects the card + creates the sub.
 */
export const useCheckout = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkout>>, TError,{venueId: string;data: CheckoutRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkout>>,
        TError,
        {venueId: string;data: CheckoutRequest},
        TContext
      > => {
      return useMutation(getCheckoutMutationOptions(options), queryClient);
    }

export const getCancel2Url = (venueId: string,) => {




  return `/api/v1/billing/venues/${venueId}/subscription/cancel`
}

/**
 * @summary Cancel at period end (access persists until the cycle closes)
 */
export const cancel2 = async (venueId: string, options?: RequestInit): Promise<SubscriptionResponse> => {

  return customInstance<SubscriptionResponse>(getCancel2Url(venueId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCancel2MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancel2>>, TError,{venueId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancel2>>, TError,{venueId: string}, TContext> => {

const mutationKey = ['cancel2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancel2>>, {venueId: string}> = (props) => {
          const {venueId} = props ?? {};

          return  cancel2(venueId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type Cancel2MutationResult = NonNullable<Awaited<ReturnType<typeof cancel2>>>

    export type Cancel2MutationError = ProblemDetail

    /**
 * @summary Cancel at period end (access persists until the cycle closes)
 */
export const useCancel2 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancel2>>, TError,{venueId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancel2>>,
        TError,
        {venueId: string},
        TContext
      > => {
      return useMutation(getCancel2MutationOptions(options), queryClient);
    }

export const getCurrentTrialUrl = () => {




  return `/api/v1/billing/trial`
}

/**
 * @summary The account's current trial (countdown + included flags + pending SLA), or null
 */
export const currentTrial = async ( options?: RequestInit): Promise<TrialBannerResponse> => {

  return customInstance<TrialBannerResponse>(getCurrentTrialUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCurrentTrialQueryKey = () => {
    return [
    `/api/v1/billing/trial`
    ] as const;
    }


export const getCurrentTrialQueryOptions = <TData = Awaited<ReturnType<typeof currentTrial>>, TError = ProblemDetail>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentTrial>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCurrentTrialQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof currentTrial>>> = ({ signal }) => currentTrial({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof currentTrial>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CurrentTrialQueryResult = NonNullable<Awaited<ReturnType<typeof currentTrial>>>
export type CurrentTrialQueryError = ProblemDetail


export function useCurrentTrial<TData = Awaited<ReturnType<typeof currentTrial>>, TError = ProblemDetail>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentTrial>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentTrial>>,
          TError,
          Awaited<ReturnType<typeof currentTrial>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentTrial<TData = Awaited<ReturnType<typeof currentTrial>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentTrial>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentTrial>>,
          TError,
          Awaited<ReturnType<typeof currentTrial>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentTrial<TData = Awaited<ReturnType<typeof currentTrial>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentTrial>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The account's current trial (countdown + included flags + pending SLA), or null
 */

export function useCurrentTrial<TData = Awaited<ReturnType<typeof currentTrial>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentTrial>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCurrentTrialQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getStartSelfServeTrialUrl = () => {




  return `/api/v1/billing/trial`
}

export const startSelfServeTrial = async ( options?: RequestInit): Promise<TrialStartedResponse> => {

  return customInstance<TrialStartedResponse>(getStartSelfServeTrialUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getStartSelfServeTrialMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSelfServeTrial>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof startSelfServeTrial>>, TError,void, TContext> => {

const mutationKey = ['startSelfServeTrial'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startSelfServeTrial>>, void> = () => {


          return  startSelfServeTrial(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartSelfServeTrialMutationResult = NonNullable<Awaited<ReturnType<typeof startSelfServeTrial>>>

    export type StartSelfServeTrialMutationError = ProblemDetail

    export const useStartSelfServeTrial = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSelfServeTrial>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startSelfServeTrial>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getStartSelfServeTrialMutationOptions(options), queryClient);
    }

export const getConversionPreviewUrl = () => {




  return `/api/v1/billing/trial/conversion-preview`
}

/**
 * @summary The flags currently in use that a candidate plan would drop on conversion (edge case 7)
 */
export const conversionPreview = async (conversionPreviewRequest: ConversionPreviewRequest, options?: RequestInit): Promise<ConversionPreviewResponse> => {

  return customInstance<ConversionPreviewResponse>(getConversionPreviewUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(conversionPreviewRequest)
  }
);}




export const getConversionPreviewMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof conversionPreview>>, TError,{data: ConversionPreviewRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof conversionPreview>>, TError,{data: ConversionPreviewRequest}, TContext> => {

const mutationKey = ['conversionPreview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof conversionPreview>>, {data: ConversionPreviewRequest}> = (props) => {
          const {data} = props ?? {};

          return  conversionPreview(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConversionPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof conversionPreview>>>
    export type ConversionPreviewMutationBody = ConversionPreviewRequest
    export type ConversionPreviewMutationError = ProblemDetail

    /**
 * @summary The flags currently in use that a candidate plan would drop on conversion (edge case 7)
 */
export const useConversionPreview = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof conversionPreview>>, TError,{data: ConversionPreviewRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof conversionPreview>>,
        TError,
        {data: ConversionPreviewRequest},
        TContext
      > => {
      return useMutation(getConversionPreviewMutationOptions(options), queryClient);
    }

export const getReceiveUrl = () => {




  return `/api/v1/billing/stripe/webhook`
}

/**
 * @summary Receive + process Stripe subscription/invoice/dispute webhooks (signature-verified)
 */
export const receive = async (receiveBody: string, options?: RequestInit): Promise<void> => {

  return customInstance<void>(getReceiveUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(receiveBody)
  }
);}




export const getReceiveMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receive>>, TError,{data: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof receive>>, TError,{data: string}, TContext> => {

const mutationKey = ['receive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof receive>>, {data: string}> = (props) => {
          const {data} = props ?? {};

          return  receive(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReceiveMutationResult = NonNullable<Awaited<ReturnType<typeof receive>>>
    export type ReceiveMutationBody = string
    export type ReceiveMutationError = ProblemDetail

    /**
 * @summary Receive + process Stripe subscription/invoice/dispute webhooks (signature-verified)
 */
export const useReceive = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof receive>>, TError,{data: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof receive>>,
        TError,
        {data: string},
        TContext
      > => {
      return useMutation(getReceiveMutationOptions(options), queryClient);
    }

export const getPortalSessionUrl = () => {




  return `/api/v1/billing/portal-session`
}

/**
 * @summary A Stripe Billing Portal URL — the customer manages the card + views/downloads invoices there.
 */
export const portalSession = async (portalSessionRequest: PortalSessionRequest, options?: RequestInit): Promise<PortalSessionResponse> => {

  return customInstance<PortalSessionResponse>(getPortalSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(portalSessionRequest)
  }
);}




export const getPortalSessionMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof portalSession>>, TError,{data: PortalSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof portalSession>>, TError,{data: PortalSessionRequest}, TContext> => {

const mutationKey = ['portalSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof portalSession>>, {data: PortalSessionRequest}> = (props) => {
          const {data} = props ?? {};

          return  portalSession(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PortalSessionMutationResult = NonNullable<Awaited<ReturnType<typeof portalSession>>>
    export type PortalSessionMutationBody = PortalSessionRequest
    export type PortalSessionMutationError = ProblemDetail

    /**
 * @summary A Stripe Billing Portal URL — the customer manages the card + views/downloads invoices there.
 */
export const usePortalSession = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof portalSession>>, TError,{data: PortalSessionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof portalSession>>,
        TError,
        {data: PortalSessionRequest},
        TContext
      > => {
      return useMutation(getPortalSessionMutationOptions(options), queryClient);
    }

export const getJoinUrl = (venueId: string,) => {




  return `/api/public/v1/venues/${venueId}/waitlist`
}

/**
 * @summary Join the waitlist when no slot is open. Neutral confirmation (GU-4).
 */
export const join = async (venueId: string,
    publicJoinRequest: PublicJoinRequest, options?: RequestInit): Promise<PublicWaitlistJoinResponse> => {

  return customInstance<PublicWaitlistJoinResponse>(getJoinUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(publicJoinRequest)
  }
);}




export const getJoinMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof join>>, TError,{venueId: string;data: PublicJoinRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof join>>, TError,{venueId: string;data: PublicJoinRequest}, TContext> => {

const mutationKey = ['join'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof join>>, {venueId: string;data: PublicJoinRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  join(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JoinMutationResult = NonNullable<Awaited<ReturnType<typeof join>>>
    export type JoinMutationBody = PublicJoinRequest
    export type JoinMutationError = ProblemDetail

    /**
 * @summary Join the waitlist when no slot is open. Neutral confirmation (GU-4).
 */
export const useJoin = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof join>>, TError,{venueId: string;data: PublicJoinRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof join>>,
        TError,
        {venueId: string;data: PublicJoinRequest},
        TContext
      > => {
      return useMutation(getJoinMutationOptions(options), queryClient);
    }

export const getCancel3Url = (venueId: string,
    token: string,) => {




  return `/api/public/v1/venues/${venueId}/waitlist/status/${token}/cancel`
}

/**
 * @summary Cancel from the status page → CANCELLED(GUEST) (R4); 409 STALE_WRITE on a lost CAS
 */
export const cancel3 = async (venueId: string,
    token: string,
    waitlistStatusCancelRequest: WaitlistStatusCancelRequest, options?: RequestInit): Promise<Cancel3200> => {

  return customInstance<Cancel3200>(getCancel3Url(venueId,token),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(waitlistStatusCancelRequest)
  }
);}




export const getCancel3MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancel3>>, TError,{venueId: string;token: string;data: WaitlistStatusCancelRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancel3>>, TError,{venueId: string;token: string;data: WaitlistStatusCancelRequest}, TContext> => {

const mutationKey = ['cancel3'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancel3>>, {venueId: string;token: string;data: WaitlistStatusCancelRequest}> = (props) => {
          const {venueId,token,data} = props ?? {};

          return  cancel3(venueId,token,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type Cancel3MutationResult = NonNullable<Awaited<ReturnType<typeof cancel3>>>
    export type Cancel3MutationBody = WaitlistStatusCancelRequest
    export type Cancel3MutationError = ProblemDetail

    /**
 * @summary Cancel from the status page → CANCELLED(GUEST) (R4); 409 STALE_WRITE on a lost CAS
 */
export const useCancel3 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancel3>>, TError,{venueId: string;token: string;data: WaitlistStatusCancelRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancel3>>,
        TError,
        {venueId: string;token: string;data: WaitlistStatusCancelRequest},
        TContext
      > => {
      return useMutation(getCancel3MutationOptions(options), queryClient);
    }

export const getWithdrawUrl = (venueId: string,
    token: string,) => {




  return `/api/public/v1/venues/${venueId}/manage/${token}/withdraw`
}

/**
 * @summary Withdraw a PENDING request before any decision (no cutoff) — CANCELLED(GUEST) + WITHDRAWN
 */
export const withdraw = async (venueId: string,
    token: string,
    withdrawRequestBody: WithdrawRequestBody, options?: RequestInit): Promise<WithdrawResponse> => {

  return customInstance<WithdrawResponse>(getWithdrawUrl(venueId,token),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(withdrawRequestBody)
  }
);}




export const getWithdrawMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof withdraw>>, TError,{venueId: string;token: string;data: WithdrawRequestBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof withdraw>>, TError,{venueId: string;token: string;data: WithdrawRequestBody}, TContext> => {

const mutationKey = ['withdraw'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof withdraw>>, {venueId: string;token: string;data: WithdrawRequestBody}> = (props) => {
          const {venueId,token,data} = props ?? {};

          return  withdraw(venueId,token,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WithdrawMutationResult = NonNullable<Awaited<ReturnType<typeof withdraw>>>
    export type WithdrawMutationBody = WithdrawRequestBody
    export type WithdrawMutationError = ProblemDetail

    /**
 * @summary Withdraw a PENDING request before any decision (no cutoff) — CANCELLED(GUEST) + WITHDRAWN
 */
export const useWithdraw = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof withdraw>>, TError,{venueId: string;token: string;data: WithdrawRequestBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof withdraw>>,
        TError,
        {venueId: string;token: string;data: WithdrawRequestBody},
        TContext
      > => {
      return useMutation(getWithdrawMutationOptions(options), queryClient);
    }

export const getUnsubscribeUrl = (venueId: string,
    token: string,) => {




  return `/api/public/v1/venues/${venueId}/manage/${token}/unsubscribe`
}

/**
 * @summary One-click unsubscribe from reminder/follow-up emails (RFC 8058 List-Unsubscribe-Post) — idempotent 204
 */
export const unsubscribe = async (venueId: string,
    token: string, options?: RequestInit): Promise<void> => {

  return customInstance<void>(getUnsubscribeUrl(venueId,token),
  {
    ...options,
    method: 'POST'


  }
);}




export const getUnsubscribeMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unsubscribe>>, TError,{venueId: string;token: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unsubscribe>>, TError,{venueId: string;token: string}, TContext> => {

const mutationKey = ['unsubscribe'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unsubscribe>>, {venueId: string;token: string}> = (props) => {
          const {venueId,token} = props ?? {};

          return  unsubscribe(venueId,token,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnsubscribeMutationResult = NonNullable<Awaited<ReturnType<typeof unsubscribe>>>

    export type UnsubscribeMutationError = ProblemDetail

    /**
 * @summary One-click unsubscribe from reminder/follow-up emails (RFC 8058 List-Unsubscribe-Post) — idempotent 204
 */
export const useUnsubscribe = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unsubscribe>>, TError,{venueId: string;token: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unsubscribe>>,
        TError,
        {venueId: string;token: string},
        TContext
      > => {
      return useMutation(getUnsubscribeMutationOptions(options), queryClient);
    }

export const getModifyUrl = (venueId: string,
    token: string,) => {




  return `/api/public/v1/venues/${venueId}/manage/${token}/modify`
}

/**
 * @summary Modify a booking (date/time/party, PATCH field-mask, BK-4) — 409 STALE_WRITE on a lost CAS
 */
export const modify = async (venueId: string,
    token: string,
    modifyManageRequest: ModifyManageRequest, options?: RequestInit): Promise<Modify200> => {

  return customInstance<Modify200>(getModifyUrl(venueId,token),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(modifyManageRequest)
  }
);}




export const getModifyMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof modify>>, TError,{venueId: string;token: string;data: ModifyManageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof modify>>, TError,{venueId: string;token: string;data: ModifyManageRequest}, TContext> => {

const mutationKey = ['modify'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof modify>>, {venueId: string;token: string;data: ModifyManageRequest}> = (props) => {
          const {venueId,token,data} = props ?? {};

          return  modify(venueId,token,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ModifyMutationResult = NonNullable<Awaited<ReturnType<typeof modify>>>
    export type ModifyMutationBody = ModifyManageRequest
    export type ModifyMutationError = ProblemDetail

    /**
 * @summary Modify a booking (date/time/party, PATCH field-mask, BK-4) — 409 STALE_WRITE on a lost CAS
 */
export const useModify = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof modify>>, TError,{venueId: string;token: string;data: ModifyManageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof modify>>,
        TError,
        {venueId: string;token: string;data: ModifyManageRequest},
        TContext
      > => {
      return useMutation(getModifyMutationOptions(options), queryClient);
    }

export const getCancel4Url = (venueId: string,
    token: string,) => {




  return `/api/public/v1/venues/${venueId}/manage/${token}/cancel`
}

/**
 * @summary Cancel a booking within the canonical cutoff (BK-6); already-cancelled answers 200 idempotently
 */
export const cancel4 = async (venueId: string,
    token: string,
    cancelManageRequest: CancelManageRequest, options?: RequestInit): Promise<Cancel4200> => {

  return customInstance<Cancel4200>(getCancel4Url(venueId,token),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cancelManageRequest)
  }
);}




export const getCancel4MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancel4>>, TError,{venueId: string;token: string;data: CancelManageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancel4>>, TError,{venueId: string;token: string;data: CancelManageRequest}, TContext> => {

const mutationKey = ['cancel4'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancel4>>, {venueId: string;token: string;data: CancelManageRequest}> = (props) => {
          const {venueId,token,data} = props ?? {};

          return  cancel4(venueId,token,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type Cancel4MutationResult = NonNullable<Awaited<ReturnType<typeof cancel4>>>
    export type Cancel4MutationBody = CancelManageRequest
    export type Cancel4MutationError = ProblemDetail

    /**
 * @summary Cancel a booking within the canonical cutoff (BK-6); already-cancelled answers 200 idempotently
 */
export const useCancel4 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancel4>>, TError,{venueId: string;token: string;data: CancelManageRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancel4>>,
        TError,
        {venueId: string;token: string;data: CancelManageRequest},
        TContext
      > => {
      return useMutation(getCancel4MutationOptions(options), queryClient);
    }

export const getPlaceHoldUrl = (venueId: string,) => {




  return `/api/public/v1/venues/${venueId}/holds`
}

/**
 * @summary Place a pre-submit hold for a slot (the countdown resource, §D.4)
 */
export const placeHold = async (venueId: string,
    placeHoldRequest: PlaceHoldRequest, options?: RequestInit): Promise<HoldResponse> => {

  return customInstance<HoldResponse>(getPlaceHoldUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(placeHoldRequest)
  }
);}




export const getPlaceHoldMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof placeHold>>, TError,{venueId: string;data: PlaceHoldRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof placeHold>>, TError,{venueId: string;data: PlaceHoldRequest}, TContext> => {

const mutationKey = ['placeHold'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof placeHold>>, {venueId: string;data: PlaceHoldRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  placeHold(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlaceHoldMutationResult = NonNullable<Awaited<ReturnType<typeof placeHold>>>
    export type PlaceHoldMutationBody = PlaceHoldRequest
    export type PlaceHoldMutationError = ProblemDetail

    /**
 * @summary Place a pre-submit hold for a slot (the countdown resource, §D.4)
 */
export const usePlaceHold = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof placeHold>>, TError,{venueId: string;data: PlaceHoldRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof placeHold>>,
        TError,
        {venueId: string;data: PlaceHoldRequest},
        TContext
      > => {
      return useMutation(getPlaceHoldMutationOptions(options), queryClient);
    }

export const getIntakeUrl = (venueId: string,) => {




  return `/api/public/v1/venues/${venueId}/dsr`
}

/**
 * @summary Open a data-subject request (access/erasure) — emails a verification link (art. 12(6))
 */
export const intake = async (venueId: string,
    dsrIntakeRequest: DsrIntakeRequest, options?: RequestInit): Promise<DsrIntakeResponse> => {

  return customInstance<DsrIntakeResponse>(getIntakeUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(dsrIntakeRequest)
  }
);}




export const getIntakeMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof intake>>, TError,{venueId: string;data: DsrIntakeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof intake>>, TError,{venueId: string;data: DsrIntakeRequest}, TContext> => {

const mutationKey = ['intake'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof intake>>, {venueId: string;data: DsrIntakeRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  intake(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IntakeMutationResult = NonNullable<Awaited<ReturnType<typeof intake>>>
    export type IntakeMutationBody = DsrIntakeRequest
    export type IntakeMutationError = ProblemDetail

    /**
 * @summary Open a data-subject request (access/erasure) — emails a verification link (art. 12(6))
 */
export const useIntake = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof intake>>, TError,{venueId: string;data: DsrIntakeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof intake>>,
        TError,
        {venueId: string;data: DsrIntakeRequest},
        TContext
      > => {
      return useMutation(getIntakeMutationOptions(options), queryClient);
    }

export const getVerifyUrl = (venueId: string,) => {




  return `/api/public/v1/venues/${venueId}/dsr/verify`
}

/**
 * @summary Verify a DSR magic link → OPEN (starts the 30-day statutory clock)
 */
export const verify = async (venueId: string,
    dsrVerifyRequest: DsrVerifyRequest, options?: RequestInit): Promise<DsrVerifyResponse> => {

  return customInstance<DsrVerifyResponse>(getVerifyUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(dsrVerifyRequest)
  }
);}




export const getVerifyMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verify>>, TError,{venueId: string;data: DsrVerifyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof verify>>, TError,{venueId: string;data: DsrVerifyRequest}, TContext> => {

const mutationKey = ['verify'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verify>>, {venueId: string;data: DsrVerifyRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  verify(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyMutationResult = NonNullable<Awaited<ReturnType<typeof verify>>>
    export type VerifyMutationBody = DsrVerifyRequest
    export type VerifyMutationError = ProblemDetail

    /**
 * @summary Verify a DSR magic link → OPEN (starts the 30-day statutory clock)
 */
export const useVerify = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verify>>, TError,{venueId: string;data: DsrVerifyRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verify>>,
        TError,
        {venueId: string;data: DsrVerifyRequest},
        TContext
      > => {
      return useMutation(getVerifyMutationOptions(options), queryClient);
    }

export const getCookieConsentUrl = (venueId: string,) => {




  return `/api/public/v1/venues/${venueId}/cookie-consent`
}

/**
 * @summary Record a cookie-banner choice server-side (anonymous, no IP/fingerprint) (R1/R2)
 */
export const cookieConsent = async (venueId: string,
    cookieConsentRequest: CookieConsentRequest, options?: RequestInit): Promise<CookieConsentResponse> => {

  return customInstance<CookieConsentResponse>(getCookieConsentUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cookieConsentRequest)
  }
);}




export const getCookieConsentMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cookieConsent>>, TError,{venueId: string;data: CookieConsentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cookieConsent>>, TError,{venueId: string;data: CookieConsentRequest}, TContext> => {

const mutationKey = ['cookieConsent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cookieConsent>>, {venueId: string;data: CookieConsentRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  cookieConsent(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CookieConsentMutationResult = NonNullable<Awaited<ReturnType<typeof cookieConsent>>>
    export type CookieConsentMutationBody = CookieConsentRequest
    export type CookieConsentMutationError = ProblemDetail

    /**
 * @summary Record a cookie-banner choice server-side (anonymous, no IP/fingerprint) (R1/R2)
 */
export const useCookieConsent = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cookieConsent>>, TError,{venueId: string;data: CookieConsentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cookieConsent>>,
        TError,
        {venueId: string;data: CookieConsentRequest},
        TContext
      > => {
      return useMutation(getCookieConsentMutationOptions(options), queryClient);
    }

export const getCreatePublicBookingUrl = (venueId: string,) => {




  return `/api/public/v1/venues/${venueId}/bookings`
}

/**
 * @summary Submit a booking — 201 CONFIRMED (instant-confirm) or 202 PENDING (request)
 */
export const createPublicBooking = async (venueId: string,
    createBookingRequest: CreateBookingRequest, options?: RequestInit): Promise<BookingSubmitResponse> => {

  return customInstance<BookingSubmitResponse>(getCreatePublicBookingUrl(venueId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createBookingRequest)
  }
);}




export const getCreatePublicBookingMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPublicBooking>>, TError,{venueId: string;data: CreateBookingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createPublicBooking>>, TError,{venueId: string;data: CreateBookingRequest}, TContext> => {

const mutationKey = ['createPublicBooking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPublicBooking>>, {venueId: string;data: CreateBookingRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  createPublicBooking(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePublicBookingMutationResult = NonNullable<Awaited<ReturnType<typeof createPublicBooking>>>
    export type CreatePublicBookingMutationBody = CreateBookingRequest
    export type CreatePublicBookingMutationError = ProblemDetail

    /**
 * @summary Submit a booking — 201 CONFIRMED (instant-confirm) or 202 PENDING (request)
 */
export const useCreatePublicBooking = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPublicBooking>>, TError,{venueId: string;data: CreateBookingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPublicBooking>>,
        TError,
        {venueId: string;data: CreateBookingRequest},
        TContext
      > => {
      return useMutation(getCreatePublicBookingMutationOptions(options), queryClient);
    }

export const getSetupIntentUrl = (venueId: string,
    bookingId: string,) => {




  return `/api/public/v1/venues/${venueId}/bookings/${bookingId}/guarantee/setup-intent`
}

/**
 * @summary Record guarantee-terms consent (R7) + return a SetupIntent client secret (R3, no charge)
 */
export const setupIntent = async (venueId: string,
    bookingId: string,
    startCaptureRequest: StartCaptureRequest, options?: RequestInit): Promise<CaptureSessionResponse> => {

  return customInstance<CaptureSessionResponse>(getSetupIntentUrl(venueId,bookingId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(startCaptureRequest)
  }
);}




export const getSetupIntentMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setupIntent>>, TError,{venueId: string;bookingId: string;data: StartCaptureRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setupIntent>>, TError,{venueId: string;bookingId: string;data: StartCaptureRequest}, TContext> => {

const mutationKey = ['setupIntent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setupIntent>>, {venueId: string;bookingId: string;data: StartCaptureRequest}> = (props) => {
          const {venueId,bookingId,data} = props ?? {};

          return  setupIntent(venueId,bookingId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetupIntentMutationResult = NonNullable<Awaited<ReturnType<typeof setupIntent>>>
    export type SetupIntentMutationBody = StartCaptureRequest
    export type SetupIntentMutationError = ProblemDetail

    /**
 * @summary Record guarantee-terms consent (R7) + return a SetupIntent client secret (R3, no charge)
 */
export const useSetupIntent = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setupIntent>>, TError,{venueId: string;bookingId: string;data: StartCaptureRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setupIntent>>,
        TError,
        {venueId: string;bookingId: string;data: StartCaptureRequest},
        TContext
      > => {
      return useMutation(getSetupIntentMutationOptions(options), queryClient);
    }

export const getConfirm4Url = (venueId: string,
    bookingId: string,) => {




  return `/api/public/v1/venues/${venueId}/bookings/${bookingId}/guarantee/confirm`
}

/**
 * @summary Store the captured identity + off-session credential; fingerprint blacklist check (R8)
 */
export const confirm4 = async (venueId: string,
    bookingId: string,
    confirmCaptureRequest: ConfirmCaptureRequest, options?: RequestInit): Promise<CaptureResultResponse> => {

  return customInstance<CaptureResultResponse>(getConfirm4Url(venueId,bookingId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(confirmCaptureRequest)
  }
);}




export const getConfirm4MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirm4>>, TError,{venueId: string;bookingId: string;data: ConfirmCaptureRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof confirm4>>, TError,{venueId: string;bookingId: string;data: ConfirmCaptureRequest}, TContext> => {

const mutationKey = ['confirm4'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirm4>>, {venueId: string;bookingId: string;data: ConfirmCaptureRequest}> = (props) => {
          const {venueId,bookingId,data} = props ?? {};

          return  confirm4(venueId,bookingId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type Confirm4MutationResult = NonNullable<Awaited<ReturnType<typeof confirm4>>>
    export type Confirm4MutationBody = ConfirmCaptureRequest
    export type Confirm4MutationError = ProblemDetail

    /**
 * @summary Store the captured identity + off-session credential; fingerprint blacklist check (R8)
 */
export const useConfirm4 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirm4>>, TError,{venueId: string;bookingId: string;data: ConfirmCaptureRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirm4>>,
        TError,
        {venueId: string;bookingId: string;data: ConfirmCaptureRequest},
        TContext
      > => {
      return useMutation(getConfirm4MutationOptions(options), queryClient);
    }

export const getGet4Url = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/site`
}

/**
 * @summary The venue's site: draft + published content, branding, CTA, offline, versions
 */
export const get4 = async (venueId: string, options?: RequestInit): Promise<SiteResponse> => {

  return customInstance<SiteResponse>(getGet4Url(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGet4QueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/site`
    ] as const;
    }


export const getGet4QueryOptions = <TData = Awaited<ReturnType<typeof get4>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get4>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGet4QueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get4>>> = ({ signal }) => get4(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get4>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Get4QueryResult = NonNullable<Awaited<ReturnType<typeof get4>>>
export type Get4QueryError = ProblemDetail


export function useGet4<TData = Awaited<ReturnType<typeof get4>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get4>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get4>>,
          TError,
          Awaited<ReturnType<typeof get4>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet4<TData = Awaited<ReturnType<typeof get4>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get4>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get4>>,
          TError,
          Awaited<ReturnType<typeof get4>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet4<TData = Awaited<ReturnType<typeof get4>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get4>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The venue's site: draft + published content, branding, CTA, offline, versions
 */

export function useGet4<TData = Awaited<ReturnType<typeof get4>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get4>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGet4QueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getEditDraftUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/site`
}

/**
 * @summary Replace the editable draft + branding (CAS 409 stale; 422 non-LIVE/other-venue asset)
 */
export const editDraft = async (venueId: string,
    siteDraftRequest: SiteDraftRequest, options?: RequestInit): Promise<SiteResponse> => {

  return customInstance<SiteResponse>(getEditDraftUrl(venueId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(siteDraftRequest)
  }
);}




export const getEditDraftMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editDraft>>, TError,{venueId: string;data: SiteDraftRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof editDraft>>, TError,{venueId: string;data: SiteDraftRequest}, TContext> => {

const mutationKey = ['editDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editDraft>>, {venueId: string;data: SiteDraftRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  editDraft(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditDraftMutationResult = NonNullable<Awaited<ReturnType<typeof editDraft>>>
    export type EditDraftMutationBody = SiteDraftRequest
    export type EditDraftMutationError = ProblemDetail

    /**
 * @summary Replace the editable draft + branding (CAS 409 stale; 422 non-LIVE/other-venue asset)
 */
export const useEditDraft = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editDraft>>, TError,{venueId: string;data: SiteDraftRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editDraft>>,
        TError,
        {venueId: string;data: SiteDraftRequest},
        TContext
      > => {
      return useMutation(getEditDraftMutationOptions(options), queryClient);
    }

export const getSetSeoIndexableUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/site/seo`
}

/**
 * @summary Set the 'hidden from search' toggle (CAS); emits SiteIndexabilityChanged. Flips the edge X-Robots-Tag instantly + queues a reason=seo rebuild (venue-seo R1/R2)
 */
export const setSeoIndexable = async (venueId: string,
    seoIndexableRequest: SeoIndexableRequest, options?: RequestInit): Promise<SiteResponse> => {

  return customInstance<SiteResponse>(getSetSeoIndexableUrl(venueId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(seoIndexableRequest)
  }
);}




export const getSetSeoIndexableMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSeoIndexable>>, TError,{venueId: string;data: SeoIndexableRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setSeoIndexable>>, TError,{venueId: string;data: SeoIndexableRequest}, TContext> => {

const mutationKey = ['setSeoIndexable'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSeoIndexable>>, {venueId: string;data: SeoIndexableRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  setSeoIndexable(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetSeoIndexableMutationResult = NonNullable<Awaited<ReturnType<typeof setSeoIndexable>>>
    export type SetSeoIndexableMutationBody = SeoIndexableRequest
    export type SetSeoIndexableMutationError = ProblemDetail

    /**
 * @summary Set the 'hidden from search' toggle (CAS); emits SiteIndexabilityChanged. Flips the edge X-Robots-Tag instantly + queues a reason=seo rebuild (venue-seo R1/R2)
 */
export const useSetSeoIndexable = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSeoIndexable>>, TError,{venueId: string;data: SeoIndexableRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setSeoIndexable>>,
        TError,
        {venueId: string;data: SeoIndexableRequest},
        TContext
      > => {
      return useMutation(getSetSeoIndexableMutationOptions(options), queryClient);
    }

export const getGet5Url = (venueId: string,
    serviceId: string,) => {




  return `/api/v1/venues/${venueId}/services/${serviceId}`
}

/**
 * @summary Fetch a service
 */
export const get5 = async (venueId: string,
    serviceId: string, options?: RequestInit): Promise<ServiceResponse> => {

  return customInstance<ServiceResponse>(getGet5Url(venueId,serviceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGet5QueryKey = (venueId: string,
    serviceId: string,) => {
    return [
    `/api/v1/venues/${venueId}/services/${serviceId}`
    ] as const;
    }


export const getGet5QueryOptions = <TData = Awaited<ReturnType<typeof get5>>, TError = ProblemDetail>(venueId: string,
    serviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get5>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGet5QueryKey(venueId,serviceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get5>>> = ({ signal }) => get5(venueId,serviceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined && serviceId !== null && serviceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get5>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Get5QueryResult = NonNullable<Awaited<ReturnType<typeof get5>>>
export type Get5QueryError = ProblemDetail


export function useGet5<TData = Awaited<ReturnType<typeof get5>>, TError = ProblemDetail>(
 venueId: string,
    serviceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get5>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get5>>,
          TError,
          Awaited<ReturnType<typeof get5>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet5<TData = Awaited<ReturnType<typeof get5>>, TError = ProblemDetail>(
 venueId: string,
    serviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get5>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get5>>,
          TError,
          Awaited<ReturnType<typeof get5>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet5<TData = Awaited<ReturnType<typeof get5>>, TError = ProblemDetail>(
 venueId: string,
    serviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get5>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch a service
 */

export function useGet5<TData = Awaited<ReturnType<typeof get5>>, TError = ProblemDetail>(
 venueId: string,
    serviceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get5>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGet5QueryOptions(venueId,serviceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getDeactivate1Url = (venueId: string,
    serviceId: string,
    params?: Deactivate1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/venues/${venueId}/services/${serviceId}?${stringifiedParams}` : `/api/v1/venues/${venueId}/services/${serviceId}`
}

/**
 * @summary Deactivate (soft-delete) a service
 */
export const deactivate1 = async (venueId: string,
    serviceId: string,
    params?: Deactivate1Params, options?: RequestInit): Promise<ServiceResponse> => {

  return customInstance<ServiceResponse>(getDeactivate1Url(venueId,serviceId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeactivate1MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivate1>>, TError,{venueId: string;serviceId: string;params?: Deactivate1Params}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deactivate1>>, TError,{venueId: string;serviceId: string;params?: Deactivate1Params}, TContext> => {

const mutationKey = ['deactivate1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivate1>>, {venueId: string;serviceId: string;params?: Deactivate1Params}> = (props) => {
          const {venueId,serviceId,params} = props ?? {};

          return  deactivate1(venueId,serviceId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type Deactivate1MutationResult = NonNullable<Awaited<ReturnType<typeof deactivate1>>>

    export type Deactivate1MutationError = ProblemDetail

    /**
 * @summary Deactivate (soft-delete) a service
 */
export const useDeactivate1 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivate1>>, TError,{venueId: string;serviceId: string;params?: Deactivate1Params}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deactivate1>>,
        TError,
        {venueId: string;serviceId: string;params?: Deactivate1Params},
        TContext
      > => {
      return useMutation(getDeactivate1MutationOptions(options), queryClient);
    }

export const getUpdate1Url = (venueId: string,
    serviceId: string,) => {




  return `/api/v1/venues/${venueId}/services/${serviceId}`
}

/**
 * @summary Update a service — 409 + current version on a stale CAS (§D.3)
 */
export const update1 = async (venueId: string,
    serviceId: string,
    serviceRequest: ServiceRequest, options?: RequestInit): Promise<ServiceResponse> => {

  return customInstance<ServiceResponse>(getUpdate1Url(venueId,serviceId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(serviceRequest)
  }
);}




export const getUpdate1MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof update1>>, TError,{venueId: string;serviceId: string;data: ServiceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof update1>>, TError,{venueId: string;serviceId: string;data: ServiceRequest}, TContext> => {

const mutationKey = ['update1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof update1>>, {venueId: string;serviceId: string;data: ServiceRequest}> = (props) => {
          const {venueId,serviceId,data} = props ?? {};

          return  update1(venueId,serviceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type Update1MutationResult = NonNullable<Awaited<ReturnType<typeof update1>>>
    export type Update1MutationBody = ServiceRequest
    export type Update1MutationError = ProblemDetail

    /**
 * @summary Update a service — 409 + current version on a stale CAS (§D.3)
 */
export const useUpdate1 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof update1>>, TError,{venueId: string;serviceId: string;data: ServiceRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof update1>>,
        TError,
        {venueId: string;serviceId: string;data: ServiceRequest},
        TContext
      > => {
      return useMutation(getUpdate1MutationOptions(options), queryClient);
    }

export const getGet6Url = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/profile`
}

/**
 * @summary Read the venue profile (displayName, legalName, category, contact) for the onboarding step
 */
export const get6 = async (venueId: string, options?: RequestInit): Promise<VenueProfileResponse> => {

  return customInstance<VenueProfileResponse>(getGet6Url(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGet6QueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/profile`
    ] as const;
    }


export const getGet6QueryOptions = <TData = Awaited<ReturnType<typeof get6>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get6>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGet6QueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get6>>> = ({ signal }) => get6(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get6>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Get6QueryResult = NonNullable<Awaited<ReturnType<typeof get6>>>
export type Get6QueryError = ProblemDetail


export function useGet6<TData = Awaited<ReturnType<typeof get6>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get6>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get6>>,
          TError,
          Awaited<ReturnType<typeof get6>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet6<TData = Awaited<ReturnType<typeof get6>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get6>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get6>>,
          TError,
          Awaited<ReturnType<typeof get6>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet6<TData = Awaited<ReturnType<typeof get6>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get6>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read the venue profile (displayName, legalName, category, contact) for the onboarding step
 */

export function useGet6<TData = Awaited<ReturnType<typeof get6>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get6>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGet6QueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdate2Url = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/profile`
}

/**
 * @summary Update the venue profile (displayName, legalName, category, contact) — marks PROFILE done
 */
export const update2 = async (venueId: string,
    updateProfileRequest: UpdateProfileRequest, options?: RequestInit): Promise<VenueProfileResponse> => {

  return customInstance<VenueProfileResponse>(getUpdate2Url(venueId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateProfileRequest)
  }
);}




export const getUpdate2MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof update2>>, TError,{venueId: string;data: UpdateProfileRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof update2>>, TError,{venueId: string;data: UpdateProfileRequest}, TContext> => {

const mutationKey = ['update2'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof update2>>, {venueId: string;data: UpdateProfileRequest}> = (props) => {
          const {venueId,data} = props ?? {};

          return  update2(venueId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type Update2MutationResult = NonNullable<Awaited<ReturnType<typeof update2>>>
    export type Update2MutationBody = UpdateProfileRequest
    export type Update2MutationError = ProblemDetail

    /**
 * @summary Update the venue profile (displayName, legalName, category, contact) — marks PROFILE done
 */
export const useUpdate2 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof update2>>, TError,{venueId: string;data: UpdateProfileRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof update2>>,
        TError,
        {venueId: string;data: UpdateProfileRequest},
        TContext
      > => {
      return useMutation(getUpdate2MutationOptions(options), queryClient);
    }

export const getEditUrl = (venueId: string,
    bookingId: string,) => {




  return `/api/v1/venues/${venueId}/bookings/${bookingId}`
}

/**
 * @summary Edit/move/reschedule — claim-new-then-release-old (BK-4); 409 + current on stale CAS
 */
export const edit = async (venueId: string,
    bookingId: string,
    staffEditBookingRequest: StaffEditBookingRequest, options?: RequestInit): Promise<StaffBookingResponse> => {

  return customInstance<StaffBookingResponse>(getEditUrl(venueId,bookingId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(staffEditBookingRequest)
  }
);}




export const getEditMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof edit>>, TError,{venueId: string;bookingId: string;data: StaffEditBookingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof edit>>, TError,{venueId: string;bookingId: string;data: StaffEditBookingRequest}, TContext> => {

const mutationKey = ['edit'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof edit>>, {venueId: string;bookingId: string;data: StaffEditBookingRequest}> = (props) => {
          const {venueId,bookingId,data} = props ?? {};

          return  edit(venueId,bookingId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditMutationResult = NonNullable<Awaited<ReturnType<typeof edit>>>
    export type EditMutationBody = StaffEditBookingRequest
    export type EditMutationError = ProblemDetail

    /**
 * @summary Edit/move/reschedule — claim-new-then-release-old (BK-4); 409 + current on stale CAS
 */
export const useEdit = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof edit>>, TError,{venueId: string;bookingId: string;data: StaffEditBookingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof edit>>,
        TError,
        {venueId: string;bookingId: string;data: StaffEditBookingRequest},
        TContext
      > => {
      return useMutation(getEditMutationOptions(options), queryClient);
    }

export const getProposeNextUrl = (venueId: string,
    params: ProposeNextParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/venues/${venueId}/waitlist/propose-next?${stringifiedParams}` : `/api/v1/venues/${venueId}/waitlist/propose-next`
}

/**
 * @summary Server proposes the next FITTING entry by rank for a freed capacity (WL-2). Fit does not reorder.
 */
export const proposeNext = async (venueId: string,
    params: ProposeNextParams, options?: RequestInit): Promise<ProposeNextResponse> => {

  return customInstance<ProposeNextResponse>(getProposeNextUrl(venueId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProposeNextQueryKey = (venueId: string,
    params?: ProposeNextParams,) => {
    return [
    `/api/v1/venues/${venueId}/waitlist/propose-next`, ...(params ? [params] : [])
    ] as const;
    }


export const getProposeNextQueryOptions = <TData = Awaited<ReturnType<typeof proposeNext>>, TError = ProblemDetail>(venueId: string,
    params: ProposeNextParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proposeNext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProposeNextQueryKey(venueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof proposeNext>>> = ({ signal }) => proposeNext(venueId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof proposeNext>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProposeNextQueryResult = NonNullable<Awaited<ReturnType<typeof proposeNext>>>
export type ProposeNextQueryError = ProblemDetail


export function useProposeNext<TData = Awaited<ReturnType<typeof proposeNext>>, TError = ProblemDetail>(
 venueId: string,
    params: ProposeNextParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof proposeNext>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof proposeNext>>,
          TError,
          Awaited<ReturnType<typeof proposeNext>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProposeNext<TData = Awaited<ReturnType<typeof proposeNext>>, TError = ProblemDetail>(
 venueId: string,
    params: ProposeNextParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proposeNext>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof proposeNext>>,
          TError,
          Awaited<ReturnType<typeof proposeNext>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProposeNext<TData = Awaited<ReturnType<typeof proposeNext>>, TError = ProblemDetail>(
 venueId: string,
    params: ProposeNextParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proposeNext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Server proposes the next FITTING entry by rank for a freed capacity (WL-2). Fit does not reorder.
 */

export function useProposeNext<TData = Awaited<ReturnType<typeof proposeNext>>, TError = ProblemDetail>(
 venueId: string,
    params: ProposeNextParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proposeNext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProposeNextQueryOptions(venueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getStatusUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/place-match`
}

/**
 * @summary Read a venue's current Google place-match status + re-check marker
 */
export const status = async (venueId: string, options?: RequestInit): Promise<PlaceMatchStatusResponse> => {

  return customInstance<PlaceMatchStatusResponse>(getStatusUrl(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStatusQueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/place-match`
    ] as const;
    }


export const getStatusQueryOptions = <TData = Awaited<ReturnType<typeof status>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStatusQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof status>>> = ({ signal }) => status(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StatusQueryResult = NonNullable<Awaited<ReturnType<typeof status>>>
export type StatusQueryError = ProblemDetail


export function useStatus<TData = Awaited<ReturnType<typeof status>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof status>>,
          TError,
          Awaited<ReturnType<typeof status>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStatus<TData = Awaited<ReturnType<typeof status>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof status>>,
          TError,
          Awaited<ReturnType<typeof status>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStatus<TData = Awaited<ReturnType<typeof status>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read a venue's current Google place-match status + re-check marker
 */

export function useStatus<TData = Awaited<ReturnType<typeof status>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStatusQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getProgressUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/onboarding`
}

/**
 * @summary Read the onboarding progress checklist (resume-at-first-incomplete, R6)
 */
export const progress = async (venueId: string, options?: RequestInit): Promise<OnboardingProgressResponse> => {

  return customInstance<OnboardingProgressResponse>(getProgressUrl(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProgressQueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/onboarding`
    ] as const;
    }


export const getProgressQueryOptions = <TData = Awaited<ReturnType<typeof progress>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof progress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProgressQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof progress>>> = ({ signal }) => progress(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof progress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProgressQueryResult = NonNullable<Awaited<ReturnType<typeof progress>>>
export type ProgressQueryError = ProblemDetail


export function useProgress<TData = Awaited<ReturnType<typeof progress>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof progress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof progress>>,
          TError,
          Awaited<ReturnType<typeof progress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProgress<TData = Awaited<ReturnType<typeof progress>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof progress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof progress>>,
          TError,
          Awaited<ReturnType<typeof progress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProgress<TData = Awaited<ReturnType<typeof progress>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof progress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read the onboarding progress checklist (resume-at-first-incomplete, R6)
 */

export function useProgress<TData = Awaited<ReturnType<typeof progress>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof progress>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProgressQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getQuotaUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/media/quota`
}

/**
 * @summary The venue's storage quota meter (bytes used vs limit)
 */
export const quota = async (venueId: string, options?: RequestInit): Promise<QuotaResponse> => {

  return customInstance<QuotaResponse>(getQuotaUrl(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getQuotaQueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/media/quota`
    ] as const;
    }


export const getQuotaQueryOptions = <TData = Awaited<ReturnType<typeof quota>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof quota>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuotaQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof quota>>> = ({ signal }) => quota(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof quota>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type QuotaQueryResult = NonNullable<Awaited<ReturnType<typeof quota>>>
export type QuotaQueryError = ProblemDetail


export function useQuota<TData = Awaited<ReturnType<typeof quota>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof quota>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof quota>>,
          TError,
          Awaited<ReturnType<typeof quota>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQuota<TData = Awaited<ReturnType<typeof quota>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof quota>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof quota>>,
          TError,
          Awaited<ReturnType<typeof quota>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useQuota<TData = Awaited<ReturnType<typeof quota>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof quota>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The venue's storage quota meter (bytes used vs limit)
 */

export function useQuota<TData = Awaited<ReturnType<typeof quota>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof quota>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getQuotaQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getTimelineUrl = (venueId: string,
    params: TimelineParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/venues/${venueId}/live/timeline?${stringifiedParams}` : `/api/v1/venues/${venueId}/live/timeline`
}

/**
 * @summary Today's bookings + walk-ins for the venue-TZ service day, ordered by slot
 */
export const timeline = async (venueId: string,
    params: TimelineParams, options?: RequestInit): Promise<LiveTimelineRowResponse[]> => {

  return customInstance<LiveTimelineRowResponse[]>(getTimelineUrl(venueId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTimelineQueryKey = (venueId: string,
    params?: TimelineParams,) => {
    return [
    `/api/v1/venues/${venueId}/live/timeline`, ...(params ? [params] : [])
    ] as const;
    }


export const getTimelineQueryOptions = <TData = Awaited<ReturnType<typeof timeline>>, TError = ProblemDetail>(venueId: string,
    params: TimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timeline>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTimelineQueryKey(venueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof timeline>>> = ({ signal }) => timeline(venueId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof timeline>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TimelineQueryResult = NonNullable<Awaited<ReturnType<typeof timeline>>>
export type TimelineQueryError = ProblemDetail


export function useTimeline<TData = Awaited<ReturnType<typeof timeline>>, TError = ProblemDetail>(
 venueId: string,
    params: TimelineParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof timeline>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof timeline>>,
          TError,
          Awaited<ReturnType<typeof timeline>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimeline<TData = Awaited<ReturnType<typeof timeline>>, TError = ProblemDetail>(
 venueId: string,
    params: TimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timeline>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof timeline>>,
          TError,
          Awaited<ReturnType<typeof timeline>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimeline<TData = Awaited<ReturnType<typeof timeline>>, TError = ProblemDetail>(
 venueId: string,
    params: TimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timeline>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Today's bookings + walk-ins for the venue-TZ service day, ordered by slot
 */

export function useTimeline<TData = Awaited<ReturnType<typeof timeline>>, TError = ProblemDetail>(
 venueId: string,
    params: TimelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timeline>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTimelineQueryOptions(venueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getFloorUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/live/floor`
}

/**
 * @summary The live floor: per-table derived/recorded state + per-zone occupancy vs capacity
 */
export const floor = async (venueId: string, options?: RequestInit): Promise<LiveFloorResponse> => {

  return customInstance<LiveFloorResponse>(getFloorUrl(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFloorQueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/live/floor`
    ] as const;
    }


export const getFloorQueryOptions = <TData = Awaited<ReturnType<typeof floor>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof floor>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFloorQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof floor>>> = ({ signal }) => floor(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof floor>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FloorQueryResult = NonNullable<Awaited<ReturnType<typeof floor>>>
export type FloorQueryError = ProblemDetail


export function useFloor<TData = Awaited<ReturnType<typeof floor>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof floor>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof floor>>,
          TError,
          Awaited<ReturnType<typeof floor>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFloor<TData = Awaited<ReturnType<typeof floor>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof floor>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof floor>>,
          TError,
          Awaited<ReturnType<typeof floor>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFloor<TData = Awaited<ReturnType<typeof floor>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof floor>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The live floor: per-table derived/recorded state + per-zone occupancy vs capacity
 */

export function useFloor<TData = Awaited<ReturnType<typeof floor>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof floor>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFloorQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getList6Url = (venueId: string,
    params?: List6Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/venues/${venueId}/guests?${stringifiedParams}` : `/api/v1/venues/${venueId}/guests`
}

/**
 * @summary Cursor-paginated directory list/search (newest first)
 */
export const list6 = async (venueId: string,
    params?: List6Params, options?: RequestInit): Promise<GuestPageResponse> => {

  return customInstance<GuestPageResponse>(getList6Url(venueId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getList6QueryKey = (venueId: string,
    params?: List6Params,) => {
    return [
    `/api/v1/venues/${venueId}/guests`, ...(params ? [params] : [])
    ] as const;
    }


export const getList6QueryOptions = <TData = Awaited<ReturnType<typeof list6>>, TError = ProblemDetail>(venueId: string,
    params?: List6Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list6>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getList6QueryKey(venueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof list6>>> = ({ signal }) => list6(venueId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof list6>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type List6QueryResult = NonNullable<Awaited<ReturnType<typeof list6>>>
export type List6QueryError = ProblemDetail


export function useList6<TData = Awaited<ReturnType<typeof list6>>, TError = ProblemDetail>(
 venueId: string,
    params: undefined |  List6Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof list6>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof list6>>,
          TError,
          Awaited<ReturnType<typeof list6>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useList6<TData = Awaited<ReturnType<typeof list6>>, TError = ProblemDetail>(
 venueId: string,
    params?: List6Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list6>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof list6>>,
          TError,
          Awaited<ReturnType<typeof list6>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useList6<TData = Awaited<ReturnType<typeof list6>>, TError = ProblemDetail>(
 venueId: string,
    params?: List6Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list6>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Cursor-paginated directory list/search (newest first)
 */

export function useList6<TData = Awaited<ReturnType<typeof list6>>, TError = ProblemDetail>(
 venueId: string,
    params?: List6Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list6>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getList6QueryOptions(venueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getProfile1Url = (venueId: string,
    guestId: string,) => {




  return `/api/v1/venues/${venueId}/guests/${guestId}`
}

/**
 * @summary Full profile: counters, tags, notes, visit history (recent first)
 */
export const profile1 = async (venueId: string,
    guestId: string, options?: RequestInit): Promise<GuestProfileResponse> => {

  return customInstance<GuestProfileResponse>(getProfile1Url(venueId,guestId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProfile1QueryKey = (venueId: string,
    guestId: string,) => {
    return [
    `/api/v1/venues/${venueId}/guests/${guestId}`
    ] as const;
    }


export const getProfile1QueryOptions = <TData = Awaited<ReturnType<typeof profile1>>, TError = ProblemDetail>(venueId: string,
    guestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profile1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProfile1QueryKey(venueId,guestId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof profile1>>> = ({ signal }) => profile1(venueId,guestId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined && guestId !== null && guestId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof profile1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Profile1QueryResult = NonNullable<Awaited<ReturnType<typeof profile1>>>
export type Profile1QueryError = ProblemDetail


export function useProfile1<TData = Awaited<ReturnType<typeof profile1>>, TError = ProblemDetail>(
 venueId: string,
    guestId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof profile1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof profile1>>,
          TError,
          Awaited<ReturnType<typeof profile1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProfile1<TData = Awaited<ReturnType<typeof profile1>>, TError = ProblemDetail>(
 venueId: string,
    guestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profile1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof profile1>>,
          TError,
          Awaited<ReturnType<typeof profile1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProfile1<TData = Awaited<ReturnType<typeof profile1>>, TError = ProblemDetail>(
 venueId: string,
    guestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profile1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Full profile: counters, tags, notes, visit history (recent first)
 */

export function useProfile1<TData = Awaited<ReturnType<typeof profile1>>, TError = ProblemDetail>(
 venueId: string,
    guestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profile1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProfile1QueryOptions(venueId,guestId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGuestRiskUrl = (venueId: string,
    guestId: string,) => {




  return `/api/v1/venues/${venueId}/guests/${guestId}/risk`
}

/**
 * @summary The STAFF-ONLY current risk advisory for a guest (never diner-facing — R5)
 */
export const guestRisk = async (venueId: string,
    guestId: string, options?: RequestInit): Promise<RiskAdviceResponse> => {

  return customInstance<RiskAdviceResponse>(getGuestRiskUrl(venueId,guestId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGuestRiskQueryKey = (venueId: string,
    guestId: string,) => {
    return [
    `/api/v1/venues/${venueId}/guests/${guestId}/risk`
    ] as const;
    }


export const getGuestRiskQueryOptions = <TData = Awaited<ReturnType<typeof guestRisk>>, TError = ProblemDetail>(venueId: string,
    guestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof guestRisk>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGuestRiskQueryKey(venueId,guestId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof guestRisk>>> = ({ signal }) => guestRisk(venueId,guestId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined && guestId !== null && guestId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof guestRisk>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GuestRiskQueryResult = NonNullable<Awaited<ReturnType<typeof guestRisk>>>
export type GuestRiskQueryError = ProblemDetail


export function useGuestRisk<TData = Awaited<ReturnType<typeof guestRisk>>, TError = ProblemDetail>(
 venueId: string,
    guestId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof guestRisk>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guestRisk>>,
          TError,
          Awaited<ReturnType<typeof guestRisk>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGuestRisk<TData = Awaited<ReturnType<typeof guestRisk>>, TError = ProblemDetail>(
 venueId: string,
    guestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof guestRisk>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guestRisk>>,
          TError,
          Awaited<ReturnType<typeof guestRisk>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGuestRisk<TData = Awaited<ReturnType<typeof guestRisk>>, TError = ProblemDetail>(
 venueId: string,
    guestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof guestRisk>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The STAFF-ONLY current risk advisory for a guest (never diner-facing — R5)
 */

export function useGuestRisk<TData = Awaited<ReturnType<typeof guestRisk>>, TError = ProblemDetail>(
 venueId: string,
    guestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof guestRisk>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGuestRiskQueryOptions(venueId,guestId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getMergeConflictsUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/guests/merge-conflicts`
}

/**
 * @summary The open phone-vs-email merge-conflict queue (GU-2/R10)
 */
export const mergeConflicts = async (venueId: string, options?: RequestInit): Promise<MergeConflictResponse[]> => {

  return customInstance<MergeConflictResponse[]>(getMergeConflictsUrl(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMergeConflictsQueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/guests/merge-conflicts`
    ] as const;
    }


export const getMergeConflictsQueryOptions = <TData = Awaited<ReturnType<typeof mergeConflicts>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mergeConflicts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMergeConflictsQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mergeConflicts>>> = ({ signal }) => mergeConflicts(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mergeConflicts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MergeConflictsQueryResult = NonNullable<Awaited<ReturnType<typeof mergeConflicts>>>
export type MergeConflictsQueryError = ProblemDetail


export function useMergeConflicts<TData = Awaited<ReturnType<typeof mergeConflicts>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mergeConflicts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mergeConflicts>>,
          TError,
          Awaited<ReturnType<typeof mergeConflicts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMergeConflicts<TData = Awaited<ReturnType<typeof mergeConflicts>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mergeConflicts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mergeConflicts>>,
          TError,
          Awaited<ReturnType<typeof mergeConflicts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMergeConflicts<TData = Awaited<ReturnType<typeof mergeConflicts>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mergeConflicts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The open phone-vs-email merge-conflict queue (GU-2/R10)
 */

export function useMergeConflicts<TData = Awaited<ReturnType<typeof mergeConflicts>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mergeConflicts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMergeConflictsQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getFailedUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/guarantees/failed`
}

/**
 * @summary Guarantees whose charge FAILED — surfaced for manager follow-up (R10)
 */
export const failed = async (venueId: string, options?: RequestInit): Promise<GuaranteeResponse[]> => {

  return customInstance<GuaranteeResponse[]>(getFailedUrl(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFailedQueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/guarantees/failed`
    ] as const;
    }


export const getFailedQueryOptions = <TData = Awaited<ReturnType<typeof failed>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof failed>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFailedQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof failed>>> = ({ signal }) => failed(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof failed>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FailedQueryResult = NonNullable<Awaited<ReturnType<typeof failed>>>
export type FailedQueryError = ProblemDetail


export function useFailed<TData = Awaited<ReturnType<typeof failed>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof failed>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof failed>>,
          TError,
          Awaited<ReturnType<typeof failed>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFailed<TData = Awaited<ReturnType<typeof failed>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof failed>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof failed>>,
          TError,
          Awaited<ReturnType<typeof failed>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFailed<TData = Awaited<ReturnType<typeof failed>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof failed>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Guarantees whose charge FAILED — surfaced for manager follow-up (R10)
 */

export function useFailed<TData = Awaited<ReturnType<typeof failed>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof failed>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFailedQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGet7Url = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/entitlements`
}

/**
 * @summary The venue's derived feature flags (every EntitlementKey -> enabled) for UI gating
 */
export const get7 = async (venueId: string, options?: RequestInit): Promise<VenueEntitlementsResponse> => {

  return customInstance<VenueEntitlementsResponse>(getGet7Url(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGet7QueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/entitlements`
    ] as const;
    }


export const getGet7QueryOptions = <TData = Awaited<ReturnType<typeof get7>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get7>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGet7QueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get7>>> = ({ signal }) => get7(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get7>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Get7QueryResult = NonNullable<Awaited<ReturnType<typeof get7>>>
export type Get7QueryError = ProblemDetail


export function useGet7<TData = Awaited<ReturnType<typeof get7>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get7>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get7>>,
          TError,
          Awaited<ReturnType<typeof get7>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet7<TData = Awaited<ReturnType<typeof get7>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get7>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get7>>,
          TError,
          Awaited<ReturnType<typeof get7>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet7<TData = Awaited<ReturnType<typeof get7>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get7>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The venue's derived feature flags (every EntitlementKey -> enabled) for UI gating
 */

export function useGet7<TData = Awaited<ReturnType<typeof get7>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get7>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGet7QueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getInboxUrl = (venueId: string,
    params?: InboxParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/venues/${venueId}/dsr?${stringifiedParams}` : `/api/v1/venues/${venueId}/dsr`
}

/**
 * @summary The DSR inbox, due-date sorted with lateness badges (CP-4, ADR-0022)
 */
export const inbox = async (venueId: string,
    params?: InboxParams, options?: RequestInit): Promise<DsrInboxResponse> => {

  return customInstance<DsrInboxResponse>(getInboxUrl(venueId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getInboxQueryKey = (venueId: string,
    params?: InboxParams,) => {
    return [
    `/api/v1/venues/${venueId}/dsr`, ...(params ? [params] : [])
    ] as const;
    }


export const getInboxQueryOptions = <TData = Awaited<ReturnType<typeof inbox>>, TError = ProblemDetail>(venueId: string,
    params?: InboxParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inbox>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInboxQueryKey(venueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof inbox>>> = ({ signal }) => inbox(venueId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof inbox>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InboxQueryResult = NonNullable<Awaited<ReturnType<typeof inbox>>>
export type InboxQueryError = ProblemDetail


export function useInbox<TData = Awaited<ReturnType<typeof inbox>>, TError = ProblemDetail>(
 venueId: string,
    params: undefined |  InboxParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof inbox>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof inbox>>,
          TError,
          Awaited<ReturnType<typeof inbox>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInbox<TData = Awaited<ReturnType<typeof inbox>>, TError = ProblemDetail>(
 venueId: string,
    params?: InboxParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inbox>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof inbox>>,
          TError,
          Awaited<ReturnType<typeof inbox>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInbox<TData = Awaited<ReturnType<typeof inbox>>, TError = ProblemDetail>(
 venueId: string,
    params?: InboxParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inbox>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The DSR inbox, due-date sorted with lateness badges (CP-4, ADR-0022)
 */

export function useInbox<TData = Awaited<ReturnType<typeof inbox>>, TError = ProblemDetail>(
 venueId: string,
    params?: InboxParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inbox>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInboxQueryOptions(venueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getStatus1Url = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/dpa`
}

/**
 * @summary Current DPA version + whether this venue's acceptance is current (R5)
 */
export const status1 = async (venueId: string, options?: RequestInit): Promise<DpaStatusResponse> => {

  return customInstance<DpaStatusResponse>(getStatus1Url(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStatus1QueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/dpa`
    ] as const;
    }


export const getStatus1QueryOptions = <TData = Awaited<ReturnType<typeof status1>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStatus1QueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof status1>>> = ({ signal }) => status1(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof status1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Status1QueryResult = NonNullable<Awaited<ReturnType<typeof status1>>>
export type Status1QueryError = ProblemDetail


export function useStatus1<TData = Awaited<ReturnType<typeof status1>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof status1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof status1>>,
          TError,
          Awaited<ReturnType<typeof status1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStatus1<TData = Awaited<ReturnType<typeof status1>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof status1>>,
          TError,
          Awaited<ReturnType<typeof status1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStatus1<TData = Awaited<ReturnType<typeof status1>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Current DPA version + whether this venue's acceptance is current (R5)
 */

export function useStatus1<TData = Awaited<ReturnType<typeof status1>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStatus1QueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getReconcileUrl = (venueId: string,
    params: ReconcileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/venues/${venueId}/deposits/reconciliation?${stringifiedParams}` : `/api/v1/venues/${venueId}/deposits/reconciliation`
}

/**
 * @summary Per-venue reconciliation over a date range (collected/refunded/forfeited split from tax)
 */
export const reconcile = async (venueId: string,
    params: ReconcileParams, options?: RequestInit): Promise<ReconciliationResponse> => {

  return customInstance<ReconciliationResponse>(getReconcileUrl(venueId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReconcileQueryKey = (venueId: string,
    params?: ReconcileParams,) => {
    return [
    `/api/v1/venues/${venueId}/deposits/reconciliation`, ...(params ? [params] : [])
    ] as const;
    }


export const getReconcileQueryOptions = <TData = Awaited<ReturnType<typeof reconcile>>, TError = ProblemDetail>(venueId: string,
    params: ReconcileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reconcile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReconcileQueryKey(venueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reconcile>>> = ({ signal }) => reconcile(venueId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reconcile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReconcileQueryResult = NonNullable<Awaited<ReturnType<typeof reconcile>>>
export type ReconcileQueryError = ProblemDetail


export function useReconcile<TData = Awaited<ReturnType<typeof reconcile>>, TError = ProblemDetail>(
 venueId: string,
    params: ReconcileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reconcile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reconcile>>,
          TError,
          Awaited<ReturnType<typeof reconcile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReconcile<TData = Awaited<ReturnType<typeof reconcile>>, TError = ProblemDetail>(
 venueId: string,
    params: ReconcileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reconcile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reconcile>>,
          TError,
          Awaited<ReturnType<typeof reconcile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReconcile<TData = Awaited<ReturnType<typeof reconcile>>, TError = ProblemDetail>(
 venueId: string,
    params: ReconcileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reconcile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Per-venue reconciliation over a date range (collected/refunded/forfeited split from tax)
 */

export function useReconcile<TData = Awaited<ReturnType<typeof reconcile>>, TError = ProblemDetail>(
 venueId: string,
    params: ReconcileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reconcile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReconcileQueryOptions(venueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getDemoContextUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/demo-context`
}

export const demoContext = async (venueId: string, options?: RequestInit): Promise<DemoContextResponse> => {

  return customInstance<DemoContextResponse>(getDemoContextUrl(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDemoContextQueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/demo-context`
    ] as const;
    }


export const getDemoContextQueryOptions = <TData = Awaited<ReturnType<typeof demoContext>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof demoContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDemoContextQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof demoContext>>> = ({ signal }) => demoContext(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof demoContext>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DemoContextQueryResult = NonNullable<Awaited<ReturnType<typeof demoContext>>>
export type DemoContextQueryError = ProblemDetail


export function useDemoContext<TData = Awaited<ReturnType<typeof demoContext>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof demoContext>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof demoContext>>,
          TError,
          Awaited<ReturnType<typeof demoContext>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDemoContext<TData = Awaited<ReturnType<typeof demoContext>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof demoContext>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof demoContext>>,
          TError,
          Awaited<ReturnType<typeof demoContext>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDemoContext<TData = Awaited<ReturnType<typeof demoContext>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof demoContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDemoContext<TData = Awaited<ReturnType<typeof demoContext>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof demoContext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDemoContextQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListExceptionsUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/calendar-exceptions`
}

/**
 * @summary All calendar exceptions for the venue
 */
export const listExceptions = async (venueId: string, options?: RequestInit): Promise<CalendarExceptionResponse[]> => {

  return customInstance<CalendarExceptionResponse[]>(getListExceptionsUrl(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListExceptionsQueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/calendar-exceptions`
    ] as const;
    }


export const getListExceptionsQueryOptions = <TData = Awaited<ReturnType<typeof listExceptions>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExceptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExceptionsQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExceptions>>> = ({ signal }) => listExceptions(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExceptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListExceptionsQueryResult = NonNullable<Awaited<ReturnType<typeof listExceptions>>>
export type ListExceptionsQueryError = ProblemDetail


export function useListExceptions<TData = Awaited<ReturnType<typeof listExceptions>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExceptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExceptions>>,
          TError,
          Awaited<ReturnType<typeof listExceptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExceptions<TData = Awaited<ReturnType<typeof listExceptions>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExceptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExceptions>>,
          TError,
          Awaited<ReturnType<typeof listExceptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExceptions<TData = Awaited<ReturnType<typeof listExceptions>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExceptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary All calendar exceptions for the venue
 */

export function useListExceptions<TData = Awaited<ReturnType<typeof listExceptions>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExceptions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListExceptionsQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGet8Url = (venueId: string,
    bookingId: string,) => {




  return `/api/v1/venues/${venueId}/bookings/${bookingId}/guarantee`
}

/**
 * @summary The booking's guarantee record: snapshot fee + card brand/last4 + charge state
 */
export const get8 = async (venueId: string,
    bookingId: string, options?: RequestInit): Promise<GuaranteeResponse> => {

  return customInstance<GuaranteeResponse>(getGet8Url(venueId,bookingId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGet8QueryKey = (venueId: string,
    bookingId: string,) => {
    return [
    `/api/v1/venues/${venueId}/bookings/${bookingId}/guarantee`
    ] as const;
    }


export const getGet8QueryOptions = <TData = Awaited<ReturnType<typeof get8>>, TError = ProblemDetail>(venueId: string,
    bookingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get8>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGet8QueryKey(venueId,bookingId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get8>>> = ({ signal }) => get8(venueId,bookingId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined && bookingId !== null && bookingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get8>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Get8QueryResult = NonNullable<Awaited<ReturnType<typeof get8>>>
export type Get8QueryError = ProblemDetail


export function useGet8<TData = Awaited<ReturnType<typeof get8>>, TError = ProblemDetail>(
 venueId: string,
    bookingId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get8>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get8>>,
          TError,
          Awaited<ReturnType<typeof get8>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet8<TData = Awaited<ReturnType<typeof get8>>, TError = ProblemDetail>(
 venueId: string,
    bookingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get8>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get8>>,
          TError,
          Awaited<ReturnType<typeof get8>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet8<TData = Awaited<ReturnType<typeof get8>>, TError = ProblemDetail>(
 venueId: string,
    bookingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get8>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The booking's guarantee record: snapshot fee + card brand/last4 + charge state
 */

export function useGet8<TData = Awaited<ReturnType<typeof get8>>, TError = ProblemDetail>(
 venueId: string,
    bookingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get8>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGet8QueryOptions(venueId,bookingId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getInbox1Url = (venueId: string,
    params?: Inbox1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/venues/${venueId}/bookings/inbox?${stringifiedParams}` : `/api/v1/venues/${venueId}/bookings/inbox`
}

/**
 * @summary Request inbox: PENDING bookings + PendingReview state (reads only — R3)
 */
export const inbox1 = async (venueId: string,
    params?: Inbox1Params, options?: RequestInit): Promise<PageResponseStaffBookingSummaryResponse> => {

  return customInstance<PageResponseStaffBookingSummaryResponse>(getInbox1Url(venueId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getInbox1QueryKey = (venueId: string,
    params?: Inbox1Params,) => {
    return [
    `/api/v1/venues/${venueId}/bookings/inbox`, ...(params ? [params] : [])
    ] as const;
    }


export const getInbox1QueryOptions = <TData = Awaited<ReturnType<typeof inbox1>>, TError = ProblemDetail>(venueId: string,
    params?: Inbox1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inbox1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInbox1QueryKey(venueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof inbox1>>> = ({ signal }) => inbox1(venueId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof inbox1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Inbox1QueryResult = NonNullable<Awaited<ReturnType<typeof inbox1>>>
export type Inbox1QueryError = ProblemDetail


export function useInbox1<TData = Awaited<ReturnType<typeof inbox1>>, TError = ProblemDetail>(
 venueId: string,
    params: undefined |  Inbox1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof inbox1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof inbox1>>,
          TError,
          Awaited<ReturnType<typeof inbox1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInbox1<TData = Awaited<ReturnType<typeof inbox1>>, TError = ProblemDetail>(
 venueId: string,
    params?: Inbox1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inbox1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof inbox1>>,
          TError,
          Awaited<ReturnType<typeof inbox1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInbox1<TData = Awaited<ReturnType<typeof inbox1>>, TError = ProblemDetail>(
 venueId: string,
    params?: Inbox1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inbox1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Request inbox: PENDING bookings + PendingReview state (reads only — R3)
 */

export function useInbox1<TData = Awaited<ReturnType<typeof inbox1>>, TError = ProblemDetail>(
 venueId: string,
    params?: Inbox1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inbox1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInbox1QueryOptions(venueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCalendarUrl = (venueId: string,
    params: CalendarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/venues/${venueId}/bookings/calendar?${stringifiedParams}` : `/api/v1/venues/${venueId}/bookings/calendar`
}

/**
 * @summary Calendar/timeline density: counts per (service_day, status) for a date window
 */
export const calendar = async (venueId: string,
    params: CalendarParams, options?: RequestInit): Promise<CalendarDensityResponse[]> => {

  return customInstance<CalendarDensityResponse[]>(getCalendarUrl(venueId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCalendarQueryKey = (venueId: string,
    params?: CalendarParams,) => {
    return [
    `/api/v1/venues/${venueId}/bookings/calendar`, ...(params ? [params] : [])
    ] as const;
    }


export const getCalendarQueryOptions = <TData = Awaited<ReturnType<typeof calendar>>, TError = ProblemDetail>(venueId: string,
    params: CalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calendar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCalendarQueryKey(venueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof calendar>>> = ({ signal }) => calendar(venueId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof calendar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CalendarQueryResult = NonNullable<Awaited<ReturnType<typeof calendar>>>
export type CalendarQueryError = ProblemDetail


export function useCalendar<TData = Awaited<ReturnType<typeof calendar>>, TError = ProblemDetail>(
 venueId: string,
    params: CalendarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof calendar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof calendar>>,
          TError,
          Awaited<ReturnType<typeof calendar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCalendar<TData = Awaited<ReturnType<typeof calendar>>, TError = ProblemDetail>(
 venueId: string,
    params: CalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calendar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof calendar>>,
          TError,
          Awaited<ReturnType<typeof calendar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCalendar<TData = Awaited<ReturnType<typeof calendar>>, TError = ProblemDetail>(
 venueId: string,
    params: CalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calendar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Calendar/timeline density: counts per (service_day, status) for a date window
 */

export function useCalendar<TData = Awaited<ReturnType<typeof calendar>>, TError = ProblemDetail>(
 venueId: string,
    params: CalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calendar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCalendarQueryOptions(venueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGet9Url = (venueId: string,
    entryId: string,) => {




  return `/api/v1/venues/${venueId}/blacklist/${entryId}`
}

/**
 * @summary Get one entry with renewals + appeals
 */
export const get9 = async (venueId: string,
    entryId: string, options?: RequestInit): Promise<BlacklistEntryResponse> => {

  return customInstance<BlacklistEntryResponse>(getGet9Url(venueId,entryId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGet9QueryKey = (venueId: string,
    entryId: string,) => {
    return [
    `/api/v1/venues/${venueId}/blacklist/${entryId}`
    ] as const;
    }


export const getGet9QueryOptions = <TData = Awaited<ReturnType<typeof get9>>, TError = ProblemDetail>(venueId: string,
    entryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get9>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGet9QueryKey(venueId,entryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get9>>> = ({ signal }) => get9(venueId,entryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined && entryId !== null && entryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get9>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Get9QueryResult = NonNullable<Awaited<ReturnType<typeof get9>>>
export type Get9QueryError = ProblemDetail


export function useGet9<TData = Awaited<ReturnType<typeof get9>>, TError = ProblemDetail>(
 venueId: string,
    entryId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get9>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get9>>,
          TError,
          Awaited<ReturnType<typeof get9>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet9<TData = Awaited<ReturnType<typeof get9>>, TError = ProblemDetail>(
 venueId: string,
    entryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get9>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get9>>,
          TError,
          Awaited<ReturnType<typeof get9>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet9<TData = Awaited<ReturnType<typeof get9>>, TError = ProblemDetail>(
 venueId: string,
    entryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get9>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one entry with renewals + appeals
 */

export function useGet9<TData = Awaited<ReturnType<typeof get9>>, TError = ProblemDetail>(
 venueId: string,
    entryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get9>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGet9QueryOptions(venueId,entryId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getRemoveUrl = (venueId: string,
    entryId: string,) => {




  return `/api/v1/venues/${venueId}/blacklist/${entryId}`
}

/**
 * @summary Remove (REMOVED); an open appeal is auto-resolved as REMOVED (R7)
 */
export const remove = async (venueId: string,
    entryId: string, options?: RequestInit): Promise<BlacklistEntryResponse> => {

  return customInstance<BlacklistEntryResponse>(getRemoveUrl(venueId,entryId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRemoveMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remove>>, TError,{venueId: string;entryId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof remove>>, TError,{venueId: string;entryId: string}, TContext> => {

const mutationKey = ['remove'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof remove>>, {venueId: string;entryId: string}> = (props) => {
          const {venueId,entryId} = props ?? {};

          return  remove(venueId,entryId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveMutationResult = NonNullable<Awaited<ReturnType<typeof remove>>>

    export type RemoveMutationError = ProblemDetail

    /**
 * @summary Remove (REMOVED); an open appeal is auto-resolved as REMOVED (R7)
 */
export const useRemove = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remove>>, TError,{venueId: string;entryId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof remove>>,
        TError,
        {venueId: string;entryId: string},
        TContext
      > => {
      return useMutation(getRemoveMutationOptions(options), queryClient);
    }

export const getReviewQueueUrl = (venueId: string,) => {




  return `/api/v1/venues/${venueId}/blacklist/review-queue`
}

/**
 * @summary The due-soon / overdue review-to-renew queue (R6)
 */
export const reviewQueue = async (venueId: string, options?: RequestInit): Promise<BlacklistEntryResponse[]> => {

  return customInstance<BlacklistEntryResponse[]>(getReviewQueueUrl(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReviewQueueQueryKey = (venueId: string,) => {
    return [
    `/api/v1/venues/${venueId}/blacklist/review-queue`
    ] as const;
    }


export const getReviewQueueQueryOptions = <TData = Awaited<ReturnType<typeof reviewQueue>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviewQueue>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReviewQueueQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reviewQueue>>> = ({ signal }) => reviewQueue(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reviewQueue>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReviewQueueQueryResult = NonNullable<Awaited<ReturnType<typeof reviewQueue>>>
export type ReviewQueueQueryError = ProblemDetail


export function useReviewQueue<TData = Awaited<ReturnType<typeof reviewQueue>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviewQueue>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reviewQueue>>,
          TError,
          Awaited<ReturnType<typeof reviewQueue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReviewQueue<TData = Awaited<ReturnType<typeof reviewQueue>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviewQueue>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reviewQueue>>,
          TError,
          Awaited<ReturnType<typeof reviewQueue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReviewQueue<TData = Awaited<ReturnType<typeof reviewQueue>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviewQueue>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The due-soon / overdue review-to-renew queue (R6)
 */

export function useReviewQueue<TData = Awaited<ReturnType<typeof reviewQueue>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviewQueue>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReviewQueueQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getOpenSlotsUrl = (venueId: string,
    params: OpenSlotsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/venues/${venueId}/availability?${stringifiedParams}` : `/api/v1/venues/${venueId}/availability`
}

/**
 * @summary Open slots for a service day and party (capacity-only, M2)
 */
export const openSlots = async (venueId: string,
    params: OpenSlotsParams, options?: RequestInit): Promise<OpenSlotsResponse> => {

  return customInstance<OpenSlotsResponse>(getOpenSlotsUrl(venueId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOpenSlotsQueryKey = (venueId: string,
    params?: OpenSlotsParams,) => {
    return [
    `/api/v1/venues/${venueId}/availability`, ...(params ? [params] : [])
    ] as const;
    }


export const getOpenSlotsQueryOptions = <TData = Awaited<ReturnType<typeof openSlots>>, TError = ProblemDetail>(venueId: string,
    params: OpenSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openSlots>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOpenSlotsQueryKey(venueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof openSlots>>> = ({ signal }) => openSlots(venueId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof openSlots>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OpenSlotsQueryResult = NonNullable<Awaited<ReturnType<typeof openSlots>>>
export type OpenSlotsQueryError = ProblemDetail


export function useOpenSlots<TData = Awaited<ReturnType<typeof openSlots>>, TError = ProblemDetail>(
 venueId: string,
    params: OpenSlotsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof openSlots>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof openSlots>>,
          TError,
          Awaited<ReturnType<typeof openSlots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenSlots<TData = Awaited<ReturnType<typeof openSlots>>, TError = ProblemDetail>(
 venueId: string,
    params: OpenSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openSlots>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof openSlots>>,
          TError,
          Awaited<ReturnType<typeof openSlots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenSlots<TData = Awaited<ReturnType<typeof openSlots>>, TError = ProblemDetail>(
 venueId: string,
    params: OpenSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openSlots>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Open slots for a service day and party (capacity-only, M2)
 */

export function useOpenSlots<TData = Awaited<ReturnType<typeof openSlots>>, TError = ProblemDetail>(
 venueId: string,
    params: OpenSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openSlots>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOpenSlotsQueryOptions(venueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSnapshotUrl = (venueId: string,
    params?: SnapshotParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/venues/${venueId}/availability/snapshot?${stringifiedParams}` : `/api/v1/venues/${venueId}/availability/snapshot`
}

/**
 * @summary The durable availability snapshot feed (best-effort; live claim authoritative, AV-8)
 */
export const snapshot = async (venueId: string,
    params?: SnapshotParams, options?: RequestInit): Promise<SnapshotSlotResponse[]> => {

  return customInstance<SnapshotSlotResponse[]>(getSnapshotUrl(venueId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSnapshotQueryKey = (venueId: string,
    params?: SnapshotParams,) => {
    return [
    `/api/v1/venues/${venueId}/availability/snapshot`, ...(params ? [params] : [])
    ] as const;
    }


export const getSnapshotQueryOptions = <TData = Awaited<ReturnType<typeof snapshot>>, TError = ProblemDetail>(venueId: string,
    params?: SnapshotParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof snapshot>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSnapshotQueryKey(venueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof snapshot>>> = ({ signal }) => snapshot(venueId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof snapshot>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SnapshotQueryResult = NonNullable<Awaited<ReturnType<typeof snapshot>>>
export type SnapshotQueryError = ProblemDetail


export function useSnapshot<TData = Awaited<ReturnType<typeof snapshot>>, TError = ProblemDetail>(
 venueId: string,
    params: undefined |  SnapshotParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof snapshot>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof snapshot>>,
          TError,
          Awaited<ReturnType<typeof snapshot>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSnapshot<TData = Awaited<ReturnType<typeof snapshot>>, TError = ProblemDetail>(
 venueId: string,
    params?: SnapshotParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof snapshot>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof snapshot>>,
          TError,
          Awaited<ReturnType<typeof snapshot>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSnapshot<TData = Awaited<ReturnType<typeof snapshot>>, TError = ProblemDetail>(
 venueId: string,
    params?: SnapshotParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof snapshot>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The durable availability snapshot feed (best-effort; live claim authoritative, AV-8)
 */

export function useSnapshot<TData = Awaited<ReturnType<typeof snapshot>>, TError = ProblemDetail>(
 venueId: string,
    params?: SnapshotParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof snapshot>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSnapshotQueryOptions(venueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getAlternativesUrl = (venueId: string,
    params: AlternativesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/venues/${venueId}/availability/alternatives?${stringifiedParams}` : `/api/v1/venues/${venueId}/availability/alternatives`
}

/**
 * @summary Nearby open slots when the requested time is gone — each re-checked live (AV-6)
 */
export const alternatives = async (venueId: string,
    params: AlternativesParams, options?: RequestInit): Promise<AlternativeResponse[]> => {

  return customInstance<AlternativeResponse[]>(getAlternativesUrl(venueId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAlternativesQueryKey = (venueId: string,
    params?: AlternativesParams,) => {
    return [
    `/api/v1/venues/${venueId}/availability/alternatives`, ...(params ? [params] : [])
    ] as const;
    }


export const getAlternativesQueryOptions = <TData = Awaited<ReturnType<typeof alternatives>>, TError = ProblemDetail>(venueId: string,
    params: AlternativesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alternatives>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAlternativesQueryKey(venueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof alternatives>>> = ({ signal }) => alternatives(venueId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof alternatives>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AlternativesQueryResult = NonNullable<Awaited<ReturnType<typeof alternatives>>>
export type AlternativesQueryError = ProblemDetail


export function useAlternatives<TData = Awaited<ReturnType<typeof alternatives>>, TError = ProblemDetail>(
 venueId: string,
    params: AlternativesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof alternatives>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof alternatives>>,
          TError,
          Awaited<ReturnType<typeof alternatives>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAlternatives<TData = Awaited<ReturnType<typeof alternatives>>, TError = ProblemDetail>(
 venueId: string,
    params: AlternativesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alternatives>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof alternatives>>,
          TError,
          Awaited<ReturnType<typeof alternatives>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAlternatives<TData = Awaited<ReturnType<typeof alternatives>>, TError = ProblemDetail>(
 venueId: string,
    params: AlternativesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alternatives>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Nearby open slots when the requested time is gone — each re-checked live (AV-6)
 */

export function useAlternatives<TData = Awaited<ReturnType<typeof alternatives>>, TError = ProblemDetail>(
 venueId: string,
    params: AlternativesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alternatives>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAlternativesQueryOptions(venueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getList7Url = (venueId: string,
    params?: List7Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/venues/${venueId}/activity?${stringifiedParams}` : `/api/v1/venues/${venueId}/activity`
}

/**
 * @summary List venue activity entries (cursor pagination, ADR-0022)
 */
export const list7 = async (venueId: string,
    params?: List7Params, options?: RequestInit): Promise<PageResponseActivityLogEntryResponse> => {

  return customInstance<PageResponseActivityLogEntryResponse>(getList7Url(venueId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getList7QueryKey = (venueId: string,
    params?: List7Params,) => {
    return [
    `/api/v1/venues/${venueId}/activity`, ...(params ? [params] : [])
    ] as const;
    }


export const getList7QueryOptions = <TData = Awaited<ReturnType<typeof list7>>, TError = ProblemDetail>(venueId: string,
    params?: List7Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list7>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getList7QueryKey(venueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof list7>>> = ({ signal }) => list7(venueId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof list7>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type List7QueryResult = NonNullable<Awaited<ReturnType<typeof list7>>>
export type List7QueryError = ProblemDetail


export function useList7<TData = Awaited<ReturnType<typeof list7>>, TError = ProblemDetail>(
 venueId: string,
    params: undefined |  List7Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof list7>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof list7>>,
          TError,
          Awaited<ReturnType<typeof list7>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useList7<TData = Awaited<ReturnType<typeof list7>>, TError = ProblemDetail>(
 venueId: string,
    params?: List7Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list7>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof list7>>,
          TError,
          Awaited<ReturnType<typeof list7>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useList7<TData = Awaited<ReturnType<typeof list7>>, TError = ProblemDetail>(
 venueId: string,
    params?: List7Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list7>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List venue activity entries (cursor pagination, ADR-0022)
 */

export function useList7<TData = Awaited<ReturnType<typeof list7>>, TError = ProblemDetail>(
 venueId: string,
    params?: List7Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list7>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getList7QueryOptions(venueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getList8Url = (venueId: string,
    params?: List8Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/venues/${venueId}/abuse-blocks?${stringifiedParams}` : `/api/v1/venues/${venueId}/abuse-blocks`
}

/**
 * @summary List active temporary blocks for a venue, newest first (cursor pagination, ADR-0022)
 */
export const list8 = async (venueId: string,
    params?: List8Params, options?: RequestInit): Promise<AbuseBlockPageResponse> => {

  return customInstance<AbuseBlockPageResponse>(getList8Url(venueId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getList8QueryKey = (venueId: string,
    params?: List8Params,) => {
    return [
    `/api/v1/venues/${venueId}/abuse-blocks`, ...(params ? [params] : [])
    ] as const;
    }


export const getList8QueryOptions = <TData = Awaited<ReturnType<typeof list8>>, TError = ProblemDetail>(venueId: string,
    params?: List8Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list8>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getList8QueryKey(venueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof list8>>> = ({ signal }) => list8(venueId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof list8>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type List8QueryResult = NonNullable<Awaited<ReturnType<typeof list8>>>
export type List8QueryError = ProblemDetail


export function useList8<TData = Awaited<ReturnType<typeof list8>>, TError = ProblemDetail>(
 venueId: string,
    params: undefined |  List8Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof list8>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof list8>>,
          TError,
          Awaited<ReturnType<typeof list8>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useList8<TData = Awaited<ReturnType<typeof list8>>, TError = ProblemDetail>(
 venueId: string,
    params?: List8Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list8>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof list8>>,
          TError,
          Awaited<ReturnType<typeof list8>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useList8<TData = Awaited<ReturnType<typeof list8>>, TError = ProblemDetail>(
 venueId: string,
    params?: List8Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list8>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List active temporary blocks for a venue, newest first (cursor pagination, ADR-0022)
 */

export function useList8<TData = Awaited<ReturnType<typeof list8>>, TError = ProblemDetail>(
 venueId: string,
    params?: List8Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof list8>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getList8QueryOptions(venueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGet10Url = (id: string,) => {




  return `/api/v1/venues/${id}`
}

/**
 * @summary Fetch a venue
 */
export const get10 = async (id: string, options?: RequestInit): Promise<VenueResponse> => {

  return customInstance<VenueResponse>(getGet10Url(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGet10QueryKey = (id: string,) => {
    return [
    `/api/v1/venues/${id}`
    ] as const;
    }


export const getGet10QueryOptions = <TData = Awaited<ReturnType<typeof get10>>, TError = ProblemDetail>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get10>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGet10QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get10>>> = ({ signal }) => get10(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get10>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Get10QueryResult = NonNullable<Awaited<ReturnType<typeof get10>>>
export type Get10QueryError = ProblemDetail


export function useGet10<TData = Awaited<ReturnType<typeof get10>>, TError = ProblemDetail>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get10>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get10>>,
          TError,
          Awaited<ReturnType<typeof get10>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet10<TData = Awaited<ReturnType<typeof get10>>, TError = ProblemDetail>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get10>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get10>>,
          TError,
          Awaited<ReturnType<typeof get10>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet10<TData = Awaited<ReturnType<typeof get10>>, TError = ProblemDetail>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get10>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch a venue
 */

export function useGet10<TData = Awaited<ReturnType<typeof get10>>, TError = ProblemDetail>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get10>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGet10QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSlugAvailabilityUrl = (params: SlugAvailabilityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/venues/slug-availability?${stringifiedParams}` : `/api/v1/venues/slug-availability`
}

/**
 * @summary Live slug availability: shape + reserved blocklist + registry state (+ variants)
 */
export const slugAvailability = async (params: SlugAvailabilityParams, options?: RequestInit): Promise<SlugAvailabilityResponse> => {

  return customInstance<SlugAvailabilityResponse>(getSlugAvailabilityUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSlugAvailabilityQueryKey = (params?: SlugAvailabilityParams,) => {
    return [
    `/api/v1/venues/slug-availability`, ...(params ? [params] : [])
    ] as const;
    }


export const getSlugAvailabilityQueryOptions = <TData = Awaited<ReturnType<typeof slugAvailability>>, TError = ProblemDetail>(params: SlugAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof slugAvailability>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSlugAvailabilityQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof slugAvailability>>> = ({ signal }) => slugAvailability(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof slugAvailability>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SlugAvailabilityQueryResult = NonNullable<Awaited<ReturnType<typeof slugAvailability>>>
export type SlugAvailabilityQueryError = ProblemDetail


export function useSlugAvailability<TData = Awaited<ReturnType<typeof slugAvailability>>, TError = ProblemDetail>(
 params: SlugAvailabilityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof slugAvailability>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof slugAvailability>>,
          TError,
          Awaited<ReturnType<typeof slugAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSlugAvailability<TData = Awaited<ReturnType<typeof slugAvailability>>, TError = ProblemDetail>(
 params: SlugAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof slugAvailability>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof slugAvailability>>,
          TError,
          Awaited<ReturnType<typeof slugAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSlugAvailability<TData = Awaited<ReturnType<typeof slugAvailability>>, TError = ProblemDetail>(
 params: SlugAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof slugAvailability>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Live slug availability: shape + reserved blocklist + registry state (+ variants)
 */

export function useSlugAvailability<TData = Awaited<ReturnType<typeof slugAvailability>>, TError = ProblemDetail>(
 params: SlugAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof slugAvailability>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSlugAvailabilityQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListUsersUrl = (params?: ListUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/users?${stringifiedParams}` : `/api/v1/users`
}

/**
 * Forward-only cursor pagination (ADR-0022): pass nextCursor back verbatim; a malformed cursor or out-of-range limit is a 422 ProblemDetail.
 * @summary List users, cursor-paginated
 */
export const listUsers = async (params?: ListUsersParams, options?: RequestInit): Promise<PageResponseUserResponse> => {

  return customInstance<PageResponseUserResponse>(getListUsersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUsersQueryKey = (params?: ListUsersParams,) => {
    return [
    `/api/v1/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getListUsersQueryOptions = <TData = Awaited<ReturnType<typeof listUsers>>, TError = ProblemDetail>(params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) => listUsers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type ListUsersQueryError = ProblemDetail


export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ProblemDetail>(
 params: undefined |  ListUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ProblemDetail>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ProblemDetail>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List users, cursor-paginated
 */

export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ProblemDetail>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getEventsUrl = (params?: EventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/realtime/events?${stringifiedParams}` : `/api/v1/realtime/events`
}

/**
 * Long-lived text/event-stream; events are cache-invalidation hints (refetch on receipt).
 * @summary Subscribe to live events for a venue (or the caller's tenant)
 */
export const events = async (params?: EventsParams, options?: RequestInit): Promise<SseEmitter> => {

  return customInstance<SseEmitter>(getEventsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getEventsQueryKey = (params?: EventsParams,) => {
    return [
    `/api/v1/realtime/events`, ...(params ? [params] : [])
    ] as const;
    }


export const getEventsQueryOptions = <TData = Awaited<ReturnType<typeof events>>, TError = ProblemDetail>(params?: EventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof events>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof events>>> = ({ signal }) => events(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof events>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EventsQueryResult = NonNullable<Awaited<ReturnType<typeof events>>>
export type EventsQueryError = ProblemDetail


export function useEvents<TData = Awaited<ReturnType<typeof events>>, TError = ProblemDetail>(
 params: undefined |  EventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof events>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof events>>,
          TError,
          Awaited<ReturnType<typeof events>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEvents<TData = Awaited<ReturnType<typeof events>>, TError = ProblemDetail>(
 params?: EventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof events>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof events>>,
          TError,
          Awaited<ReturnType<typeof events>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEvents<TData = Awaited<ReturnType<typeof events>>, TError = ProblemDetail>(
 params?: EventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof events>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Subscribe to live events for a venue (or the caller's tenant)
 */

export function useEvents<TData = Awaited<ReturnType<typeof events>>, TError = ProblemDetail>(
 params?: EventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof events>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEventsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getActiveUrl = (venueId: string,) => {




  return `/api/v1/ops/venues/${venueId}/impersonations`
}

export const active = async (venueId: string, options?: RequestInit): Promise<ImpersonationSessionDto[]> => {

  return customInstance<ImpersonationSessionDto[]>(getActiveUrl(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActiveQueryKey = (venueId: string,) => {
    return [
    `/api/v1/ops/venues/${venueId}/impersonations`
    ] as const;
    }


export const getActiveQueryOptions = <TData = Awaited<ReturnType<typeof active>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof active>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActiveQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof active>>> = ({ signal }) => active(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof active>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActiveQueryResult = NonNullable<Awaited<ReturnType<typeof active>>>
export type ActiveQueryError = ProblemDetail


export function useActive<TData = Awaited<ReturnType<typeof active>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof active>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof active>>,
          TError,
          Awaited<ReturnType<typeof active>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActive<TData = Awaited<ReturnType<typeof active>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof active>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof active>>,
          TError,
          Awaited<ReturnType<typeof active>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActive<TData = Awaited<ReturnType<typeof active>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof active>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActive<TData = Awaited<ReturnType<typeof active>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof active>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActiveQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGet11Url = (venueId: string,) => {




  return `/api/v1/ops/venues/${venueId}/entitlements`
}

export const get11 = async (venueId: string, options?: RequestInit): Promise<EntitlementViewDto> => {

  return customInstance<EntitlementViewDto>(getGet11Url(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGet11QueryKey = (venueId: string,) => {
    return [
    `/api/v1/ops/venues/${venueId}/entitlements`
    ] as const;
    }


export const getGet11QueryOptions = <TData = Awaited<ReturnType<typeof get11>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get11>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGet11QueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get11>>> = ({ signal }) => get11(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get11>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Get11QueryResult = NonNullable<Awaited<ReturnType<typeof get11>>>
export type Get11QueryError = ProblemDetail


export function useGet11<TData = Awaited<ReturnType<typeof get11>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get11>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get11>>,
          TError,
          Awaited<ReturnType<typeof get11>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet11<TData = Awaited<ReturnType<typeof get11>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get11>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get11>>,
          TError,
          Awaited<ReturnType<typeof get11>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet11<TData = Awaited<ReturnType<typeof get11>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get11>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGet11<TData = Awaited<ReturnType<typeof get11>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get11>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGet11QueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListTenantsUrl = (params?: ListTenantsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/ops/tenants?${stringifiedParams}` : `/api/v1/ops/tenants`
}

export const listTenants = async (params?: ListTenantsParams, options?: RequestInit): Promise<PageDtoTenantSearchHitDto> => {

  return customInstance<PageDtoTenantSearchHitDto>(getListTenantsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTenantsQueryKey = (params?: ListTenantsParams,) => {
    return [
    `/api/v1/ops/tenants`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTenantsQueryOptions = <TData = Awaited<ReturnType<typeof listTenants>>, TError = ProblemDetail>(params?: ListTenantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTenantsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTenants>>> = ({ signal }) => listTenants(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTenantsQueryResult = NonNullable<Awaited<ReturnType<typeof listTenants>>>
export type ListTenantsQueryError = ProblemDetail


export function useListTenants<TData = Awaited<ReturnType<typeof listTenants>>, TError = ProblemDetail>(
 params: undefined |  ListTenantsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTenants>>,
          TError,
          Awaited<ReturnType<typeof listTenants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTenants<TData = Awaited<ReturnType<typeof listTenants>>, TError = ProblemDetail>(
 params?: ListTenantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTenants>>,
          TError,
          Awaited<ReturnType<typeof listTenants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTenants<TData = Awaited<ReturnType<typeof listTenants>>, TError = ProblemDetail>(
 params?: ListTenantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListTenants<TData = Awaited<ReturnType<typeof listTenants>>, TError = ProblemDetail>(
 params?: ListTenantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTenantsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getActive1Url = (tenantId: string,) => {




  return `/api/v1/ops/tenants/${tenantId}/trials/active`
}

export const active1 = async (tenantId: string, options?: RequestInit): Promise<TrialViewDto> => {

  return customInstance<TrialViewDto>(getActive1Url(tenantId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActive1QueryKey = (tenantId: string,) => {
    return [
    `/api/v1/ops/tenants/${tenantId}/trials/active`
    ] as const;
    }


export const getActive1QueryOptions = <TData = Awaited<ReturnType<typeof active1>>, TError = ProblemDetail>(tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof active1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActive1QueryKey(tenantId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof active1>>> = ({ signal }) => active1(tenantId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof active1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Active1QueryResult = NonNullable<Awaited<ReturnType<typeof active1>>>
export type Active1QueryError = ProblemDetail


export function useActive1<TData = Awaited<ReturnType<typeof active1>>, TError = ProblemDetail>(
 tenantId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof active1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof active1>>,
          TError,
          Awaited<ReturnType<typeof active1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActive1<TData = Awaited<ReturnType<typeof active1>>, TError = ProblemDetail>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof active1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof active1>>,
          TError,
          Awaited<ReturnType<typeof active1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActive1<TData = Awaited<ReturnType<typeof active1>>, TError = ProblemDetail>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof active1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useActive1<TData = Awaited<ReturnType<typeof active1>>, TError = ProblemDetail>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof active1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActive1QueryOptions(tenantId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getHealthUrl = (tenantId: string,) => {




  return `/api/v1/ops/tenants/${tenantId}/health`
}

export const health = async (tenantId: string, options?: RequestInit): Promise<TenantHealthDto> => {

  return customInstance<TenantHealthDto>(getHealthUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthQueryKey = (tenantId: string,) => {
    return [
    `/api/v1/ops/tenants/${tenantId}/health`
    ] as const;
    }


export const getHealthQueryOptions = <TData = Awaited<ReturnType<typeof health>>, TError = ProblemDetail>(tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthQueryKey(tenantId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof health>>> = ({ signal }) => health(tenantId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthQueryResult = NonNullable<Awaited<ReturnType<typeof health>>>
export type HealthQueryError = ProblemDetail


export function useHealth<TData = Awaited<ReturnType<typeof health>>, TError = ProblemDetail>(
 tenantId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof health>>,
          TError,
          Awaited<ReturnType<typeof health>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealth<TData = Awaited<ReturnType<typeof health>>, TError = ProblemDetail>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof health>>,
          TError,
          Awaited<ReturnType<typeof health>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealth<TData = Awaited<ReturnType<typeof health>>, TError = ProblemDetail>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHealth<TData = Awaited<ReturnType<typeof health>>, TError = ProblemDetail>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthQueryOptions(tenantId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getThreads1Url = (tenantId: string,
    params?: Threads1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/ops/support/tenants/${tenantId}/threads?${stringifiedParams}` : `/api/v1/ops/support/tenants/${tenantId}/threads`
}

export const threads1 = async (tenantId: string,
    params?: Threads1Params, options?: RequestInit): Promise<PageDtoSupportThreadDto> => {

  return customInstance<PageDtoSupportThreadDto>(getThreads1Url(tenantId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getThreads1QueryKey = (tenantId: string,
    params?: Threads1Params,) => {
    return [
    `/api/v1/ops/support/tenants/${tenantId}/threads`, ...(params ? [params] : [])
    ] as const;
    }


export const getThreads1QueryOptions = <TData = Awaited<ReturnType<typeof threads1>>, TError = ProblemDetail>(tenantId: string,
    params?: Threads1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof threads1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getThreads1QueryKey(tenantId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof threads1>>> = ({ signal }) => threads1(tenantId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof threads1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Threads1QueryResult = NonNullable<Awaited<ReturnType<typeof threads1>>>
export type Threads1QueryError = ProblemDetail


export function useThreads1<TData = Awaited<ReturnType<typeof threads1>>, TError = ProblemDetail>(
 tenantId: string,
    params: undefined |  Threads1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof threads1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof threads1>>,
          TError,
          Awaited<ReturnType<typeof threads1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useThreads1<TData = Awaited<ReturnType<typeof threads1>>, TError = ProblemDetail>(
 tenantId: string,
    params?: Threads1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof threads1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof threads1>>,
          TError,
          Awaited<ReturnType<typeof threads1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useThreads1<TData = Awaited<ReturnType<typeof threads1>>, TError = ProblemDetail>(
 tenantId: string,
    params?: Threads1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof threads1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useThreads1<TData = Awaited<ReturnType<typeof threads1>>, TError = ProblemDetail>(
 tenantId: string,
    params?: Threads1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof threads1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getThreads1QueryOptions(tenantId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getInbox2Url = (params?: Inbox2Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/ops/support/inbox?${stringifiedParams}` : `/api/v1/ops/support/inbox`
}

export const inbox2 = async (params?: Inbox2Params, options?: RequestInit): Promise<PageDtoSupportThreadDto> => {

  return customInstance<PageDtoSupportThreadDto>(getInbox2Url(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getInbox2QueryKey = (params?: Inbox2Params,) => {
    return [
    `/api/v1/ops/support/inbox`, ...(params ? [params] : [])
    ] as const;
    }


export const getInbox2QueryOptions = <TData = Awaited<ReturnType<typeof inbox2>>, TError = ProblemDetail>(params?: Inbox2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inbox2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInbox2QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof inbox2>>> = ({ signal }) => inbox2(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof inbox2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Inbox2QueryResult = NonNullable<Awaited<ReturnType<typeof inbox2>>>
export type Inbox2QueryError = ProblemDetail


export function useInbox2<TData = Awaited<ReturnType<typeof inbox2>>, TError = ProblemDetail>(
 params: undefined |  Inbox2Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof inbox2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof inbox2>>,
          TError,
          Awaited<ReturnType<typeof inbox2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInbox2<TData = Awaited<ReturnType<typeof inbox2>>, TError = ProblemDetail>(
 params?: Inbox2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inbox2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof inbox2>>,
          TError,
          Awaited<ReturnType<typeof inbox2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInbox2<TData = Awaited<ReturnType<typeof inbox2>>, TError = ProblemDetail>(
 params?: Inbox2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inbox2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useInbox2<TData = Awaited<ReturnType<typeof inbox2>>, TError = ProblemDetail>(
 params?: Inbox2Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inbox2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInbox2QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSearch1Url = (params: Search1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/ops/search?${stringifiedParams}` : `/api/v1/ops/search`
}

export const search1 = async (params: Search1Params, options?: RequestInit): Promise<TenantSearchHitDto[]> => {

  return customInstance<TenantSearchHitDto[]>(getSearch1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearch1QueryKey = (params?: Search1Params,) => {
    return [
    `/api/v1/ops/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearch1QueryOptions = <TData = Awaited<ReturnType<typeof search1>>, TError = ProblemDetail>(params: Search1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof search1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearch1QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof search1>>> = ({ signal }) => search1(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof search1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Search1QueryResult = NonNullable<Awaited<ReturnType<typeof search1>>>
export type Search1QueryError = ProblemDetail


export function useSearch1<TData = Awaited<ReturnType<typeof search1>>, TError = ProblemDetail>(
 params: Search1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof search1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof search1>>,
          TError,
          Awaited<ReturnType<typeof search1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearch1<TData = Awaited<ReturnType<typeof search1>>, TError = ProblemDetail>(
 params: Search1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof search1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof search1>>,
          TError,
          Awaited<ReturnType<typeof search1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearch1<TData = Awaited<ReturnType<typeof search1>>, TError = ProblemDetail>(
 params: Search1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof search1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSearch1<TData = Awaited<ReturnType<typeof search1>>, TError = ProblemDetail>(
 params: Search1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof search1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearch1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getFirstBookingFunnelUrl = () => {




  return `/api/v1/ops/first-booking-funnel`
}

export const firstBookingFunnel = async ( options?: RequestInit): Promise<FirstBookingFunnelDto> => {

  return customInstance<FirstBookingFunnelDto>(getFirstBookingFunnelUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFirstBookingFunnelQueryKey = () => {
    return [
    `/api/v1/ops/first-booking-funnel`
    ] as const;
    }


export const getFirstBookingFunnelQueryOptions = <TData = Awaited<ReturnType<typeof firstBookingFunnel>>, TError = ProblemDetail>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof firstBookingFunnel>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFirstBookingFunnelQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof firstBookingFunnel>>> = ({ signal }) => firstBookingFunnel({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof firstBookingFunnel>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FirstBookingFunnelQueryResult = NonNullable<Awaited<ReturnType<typeof firstBookingFunnel>>>
export type FirstBookingFunnelQueryError = ProblemDetail


export function useFirstBookingFunnel<TData = Awaited<ReturnType<typeof firstBookingFunnel>>, TError = ProblemDetail>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof firstBookingFunnel>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof firstBookingFunnel>>,
          TError,
          Awaited<ReturnType<typeof firstBookingFunnel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFirstBookingFunnel<TData = Awaited<ReturnType<typeof firstBookingFunnel>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof firstBookingFunnel>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof firstBookingFunnel>>,
          TError,
          Awaited<ReturnType<typeof firstBookingFunnel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFirstBookingFunnel<TData = Awaited<ReturnType<typeof firstBookingFunnel>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof firstBookingFunnel>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useFirstBookingFunnel<TData = Awaited<ReturnType<typeof firstBookingFunnel>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof firstBookingFunnel>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFirstBookingFunnelQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getAuditUrl = (params?: AuditParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/ops/audit?${stringifiedParams}` : `/api/v1/ops/audit`
}

export const audit = async (params?: AuditParams, options?: RequestInit): Promise<PageDtoOperatorAuditEntryDto> => {

  return customInstance<PageDtoOperatorAuditEntryDto>(getAuditUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAuditQueryKey = (params?: AuditParams,) => {
    return [
    `/api/v1/ops/audit`, ...(params ? [params] : [])
    ] as const;
    }


export const getAuditQueryOptions = <TData = Awaited<ReturnType<typeof audit>>, TError = ProblemDetail>(params?: AuditParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof audit>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof audit>>> = ({ signal }) => audit(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof audit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditQueryResult = NonNullable<Awaited<ReturnType<typeof audit>>>
export type AuditQueryError = ProblemDetail


export function useAudit<TData = Awaited<ReturnType<typeof audit>>, TError = ProblemDetail>(
 params: undefined |  AuditParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof audit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof audit>>,
          TError,
          Awaited<ReturnType<typeof audit>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAudit<TData = Awaited<ReturnType<typeof audit>>, TError = ProblemDetail>(
 params?: AuditParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof audit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof audit>>,
          TError,
          Awaited<ReturnType<typeof audit>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAudit<TData = Awaited<ReturnType<typeof audit>>, TError = ProblemDetail>(
 params?: AuditParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof audit>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAudit<TData = Awaited<ReturnType<typeof audit>>, TError = ProblemDetail>(
 params?: AuditParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof audit>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGet12Url = (id: string,) => {




  return `/api/v1/notifications/${id}`
}

/**
 * @summary The delivery status of a single notification row
 */
export const get12 = async (id: string, options?: RequestInit): Promise<NotificationStatusResponse> => {

  return customInstance<NotificationStatusResponse>(getGet12Url(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGet12QueryKey = (id: string,) => {
    return [
    `/api/v1/notifications/${id}`
    ] as const;
    }


export const getGet12QueryOptions = <TData = Awaited<ReturnType<typeof get12>>, TError = ProblemDetail>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get12>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGet12QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get12>>> = ({ signal }) => get12(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get12>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Get12QueryResult = NonNullable<Awaited<ReturnType<typeof get12>>>
export type Get12QueryError = ProblemDetail


export function useGet12<TData = Awaited<ReturnType<typeof get12>>, TError = ProblemDetail>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get12>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get12>>,
          TError,
          Awaited<ReturnType<typeof get12>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet12<TData = Awaited<ReturnType<typeof get12>>, TError = ProblemDetail>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get12>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get12>>,
          TError,
          Awaited<ReturnType<typeof get12>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet12<TData = Awaited<ReturnType<typeof get12>>, TError = ProblemDetail>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get12>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The delivery status of a single notification row
 */

export function useGet12<TData = Awaited<ReturnType<typeof get12>>, TError = ProblemDetail>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get12>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGet12QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGet13Url = (venueId: string,) => {




  return `/api/v1/internal/entitlements/${venueId}`
}

/**
 * @summary Read a venue's derived flags + their single source (EN-1)
 */
export const get13 = async (venueId: string, options?: RequestInit): Promise<EntitlementViewResponse> => {

  return customInstance<EntitlementViewResponse>(getGet13Url(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGet13QueryKey = (venueId: string,) => {
    return [
    `/api/v1/internal/entitlements/${venueId}`
    ] as const;
    }


export const getGet13QueryOptions = <TData = Awaited<ReturnType<typeof get13>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get13>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGet13QueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get13>>> = ({ signal }) => get13(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get13>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Get13QueryResult = NonNullable<Awaited<ReturnType<typeof get13>>>
export type Get13QueryError = ProblemDetail


export function useGet13<TData = Awaited<ReturnType<typeof get13>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get13>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get13>>,
          TError,
          Awaited<ReturnType<typeof get13>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet13<TData = Awaited<ReturnType<typeof get13>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get13>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get13>>,
          TError,
          Awaited<ReturnType<typeof get13>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet13<TData = Awaited<ReturnType<typeof get13>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get13>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read a venue's derived flags + their single source (EN-1)
 */

export function useGet13<TData = Awaited<ReturnType<typeof get13>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get13>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGet13QueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetHealthUrl = () => {




  return `/api/v1/health`
}

/**
 * @summary Liveness/readiness probe with the running version
 */
export const getHealth = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customInstance<HealthStatus>(getGetHealthUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHealthQueryKey = () => {
    return [
    `/api/v1/health`
    ] as const;
    }


export const getGetHealthQueryOptions = <TData = Awaited<ReturnType<typeof getHealth>>, TError = ProblemDetail>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHealthQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHealth>>> = ({ signal }) => getHealth({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getHealth>>>
export type GetHealthQueryError = ProblemDetail


export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = ProblemDetail>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHealth>>,
          TError,
          Awaited<ReturnType<typeof getHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHealth>>,
          TError,
          Awaited<ReturnType<typeof getHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Liveness/readiness probe with the running version
 */

export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHealthQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getStatus2Url = () => {




  return `/api/v1/google-business/status`
}

/**
 * @summary Connection status + the discovered GBP locations and their venue mapping
 */
export const status2 = async ( options?: RequestInit): Promise<ConnectionStatusResponse> => {

  return customInstance<ConnectionStatusResponse>(getStatus2Url(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStatus2QueryKey = () => {
    return [
    `/api/v1/google-business/status`
    ] as const;
    }


export const getStatus2QueryOptions = <TData = Awaited<ReturnType<typeof status2>>, TError = ProblemDetail>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStatus2QueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof status2>>> = ({ signal }) => status2({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof status2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Status2QueryResult = NonNullable<Awaited<ReturnType<typeof status2>>>
export type Status2QueryError = ProblemDetail


export function useStatus2<TData = Awaited<ReturnType<typeof status2>>, TError = ProblemDetail>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof status2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof status2>>,
          TError,
          Awaited<ReturnType<typeof status2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStatus2<TData = Awaited<ReturnType<typeof status2>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof status2>>,
          TError,
          Awaited<ReturnType<typeof status2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStatus2<TData = Awaited<ReturnType<typeof status2>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Connection status + the discovered GBP locations and their venue mapping
 */

export function useStatus2<TData = Awaited<ReturnType<typeof status2>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStatus2QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGoogleBusinessOauthCallbackUrl = (params?: GoogleBusinessOauthCallbackParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/google-business/oauth/callback?${stringifiedParams}` : `/api/v1/google-business/oauth/callback`
}

/**
 * @summary Google OAuth redirect target — exchanges the code, stores the connection, bounces to the app
 */
export const googleBusinessOauthCallback = async (params?: GoogleBusinessOauthCallbackParams, options?: RequestInit): Promise<void> => {

  return customInstance<void>(getGoogleBusinessOauthCallbackUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGoogleBusinessOauthCallbackQueryKey = (params?: GoogleBusinessOauthCallbackParams,) => {
    return [
    `/api/v1/google-business/oauth/callback`, ...(params ? [params] : [])
    ] as const;
    }


export const getGoogleBusinessOauthCallbackQueryOptions = <TData = Awaited<ReturnType<typeof googleBusinessOauthCallback>>, TError = ProblemDetail>(params?: GoogleBusinessOauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof googleBusinessOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGoogleBusinessOauthCallbackQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof googleBusinessOauthCallback>>> = ({ signal }) => googleBusinessOauthCallback(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof googleBusinessOauthCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GoogleBusinessOauthCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof googleBusinessOauthCallback>>>
export type GoogleBusinessOauthCallbackQueryError = ProblemDetail


export function useGoogleBusinessOauthCallback<TData = Awaited<ReturnType<typeof googleBusinessOauthCallback>>, TError = ProblemDetail>(
 params: undefined |  GoogleBusinessOauthCallbackParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof googleBusinessOauthCallback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof googleBusinessOauthCallback>>,
          TError,
          Awaited<ReturnType<typeof googleBusinessOauthCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGoogleBusinessOauthCallback<TData = Awaited<ReturnType<typeof googleBusinessOauthCallback>>, TError = ProblemDetail>(
 params?: GoogleBusinessOauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof googleBusinessOauthCallback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof googleBusinessOauthCallback>>,
          TError,
          Awaited<ReturnType<typeof googleBusinessOauthCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGoogleBusinessOauthCallback<TData = Awaited<ReturnType<typeof googleBusinessOauthCallback>>, TError = ProblemDetail>(
 params?: GoogleBusinessOauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof googleBusinessOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Google OAuth redirect target — exchanges the code, stores the connection, bounces to the app
 */

export function useGoogleBusinessOauthCallback<TData = Awaited<ReturnType<typeof googleBusinessOauthCallback>>, TError = ProblemDetail>(
 params?: GoogleBusinessOauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof googleBusinessOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGoogleBusinessOauthCallbackQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getReviewsUrl = (locationId: string,) => {




  return `/api/v1/google-business/locations/${locationId}/reviews`
}

/**
 * @summary List a mapped location's Google reviews (read-only). Reviews live on My Business v4
 */
export const reviews = async (locationId: string, options?: RequestInit): Promise<ReviewsResponse> => {

  return customInstance<ReviewsResponse>(getReviewsUrl(locationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReviewsQueryKey = (locationId: string,) => {
    return [
    `/api/v1/google-business/locations/${locationId}/reviews`
    ] as const;
    }


export const getReviewsQueryOptions = <TData = Awaited<ReturnType<typeof reviews>>, TError = ProblemDetail>(locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReviewsQueryKey(locationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reviews>>> = ({ signal }) => reviews(locationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reviews>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof reviews>>>
export type ReviewsQueryError = ProblemDetail


export function useReviews<TData = Awaited<ReturnType<typeof reviews>>, TError = ProblemDetail>(
 locationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviews>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reviews>>,
          TError,
          Awaited<ReturnType<typeof reviews>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReviews<TData = Awaited<ReturnType<typeof reviews>>, TError = ProblemDetail>(
 locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviews>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reviews>>,
          TError,
          Awaited<ReturnType<typeof reviews>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReviews<TData = Awaited<ReturnType<typeof reviews>>, TError = ProblemDetail>(
 locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a mapped location's Google reviews (read-only). Reviews live on My Business v4
 */

export function useReviews<TData = Awaited<ReturnType<typeof reviews>>, TError = ProblemDetail>(
 locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviews>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReviewsQueryOptions(locationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getRecommendationsUrl = (locationId: string,) => {




  return `/api/v1/google-business/locations/${locationId}/recommendations`
}

/**
 * @summary Computed suggestions for a location (profile completeness, unanswered reviews, rating)
 */
export const recommendations = async (locationId: string, options?: RequestInit): Promise<RecommendationResponse[]> => {

  return customInstance<RecommendationResponse[]>(getRecommendationsUrl(locationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRecommendationsQueryKey = (locationId: string,) => {
    return [
    `/api/v1/google-business/locations/${locationId}/recommendations`
    ] as const;
    }


export const getRecommendationsQueryOptions = <TData = Awaited<ReturnType<typeof recommendations>>, TError = ProblemDetail>(locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recommendations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecommendationsQueryKey(locationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recommendations>>> = ({ signal }) => recommendations(locationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recommendations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecommendationsQueryResult = NonNullable<Awaited<ReturnType<typeof recommendations>>>
export type RecommendationsQueryError = ProblemDetail


export function useRecommendations<TData = Awaited<ReturnType<typeof recommendations>>, TError = ProblemDetail>(
 locationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recommendations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recommendations>>,
          TError,
          Awaited<ReturnType<typeof recommendations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecommendations<TData = Awaited<ReturnType<typeof recommendations>>, TError = ProblemDetail>(
 locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recommendations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recommendations>>,
          TError,
          Awaited<ReturnType<typeof recommendations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecommendations<TData = Awaited<ReturnType<typeof recommendations>>, TError = ProblemDetail>(
 locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recommendations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Computed suggestions for a location (profile completeness, unanswered reviews, rating)
 */

export function useRecommendations<TData = Awaited<ReturnType<typeof recommendations>>, TError = ProblemDetail>(
 locationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recommendations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecommendationsQueryOptions(locationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getDownloadUrl = (key: string,) => {




  return `/api/v1/files/${key}`
}

/**
 * @summary Redirect to a short-lived presigned download URL
 */
export const download = async (key: string, options?: RequestInit): Promise<void> => {

  return customInstance<void>(getDownloadUrl(key),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadQueryKey = (key: string,) => {
    return [
    `/api/v1/files/${key}`
    ] as const;
    }


export const getDownloadQueryOptions = <TData = Awaited<ReturnType<typeof download>>, TError = ProblemDetail>(key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof download>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadQueryKey(key);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof download>>> = ({ signal }) => download(key, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: key !== null && key !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof download>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadQueryResult = NonNullable<Awaited<ReturnType<typeof download>>>
export type DownloadQueryError = ProblemDetail


export function useDownload<TData = Awaited<ReturnType<typeof download>>, TError = ProblemDetail>(
 key: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof download>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof download>>,
          TError,
          Awaited<ReturnType<typeof download>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownload<TData = Awaited<ReturnType<typeof download>>, TError = ProblemDetail>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof download>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof download>>,
          TError,
          Awaited<ReturnType<typeof download>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownload<TData = Awaited<ReturnType<typeof download>>, TError = ProblemDetail>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof download>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Redirect to a short-lived presigned download URL
 */

export function useDownload<TData = Awaited<ReturnType<typeof download>>, TError = ProblemDetail>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof download>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadQueryOptions(key,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSubscriptionUrl = (venueId: string,) => {




  return `/api/v1/billing/venues/${venueId}/subscription`
}

/**
 * @summary The venue's current subscription state
 */
export const subscription = async (venueId: string, options?: RequestInit): Promise<SubscriptionResponse> => {

  return customInstance<SubscriptionResponse>(getSubscriptionUrl(venueId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSubscriptionQueryKey = (venueId: string,) => {
    return [
    `/api/v1/billing/venues/${venueId}/subscription`
    ] as const;
    }


export const getSubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof subscription>>, TError = ProblemDetail>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof subscription>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSubscriptionQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof subscription>>> = ({ signal }) => subscription(venueId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof subscription>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof subscription>>>
export type SubscriptionQueryError = ProblemDetail


export function useSubscription<TData = Awaited<ReturnType<typeof subscription>>, TError = ProblemDetail>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof subscription>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof subscription>>,
          TError,
          Awaited<ReturnType<typeof subscription>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSubscription<TData = Awaited<ReturnType<typeof subscription>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof subscription>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof subscription>>,
          TError,
          Awaited<ReturnType<typeof subscription>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSubscription<TData = Awaited<ReturnType<typeof subscription>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof subscription>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The venue's current subscription state
 */

export function useSubscription<TData = Awaited<ReturnType<typeof subscription>>, TError = ProblemDetail>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof subscription>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSubscriptionQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getPlansUrl = () => {




  return `/api/v1/billing/plans`
}

/**
 * @summary The platform plan + add-on catalog (prices, limits, included flags)
 */
export const plans = async ( options?: RequestInit): Promise<PlanCatalogResponse> => {

  return customInstance<PlanCatalogResponse>(getPlansUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlansQueryKey = () => {
    return [
    `/api/v1/billing/plans`
    ] as const;
    }


export const getPlansQueryOptions = <TData = Awaited<ReturnType<typeof plans>>, TError = ProblemDetail>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof plans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlansQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof plans>>> = ({ signal }) => plans({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof plans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlansQueryResult = NonNullable<Awaited<ReturnType<typeof plans>>>
export type PlansQueryError = ProblemDetail


export function usePlans<TData = Awaited<ReturnType<typeof plans>>, TError = ProblemDetail>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof plans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof plans>>,
          TError,
          Awaited<ReturnType<typeof plans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlans<TData = Awaited<ReturnType<typeof plans>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof plans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof plans>>,
          TError,
          Awaited<ReturnType<typeof plans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlans<TData = Awaited<ReturnType<typeof plans>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof plans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The platform plan + add-on catalog (prices, limits, included flags)
 */

export function usePlans<TData = Awaited<ReturnType<typeof plans>>, TError = ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof plans>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlansQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getComparisonUrl = (params: ComparisonParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/analytics/venues?${stringifiedParams}` : `/api/v1/analytics/venues`
}

/**
 * @summary Compare every venue in scope side by side (cursor pagination; collapses at scope 1 — R1)
 */
export const comparison = async (params: ComparisonParams, options?: RequestInit): Promise<AnalyticsComparisonResponse> => {

  return customInstance<AnalyticsComparisonResponse>(getComparisonUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getComparisonQueryKey = (params?: ComparisonParams,) => {
    return [
    `/api/v1/analytics/venues`, ...(params ? [params] : [])
    ] as const;
    }


export const getComparisonQueryOptions = <TData = Awaited<ReturnType<typeof comparison>>, TError = ProblemDetail>(params: ComparisonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof comparison>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getComparisonQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof comparison>>> = ({ signal }) => comparison(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof comparison>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ComparisonQueryResult = NonNullable<Awaited<ReturnType<typeof comparison>>>
export type ComparisonQueryError = ProblemDetail


export function useComparison<TData = Awaited<ReturnType<typeof comparison>>, TError = ProblemDetail>(
 params: ComparisonParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof comparison>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof comparison>>,
          TError,
          Awaited<ReturnType<typeof comparison>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useComparison<TData = Awaited<ReturnType<typeof comparison>>, TError = ProblemDetail>(
 params: ComparisonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof comparison>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof comparison>>,
          TError,
          Awaited<ReturnType<typeof comparison>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useComparison<TData = Awaited<ReturnType<typeof comparison>>, TError = ProblemDetail>(
 params: ComparisonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof comparison>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Compare every venue in scope side by side (cursor pagination; collapses at scope 1 — R1)
 */

export function useComparison<TData = Awaited<ReturnType<typeof comparison>>, TError = ProblemDetail>(
 params: ComparisonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof comparison>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getComparisonQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getDetailUrl = (venueId: string,
    params: DetailParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/analytics/venues/${venueId}?${stringifiedParams}` : `/api/v1/analytics/venues/${venueId}`
}

/**
 * @summary Drill down to one venue — identical numbers + its trend series (404 when out of scope)
 */
export const detail = async (venueId: string,
    params: DetailParams, options?: RequestInit): Promise<VenueDetailResponse> => {

  return customInstance<VenueDetailResponse>(getDetailUrl(venueId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDetailQueryKey = (venueId: string,
    params?: DetailParams,) => {
    return [
    `/api/v1/analytics/venues/${venueId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getDetailQueryOptions = <TData = Awaited<ReturnType<typeof detail>>, TError = ProblemDetail>(venueId: string,
    params: DetailParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof detail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDetailQueryKey(venueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof detail>>> = ({ signal }) => detail(venueId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof detail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DetailQueryResult = NonNullable<Awaited<ReturnType<typeof detail>>>
export type DetailQueryError = ProblemDetail


export function useDetail<TData = Awaited<ReturnType<typeof detail>>, TError = ProblemDetail>(
 venueId: string,
    params: DetailParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof detail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof detail>>,
          TError,
          Awaited<ReturnType<typeof detail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDetail<TData = Awaited<ReturnType<typeof detail>>, TError = ProblemDetail>(
 venueId: string,
    params: DetailParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof detail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof detail>>,
          TError,
          Awaited<ReturnType<typeof detail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDetail<TData = Awaited<ReturnType<typeof detail>>, TError = ProblemDetail>(
 venueId: string,
    params: DetailParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof detail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Drill down to one venue — identical numbers + its trend series (404 when out of scope)
 */

export function useDetail<TData = Awaited<ReturnType<typeof detail>>, TError = ProblemDetail>(
 venueId: string,
    params: DetailParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof detail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDetailQueryOptions(venueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getTrendsUrl = (params: TrendsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/analytics/trends?${stringifiedParams}` : `/api/v1/analytics/trends`
}

/**
 * @summary Per-metric trend lines comparing every venue in scope (cursor pagination)
 */
export const trends = async (params: TrendsParams, options?: RequestInit): Promise<AnalyticsTrendResponse> => {

  return customInstance<AnalyticsTrendResponse>(getTrendsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTrendsQueryKey = (params?: TrendsParams,) => {
    return [
    `/api/v1/analytics/trends`, ...(params ? [params] : [])
    ] as const;
    }


export const getTrendsQueryOptions = <TData = Awaited<ReturnType<typeof trends>>, TError = ProblemDetail>(params: TrendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof trends>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTrendsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof trends>>> = ({ signal }) => trends(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof trends>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TrendsQueryResult = NonNullable<Awaited<ReturnType<typeof trends>>>
export type TrendsQueryError = ProblemDetail


export function useTrends<TData = Awaited<ReturnType<typeof trends>>, TError = ProblemDetail>(
 params: TrendsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof trends>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trends>>,
          TError,
          Awaited<ReturnType<typeof trends>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTrends<TData = Awaited<ReturnType<typeof trends>>, TError = ProblemDetail>(
 params: TrendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof trends>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trends>>,
          TError,
          Awaited<ReturnType<typeof trends>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTrends<TData = Awaited<ReturnType<typeof trends>>, TError = ProblemDetail>(
 params: TrendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof trends>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Per-metric trend lines comparing every venue in scope (cursor pagination)
 */

export function useTrends<TData = Awaited<ReturnType<typeof trends>>, TError = ProblemDetail>(
 params: TrendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof trends>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTrendsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getPlaceDetailsUrl = (id: string,) => {




  return `/api/v1/address/place/${id}`
}

/**
 * @summary Re-verify a captured Google place_id (staleness refresh)
 */
export const placeDetails = async (id: string, options?: RequestInit): Promise<PlaceVerificationResponse> => {

  return customInstance<PlaceVerificationResponse>(getPlaceDetailsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPlaceDetailsQueryKey = (id: string,) => {
    return [
    `/api/v1/address/place/${id}`
    ] as const;
    }


export const getPlaceDetailsQueryOptions = <TData = Awaited<ReturnType<typeof placeDetails>>, TError = ProblemDetail>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof placeDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlaceDetailsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof placeDetails>>> = ({ signal }) => placeDetails(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof placeDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlaceDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof placeDetails>>>
export type PlaceDetailsQueryError = ProblemDetail


export function usePlaceDetails<TData = Awaited<ReturnType<typeof placeDetails>>, TError = ProblemDetail>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof placeDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof placeDetails>>,
          TError,
          Awaited<ReturnType<typeof placeDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlaceDetails<TData = Awaited<ReturnType<typeof placeDetails>>, TError = ProblemDetail>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof placeDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof placeDetails>>,
          TError,
          Awaited<ReturnType<typeof placeDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlaceDetails<TData = Awaited<ReturnType<typeof placeDetails>>, TError = ProblemDetail>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof placeDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Re-verify a captured Google place_id (staleness refresh)
 */

export function usePlaceDetails<TData = Awaited<ReturnType<typeof placeDetails>>, TError = ProblemDetail>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof placeDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlaceDetailsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getAutocompleteUrl = (params: AutocompleteParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/address/autocomplete?${stringifiedParams}` : `/api/v1/address/autocomplete`
}

/**
 * @summary France-first address autocomplete (BAN); degraded provider → manual mode
 */
export const autocomplete = async (params: AutocompleteParams, options?: RequestInit): Promise<AutocompleteResponse> => {

  return customInstance<AutocompleteResponse>(getAutocompleteUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAutocompleteQueryKey = (params?: AutocompleteParams,) => {
    return [
    `/api/v1/address/autocomplete`, ...(params ? [params] : [])
    ] as const;
    }


export const getAutocompleteQueryOptions = <TData = Awaited<ReturnType<typeof autocomplete>>, TError = ProblemDetail>(params: AutocompleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocomplete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAutocompleteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof autocomplete>>> = ({ signal }) => autocomplete(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof autocomplete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AutocompleteQueryResult = NonNullable<Awaited<ReturnType<typeof autocomplete>>>
export type AutocompleteQueryError = ProblemDetail


export function useAutocomplete<TData = Awaited<ReturnType<typeof autocomplete>>, TError = ProblemDetail>(
 params: AutocompleteParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocomplete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof autocomplete>>,
          TError,
          Awaited<ReturnType<typeof autocomplete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAutocomplete<TData = Awaited<ReturnType<typeof autocomplete>>, TError = ProblemDetail>(
 params: AutocompleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocomplete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof autocomplete>>,
          TError,
          Awaited<ReturnType<typeof autocomplete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAutocomplete<TData = Awaited<ReturnType<typeof autocomplete>>, TError = ProblemDetail>(
 params: AutocompleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocomplete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary France-first address autocomplete (BAN); degraded provider → manual mode
 */

export function useAutocomplete<TData = Awaited<ReturnType<typeof autocomplete>>, TError = ProblemDetail>(
 params: AutocompleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocomplete>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAutocompleteQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getViewUrl = (venueId: string,
    token: string,) => {




  return `/api/public/v1/venues/${venueId}/waitlist/status/${token}`
}

/**
 * @summary View a waitlist entry's own live status by its HMAC link — position/estimate/state, no PII (R5)
 */
export const view = async (venueId: string,
    token: string, options?: RequestInit): Promise<WaitlistStatusResponse> => {

  return customInstance<WaitlistStatusResponse>(getViewUrl(venueId,token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getViewQueryKey = (venueId: string,
    token: string,) => {
    return [
    `/api/public/v1/venues/${venueId}/waitlist/status/${token}`
    ] as const;
    }


export const getViewQueryOptions = <TData = Awaited<ReturnType<typeof view>>, TError = ProblemDetail>(venueId: string,
    token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof view>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getViewQueryKey(venueId,token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof view>>> = ({ signal }) => view(venueId,token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined && token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof view>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ViewQueryResult = NonNullable<Awaited<ReturnType<typeof view>>>
export type ViewQueryError = ProblemDetail


export function useView<TData = Awaited<ReturnType<typeof view>>, TError = ProblemDetail>(
 venueId: string,
    token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof view>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof view>>,
          TError,
          Awaited<ReturnType<typeof view>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useView<TData = Awaited<ReturnType<typeof view>>, TError = ProblemDetail>(
 venueId: string,
    token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof view>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof view>>,
          TError,
          Awaited<ReturnType<typeof view>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useView<TData = Awaited<ReturnType<typeof view>>, TError = ProblemDetail>(
 venueId: string,
    token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof view>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary View a waitlist entry's own live status by its HMAC link — position/estimate/state, no PII (R5)
 */

export function useView<TData = Awaited<ReturnType<typeof view>>, TError = ProblemDetail>(
 venueId: string,
    token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof view>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getViewQueryOptions(venueId,token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getEstimateUrl = (venueId: string,
    params: EstimateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/public/v1/venues/${venueId}/waitlist/estimate?${stringifiedParams}` : `/api/public/v1/venues/${venueId}/waitlist/estimate`
}

/**
 * @summary Pre-join advisory wait estimate for a party size (R1) — never blocks or gates the join.
 */
export const estimate = async (venueId: string,
    params: EstimateParams, options?: RequestInit): Promise<WaitEstimateResponse> => {

  return customInstance<WaitEstimateResponse>(getEstimateUrl(venueId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getEstimateQueryKey = (venueId: string,
    params?: EstimateParams,) => {
    return [
    `/api/public/v1/venues/${venueId}/waitlist/estimate`, ...(params ? [params] : [])
    ] as const;
    }


export const getEstimateQueryOptions = <TData = Awaited<ReturnType<typeof estimate>>, TError = ProblemDetail>(venueId: string,
    params: EstimateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof estimate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEstimateQueryKey(venueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof estimate>>> = ({ signal }) => estimate(venueId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof estimate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EstimateQueryResult = NonNullable<Awaited<ReturnType<typeof estimate>>>
export type EstimateQueryError = ProblemDetail


export function useEstimate<TData = Awaited<ReturnType<typeof estimate>>, TError = ProblemDetail>(
 venueId: string,
    params: EstimateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof estimate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof estimate>>,
          TError,
          Awaited<ReturnType<typeof estimate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEstimate<TData = Awaited<ReturnType<typeof estimate>>, TError = ProblemDetail>(
 venueId: string,
    params: EstimateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof estimate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof estimate>>,
          TError,
          Awaited<ReturnType<typeof estimate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEstimate<TData = Awaited<ReturnType<typeof estimate>>, TError = ProblemDetail>(
 venueId: string,
    params: EstimateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof estimate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Pre-join advisory wait estimate for a party size (R1) — never blocks or gates the join.
 */

export function useEstimate<TData = Awaited<ReturnType<typeof estimate>>, TError = ProblemDetail>(
 venueId: string,
    params: EstimateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof estimate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEstimateQueryOptions(venueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getView1Url = (venueId: string,
    token: string,) => {




  return `/api/public/v1/venues/${venueId}/manage/${token}`
}

/**
 * @summary View a booking by its manage token — facts + cutoff verdict, no contact PII (BK-12)
 */
export const view1 = async (venueId: string,
    token: string, options?: RequestInit): Promise<ManageBookingResponse> => {

  return customInstance<ManageBookingResponse>(getView1Url(venueId,token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getView1QueryKey = (venueId: string,
    token: string,) => {
    return [
    `/api/public/v1/venues/${venueId}/manage/${token}`
    ] as const;
    }


export const getView1QueryOptions = <TData = Awaited<ReturnType<typeof view1>>, TError = ProblemDetail>(venueId: string,
    token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof view1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getView1QueryKey(venueId,token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof view1>>> = ({ signal }) => view1(venueId,token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined && token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof view1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type View1QueryResult = NonNullable<Awaited<ReturnType<typeof view1>>>
export type View1QueryError = ProblemDetail


export function useView1<TData = Awaited<ReturnType<typeof view1>>, TError = ProblemDetail>(
 venueId: string,
    token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof view1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof view1>>,
          TError,
          Awaited<ReturnType<typeof view1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useView1<TData = Awaited<ReturnType<typeof view1>>, TError = ProblemDetail>(
 venueId: string,
    token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof view1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof view1>>,
          TError,
          Awaited<ReturnType<typeof view1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useView1<TData = Awaited<ReturnType<typeof view1>>, TError = ProblemDetail>(
 venueId: string,
    token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof view1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary View a booking by its manage token — facts + cutoff verdict, no contact PII (BK-12)
 */

export function useView1<TData = Awaited<ReturnType<typeof view1>>, TError = ProblemDetail>(
 venueId: string,
    token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof view1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getView1QueryOptions(venueId,token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGroupAvailabilityUrl = (venueId: string,
    params: GroupAvailabilityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/public/v1/venues/${venueId}/group-availability?${stringifiedParams}` : `/api/public/v1/venues/${venueId}/group-availability`
}

/**
 * @summary Cross-venue overflow proposal across the tenant's sibling venues (R6)
 */
export const groupAvailability = async (venueId: string,
    params: GroupAvailabilityParams, options?: RequestInit): Promise<GroupAvailabilityResponse> => {

  return customInstance<GroupAvailabilityResponse>(getGroupAvailabilityUrl(venueId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGroupAvailabilityQueryKey = (venueId: string,
    params?: GroupAvailabilityParams,) => {
    return [
    `/api/public/v1/venues/${venueId}/group-availability`, ...(params ? [params] : [])
    ] as const;
    }


export const getGroupAvailabilityQueryOptions = <TData = Awaited<ReturnType<typeof groupAvailability>>, TError = ProblemDetail>(venueId: string,
    params: GroupAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupAvailability>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGroupAvailabilityQueryKey(venueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof groupAvailability>>> = ({ signal }) => groupAvailability(venueId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof groupAvailability>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GroupAvailabilityQueryResult = NonNullable<Awaited<ReturnType<typeof groupAvailability>>>
export type GroupAvailabilityQueryError = ProblemDetail


export function useGroupAvailability<TData = Awaited<ReturnType<typeof groupAvailability>>, TError = ProblemDetail>(
 venueId: string,
    params: GroupAvailabilityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupAvailability>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof groupAvailability>>,
          TError,
          Awaited<ReturnType<typeof groupAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGroupAvailability<TData = Awaited<ReturnType<typeof groupAvailability>>, TError = ProblemDetail>(
 venueId: string,
    params: GroupAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupAvailability>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof groupAvailability>>,
          TError,
          Awaited<ReturnType<typeof groupAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGroupAvailability<TData = Awaited<ReturnType<typeof groupAvailability>>, TError = ProblemDetail>(
 venueId: string,
    params: GroupAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupAvailability>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Cross-venue overflow proposal across the tenant's sibling venues (R6)
 */

export function useGroupAvailability<TData = Awaited<ReturnType<typeof groupAvailability>>, TError = ProblemDetail>(
 venueId: string,
    params: GroupAvailabilityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof groupAvailability>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGroupAvailabilityQueryOptions(venueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getByManageTokenUrl = (venueId: string,
    manageToken: string,) => {




  return `/api/public/v1/venues/${venueId}/bookings/${manageToken}`
}

/**
 * @summary Fetch a booking by its no-login manage token (BK-12)
 */
export const byManageToken = async (venueId: string,
    manageToken: string, options?: RequestInit): Promise<BookingDetailResponse> => {

  return customInstance<BookingDetailResponse>(getByManageTokenUrl(venueId,manageToken),
  {
    ...options,
    method: 'GET'


  }
);}





export const getByManageTokenQueryKey = (venueId: string,
    manageToken: string,) => {
    return [
    `/api/public/v1/venues/${venueId}/bookings/${manageToken}`
    ] as const;
    }


export const getByManageTokenQueryOptions = <TData = Awaited<ReturnType<typeof byManageToken>>, TError = ProblemDetail>(venueId: string,
    manageToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof byManageToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getByManageTokenQueryKey(venueId,manageToken);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof byManageToken>>> = ({ signal }) => byManageToken(venueId,manageToken, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined && manageToken !== null && manageToken !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof byManageToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ByManageTokenQueryResult = NonNullable<Awaited<ReturnType<typeof byManageToken>>>
export type ByManageTokenQueryError = ProblemDetail


export function useByManageToken<TData = Awaited<ReturnType<typeof byManageToken>>, TError = ProblemDetail>(
 venueId: string,
    manageToken: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof byManageToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof byManageToken>>,
          TError,
          Awaited<ReturnType<typeof byManageToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useByManageToken<TData = Awaited<ReturnType<typeof byManageToken>>, TError = ProblemDetail>(
 venueId: string,
    manageToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof byManageToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof byManageToken>>,
          TError,
          Awaited<ReturnType<typeof byManageToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useByManageToken<TData = Awaited<ReturnType<typeof byManageToken>>, TError = ProblemDetail>(
 venueId: string,
    manageToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof byManageToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch a booking by its no-login manage token (BK-12)
 */

export function useByManageToken<TData = Awaited<ReturnType<typeof byManageToken>>, TError = ProblemDetail>(
 venueId: string,
    manageToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof byManageToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getByManageTokenQueryOptions(venueId,manageToken,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getOpenSlots1Url = (venueId: string,
    params: OpenSlots1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/public/v1/venues/${venueId}/availability?${stringifiedParams}` : `/api/public/v1/venues/${venueId}/availability`
}

/**
 * @summary Open slots for a service day and party (capacity-only, M2)
 */
export const openSlots1 = async (venueId: string,
    params: OpenSlots1Params, options?: RequestInit): Promise<PublicOpenSlotsResponse> => {

  return customInstance<PublicOpenSlotsResponse>(getOpenSlots1Url(venueId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getOpenSlots1QueryKey = (venueId: string,
    params?: OpenSlots1Params,) => {
    return [
    `/api/public/v1/venues/${venueId}/availability`, ...(params ? [params] : [])
    ] as const;
    }


export const getOpenSlots1QueryOptions = <TData = Awaited<ReturnType<typeof openSlots1>>, TError = ProblemDetail>(venueId: string,
    params: OpenSlots1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openSlots1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOpenSlots1QueryKey(venueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof openSlots1>>> = ({ signal }) => openSlots1(venueId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof openSlots1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OpenSlots1QueryResult = NonNullable<Awaited<ReturnType<typeof openSlots1>>>
export type OpenSlots1QueryError = ProblemDetail


export function useOpenSlots1<TData = Awaited<ReturnType<typeof openSlots1>>, TError = ProblemDetail>(
 venueId: string,
    params: OpenSlots1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof openSlots1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof openSlots1>>,
          TError,
          Awaited<ReturnType<typeof openSlots1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenSlots1<TData = Awaited<ReturnType<typeof openSlots1>>, TError = ProblemDetail>(
 venueId: string,
    params: OpenSlots1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openSlots1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof openSlots1>>,
          TError,
          Awaited<ReturnType<typeof openSlots1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOpenSlots1<TData = Awaited<ReturnType<typeof openSlots1>>, TError = ProblemDetail>(
 venueId: string,
    params: OpenSlots1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openSlots1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Open slots for a service day and party (capacity-only, M2)
 */

export function useOpenSlots1<TData = Awaited<ReturnType<typeof openSlots1>>, TError = ProblemDetail>(
 venueId: string,
    params: OpenSlots1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof openSlots1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOpenSlots1QueryOptions(venueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getAlternatives1Url = (venueId: string,
    params: Alternatives1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/public/v1/venues/${venueId}/availability/alternatives?${stringifiedParams}` : `/api/public/v1/venues/${venueId}/availability/alternatives`
}

/**
 * @summary Nearby open slots when the requested time is gone — each re-checked live (AV-6)
 */
export const alternatives1 = async (venueId: string,
    params: Alternatives1Params, options?: RequestInit): Promise<PublicAlternativeDto[]> => {

  return customInstance<PublicAlternativeDto[]>(getAlternatives1Url(venueId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAlternatives1QueryKey = (venueId: string,
    params?: Alternatives1Params,) => {
    return [
    `/api/public/v1/venues/${venueId}/availability/alternatives`, ...(params ? [params] : [])
    ] as const;
    }


export const getAlternatives1QueryOptions = <TData = Awaited<ReturnType<typeof alternatives1>>, TError = ProblemDetail>(venueId: string,
    params: Alternatives1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alternatives1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAlternatives1QueryKey(venueId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof alternatives1>>> = ({ signal }) => alternatives1(venueId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof alternatives1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Alternatives1QueryResult = NonNullable<Awaited<ReturnType<typeof alternatives1>>>
export type Alternatives1QueryError = ProblemDetail


export function useAlternatives1<TData = Awaited<ReturnType<typeof alternatives1>>, TError = ProblemDetail>(
 venueId: string,
    params: Alternatives1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof alternatives1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof alternatives1>>,
          TError,
          Awaited<ReturnType<typeof alternatives1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAlternatives1<TData = Awaited<ReturnType<typeof alternatives1>>, TError = ProblemDetail>(
 venueId: string,
    params: Alternatives1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alternatives1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof alternatives1>>,
          TError,
          Awaited<ReturnType<typeof alternatives1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAlternatives1<TData = Awaited<ReturnType<typeof alternatives1>>, TError = ProblemDetail>(
 venueId: string,
    params: Alternatives1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alternatives1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Nearby open slots when the requested time is gone — each re-checked live (AV-6)
 */

export function useAlternatives1<TData = Awaited<ReturnType<typeof alternatives1>>, TError = ProblemDetail>(
 venueId: string,
    params: Alternatives1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof alternatives1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAlternatives1QueryOptions(venueId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getBookingConfigUrl = (slug: string,) => {




  return `/api/public/v1/venues/by-slug/${slug}/booking-config`
}

/**
 * @summary Resolve a venue's public booking config by slug (P1)
 */
export const bookingConfig = async (slug: string, options?: RequestInit): Promise<VenueConfigResponse> => {

  return customInstance<VenueConfigResponse>(getBookingConfigUrl(slug),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBookingConfigQueryKey = (slug: string,) => {
    return [
    `/api/public/v1/venues/by-slug/${slug}/booking-config`
    ] as const;
    }


export const getBookingConfigQueryOptions = <TData = Awaited<ReturnType<typeof bookingConfig>>, TError = ProblemDetail>(slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bookingConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBookingConfigQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof bookingConfig>>> = ({ signal }) => bookingConfig(slug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof bookingConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BookingConfigQueryResult = NonNullable<Awaited<ReturnType<typeof bookingConfig>>>
export type BookingConfigQueryError = ProblemDetail


export function useBookingConfig<TData = Awaited<ReturnType<typeof bookingConfig>>, TError = ProblemDetail>(
 slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof bookingConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof bookingConfig>>,
          TError,
          Awaited<ReturnType<typeof bookingConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBookingConfig<TData = Awaited<ReturnType<typeof bookingConfig>>, TError = ProblemDetail>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bookingConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof bookingConfig>>,
          TError,
          Awaited<ReturnType<typeof bookingConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBookingConfig<TData = Awaited<ReturnType<typeof bookingConfig>>, TError = ProblemDetail>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bookingConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resolve a venue's public booking config by slug (P1)
 */

export function useBookingConfig<TData = Awaited<ReturnType<typeof bookingConfig>>, TError = ProblemDetail>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bookingConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBookingConfigQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getClearOverrideUrl = (venueId: string,
    flag: string,) => {




  return `/api/v1/ops/venues/${venueId}/entitlements/override/${flag}`
}

export const clearOverride = async (venueId: string,
    flag: string, options?: RequestInit): Promise<EntitlementViewDto> => {

  return customInstance<EntitlementViewDto>(getClearOverrideUrl(venueId,flag),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getClearOverrideMutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearOverride>>, TError,{venueId: string;flag: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof clearOverride>>, TError,{venueId: string;flag: string}, TContext> => {

const mutationKey = ['clearOverride'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearOverride>>, {venueId: string;flag: string}> = (props) => {
          const {venueId,flag} = props ?? {};

          return  clearOverride(venueId,flag,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof clearOverride>>>

    export type ClearOverrideMutationError = ProblemDetail

    export const useClearOverride = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearOverride>>, TError,{venueId: string;flag: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearOverride>>,
        TError,
        {venueId: string;flag: string},
        TContext
      > => {
      return useMutation(getClearOverrideMutationOptions(options), queryClient);
    }

export const getClearOverride1Url = (venueId: string,
    flag: string,) => {




  return `/api/v1/internal/entitlements/${venueId}/override/${flag}`
}

/**
 * @summary Clear a flag's override, reverting to its trial/plan source (then recompute)
 */
export const clearOverride1 = async (venueId: string,
    flag: string, options?: RequestInit): Promise<EntitlementViewResponse> => {

  return customInstance<EntitlementViewResponse>(getClearOverride1Url(venueId,flag),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getClearOverride1MutationOptions = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearOverride1>>, TError,{venueId: string;flag: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof clearOverride1>>, TError,{venueId: string;flag: string}, TContext> => {

const mutationKey = ['clearOverride1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearOverride1>>, {venueId: string;flag: string}> = (props) => {
          const {venueId,flag} = props ?? {};

          return  clearOverride1(venueId,flag,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearOverride1MutationResult = NonNullable<Awaited<ReturnType<typeof clearOverride1>>>

    export type ClearOverride1MutationError = ProblemDetail

    /**
 * @summary Clear a flag's override, reverting to its trial/plan source (then recompute)
 */
export const useClearOverride1 = <TError = ProblemDetail,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearOverride1>>, TError,{venueId: string;flag: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearOverride1>>,
        TError,
        {venueId: string;flag: string},
        TContext
      > => {
      return useMutation(getClearOverride1MutationOptions(options), queryClient);
    }
